var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/alert/NxAlert.tsx
import React4 from "react";

// src/alert/NxAlertBase.tsx
import React3, { useState } from "react";
import {
  Box,
  capitalize,
  Grow,
  useMediaQuery,
  useTheme as useTheme2
} from "@material-ui/core";
import clsx2 from "clsx";
import "@playvs-inc/nexus-theme";
import { Close } from "@playvs-inc/nexus-icons";

// src/typography/NxTypography.tsx
import React from "react";
import {
  makeStyles,
  Typography as MuiTypography,
  useTheme
} from "@material-ui/core";
import { clsx } from "clsx";
import {
  baseThemeTypography
} from "@playvs-inc/nexus-theme";
var useStyles = makeStyles((theme) => ({
  baseStyles: ({
    colorToken,
    showDefault,
    variant
  }) => __spreadValues({
    color: colorToken != null ? colorToken : showDefault ? theme.palette.ColorTextBase : void 0
  }, variant && __spreadValues({}, baseThemeTypography(theme)[variant]))
}));
function NxTypography(_a) {
  var _b = _a, {
    variant,
    style: propStyle = {},
    colorToken,
    color,
    className
  } = _b, restProps = __objRest(_b, [
    "variant",
    "style",
    "colorToken",
    "color",
    "className"
  ]);
  const theme = useTheme();
  const colorStyleValue = colorToken ? theme.palette[colorToken] : void 0;
  const showDefaultColorStyleValue = !color && !colorStyleValue;
  const { baseStyles } = useStyles({
    colorToken: colorStyleValue,
    showDefault: showDefaultColorStyleValue,
    variant
  });
  return /* @__PURE__ */ React.createElement(MuiTypography, __spreadValues({
    className: clsx(className, baseStyles),
    color,
    style: __spreadValues({}, propStyle),
    variant: void 0
  }, restProps));
}

// src/alert/NxAlert.styles.tsx
import { makeStyles as makeStyles2 } from "@material-ui/core";
import { colors } from "@playvs-inc/nexus-core";
var useBaseStyles = makeStyles2((theme) => ({
  error: {
    backgroundColor: colors.RedError[4]
  },
  info: {
    backgroundColor: colors.BlueInfo[4]
  },
  success: {
    backgroundColor: colors.GreenSuccess[4]
  },
  warn: {
    backgroundColor: colors.YellowWarn[4]
  },
  container: {
    maxWidth: "1042px",
    borderRadius: theme.mixins.cornerRadius["border-radius-10"],
    boxShadow: theme.mixins.boxShadow.elevation2
  },
  variantBorder: {
    borderRadius: `${theme.mixins.cornerRadius["border-radius-10"]} ${theme.mixins.cornerRadius["border-radius-10"]} 0 0`,
    height: "6px"
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "row",
    padding: theme.spacing(3),
    gridGap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gridGap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0
    }
  },
  avatarCloseButtonWrapper: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block"
    }
  },
  closeButton: {
    "&:hover": {
      cursor: "pointer"
    }
  },
  closeButtonWrapper: {
    display: "block",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  }
}));

// src/alert/NxAlert.helpers.tsx
import React2 from "react";
import {
  SuccessOutlined,
  ErrorOutlined,
  InfoOutlined,
  WarningOutlined
} from "@playvs-inc/nexus-icons";
function getIconFromVariant(variant, theme) {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ React2.createElement(SuccessOutlined, {
        color: theme.palette.ColorIconSuccess
      });
    case "error":
      return /* @__PURE__ */ React2.createElement(ErrorOutlined, {
        color: theme.palette.ColorIconError
      });
    case "warn":
      return /* @__PURE__ */ React2.createElement(WarningOutlined, {
        color: theme.palette.ColorIconWarn
      });
    case "info":
    default:
      return /* @__PURE__ */ React2.createElement(InfoOutlined, {
        color: theme.palette.ColorIconInfo
      });
  }
}

// src/alert/NxAlertBase.tsx
function NxAlertBase({
  className,
  title,
  content,
  icon,
  variant,
  tinted,
  canClose = false,
  actions
}) {
  const theme = useTheme2();
  const [isClosed, setIsClosed] = useState(false);
  const classes = useBaseStyles({ tinted, variant });
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const showTitleIcon = !icon;
  const onClose = () => {
    setIsClosed(!isClosed);
  };
  const closeButton = canClose && /* @__PURE__ */ React3.createElement(Close, {
    className: classes.closeButton,
    onClick: onClose
  });
  const titleComponent = typeof title === "string" ? /* @__PURE__ */ React3.createElement(NxTypography, {
    variant: "h4"
  }, title) : title;
  const contentComponent = /* @__PURE__ */ React3.createElement(Box, {
    ml: showTitleIcon ? 3.5 : 0
  }, typeof content === "string" ? /* @__PURE__ */ React3.createElement(NxTypography, {
    colorToken: "ColorTextAlt2",
    variant: "body1"
  }, content) : content);
  const actionsComponent = actions && /* @__PURE__ */ React3.createElement(Box, {
    display: "flex",
    gridGap: theme.spacing(2),
    justifyContent: "flex-end"
  }, actions);
  const avatarComponent = (icon || isXs) && /* @__PURE__ */ React3.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, icon, /* @__PURE__ */ React3.createElement(Box, {
    className: classes.avatarCloseButtonWrapper,
    display: "flex",
    flex: 1,
    justifyContent: "flex-end"
  }, closeButton));
  const bgcolor = tinted ? `ColorBackground${capitalize(variant)}` : "ColorBackgroundBase";
  const titleIcon = getIconFromVariant(variant, theme);
  return /* @__PURE__ */ React3.createElement(Grow, {
    appear: false,
    in: !isClosed,
    unmountOnExit: true
  }, /* @__PURE__ */ React3.createElement(Box, {
    bgcolor,
    className: clsx2(classes.container, className)
  }, /* @__PURE__ */ React3.createElement(Box, {
    className: clsx2(classes.variantBorder, classes[variant])
  }), /* @__PURE__ */ React3.createElement(Box, {
    className: classes.bodyContainer
  }, avatarComponent, /* @__PURE__ */ React3.createElement(Box, {
    className: classes.contentContainer
  }, /* @__PURE__ */ React3.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React3.createElement(Box, {
    alignItems: "center",
    display: "flex",
    gridGap: theme.spacing(1)
  }, showTitleIcon && titleIcon, titleComponent), /* @__PURE__ */ React3.createElement("div", {
    className: classes.closeButtonWrapper
  }, closeButton)), contentComponent, actionsComponent))));
}

// src/alert/NxAlert.tsx
function NxAlert(_a) {
  var _b = _a, {
    variant,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "className"
  ]);
  return /* @__PURE__ */ React4.createElement(NxAlertBase, __spreadValues({
    className,
    variant
  }, rest));
}

// src/avatar/NxAvatar.tsx
import React9 from "react";
import { Avatar, Box as Box4, makeStyles as makeStyles7 } from "@material-ui/core";
import clsx4 from "clsx";
import { NxRandomAvatar } from "@playvs-inc/nexus-random-avatars";

// src/tooltip/NxTooltip.tsx
import React5 from "react";
import { Tooltip } from "@material-ui/core";

// src/tooltip/NxTooltip.styles.ts
import { makeStyles as makeStyles3 } from "@material-ui/core";
var useStyles2 = makeStyles3((theme) => ({
  arrow: {
    "&::before": {
      backgroundColor: theme.palette.ColorBackgroundTooltip
    }
  },
  tooltip: ({ maxWidth }) => ({
    backgroundColor: theme.palette.ColorBackgroundTooltip,
    padding: theme.spacing(0.5, 1.25),
    maxWidth: maxWidth || 300
  }),
  tooltipText: {
    color: theme.palette.common.white
  }
}));

// src/tooltip/NxTooltip.tsx
function NxTooltip(_a) {
  var _b = _a, {
    children,
    title,
    maxWidth
  } = _b, rest = __objRest(_b, [
    "children",
    "title",
    "maxWidth"
  ]);
  const classes = useStyles2({ maxWidth });
  if (!title) {
    return children;
  }
  return /* @__PURE__ */ React5.createElement(Tooltip, __spreadValues({
    classes: {
      arrow: classes.arrow,
      tooltip: classes.tooltip
    },
    title: /* @__PURE__ */ React5.createElement(NxTypography, {
      className: classes.tooltipText,
      component: "div",
      variant: "body4"
    }, title)
  }, rest), children);
}

// src/user-cluster/NxUserCluster.tsx
import React7, { useRef, useState as useState2, useEffect } from "react";
import { Box as Box3, makeStyles as makeStyles5 } from "@material-ui/core";
import clsx3 from "clsx";

// src/user-cluster/NxUserClusterSubtitle.tsx
import React6 from "react";
import { Box as Box2, makeStyles as makeStyles4 } from "@material-ui/core";
var useStyles3 = makeStyles4((theme) => ({
  typography: ({ disabled }) => ({
    color: disabled ? theme.palette.ColorTextDisabled : theme.palette.ColorTextAlt2,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  })
}));
function NxUserClusterSubtitle({
  subtitle,
  tooltip,
  className,
  subtitleVariant,
  disabled
}) {
  const classes = useStyles3({ disabled });
  const useDefaultTypography = typeof subtitle === "string" || typeof subtitle === "number";
  const Typography = useDefaultTypography ? /* @__PURE__ */ React6.createElement(NxTypography, {
    className: `${classes.typography} ${className}`,
    variant: subtitleVariant || "body3"
  }, subtitle) : subtitle;
  return tooltip ? /* @__PURE__ */ React6.createElement(NxTooltip, {
    arrow: true,
    placement: "top-start",
    title: tooltip
  }, /* @__PURE__ */ React6.createElement(Box2, null, Typography)) : Typography;
}

// src/user-cluster/NxUserCluster.tsx
var useStyles4 = makeStyles5((theme) => ({
  userCluster: ({
    compact,
    numOfSubtitles,
    alignment,
    disabled
  }) => ({
    display: "flex",
    alignItems: compact || numOfSubtitles === 0 ? "center" : "auto",
    color: disabled ? theme.palette.ColorTextDisabled : theme.palette.ColorTextBase,
    overflow: "hidden",
    height: "min-content",
    flexDirection: alignment === "right" ? "row-reverse" : "row",
    textAlign: alignment === "right" ? "right" : "left",
    columnGap: theme.spacing(2),
    rowGap: theme.spacing(0.5)
  }),
  titlesContainer: ({
    numOfSubtitles,
    compact
  }) => ({
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gridGap: numOfSubtitles && !compact ? theme.spacing(1) / numOfSubtitles : 0
  }),
  titleClass: ({ showTooltip }) => ({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    cursor: showTooltip ? "pointer" : "auto"
  }),
  ellipsisOverflow: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  avatar: ({ disabled }) => ({
    opacity: disabled ? "30%" : "100%"
  })
}));
function NxUserCluster({
  title,
  subtitles,
  avatarUrl,
  avatarHashId,
  subAvatarUrl,
  subAvatarHashId,
  showSubAvatar,
  compact = false,
  onClickAvatar,
  alignment = "left",
  disabled = false,
  className,
  onlineStatus,
  showTooltipForOnlineStatus,
  SubIcon,
  subHeader,
  randomPersona,
  randomPersonaIndex,
  avatarHeight = 54,
  avatarWidth = 54,
  Avatar: Avatar4
}) {
  var _a;
  const [showTooltip, setShowTooltip] = useState2(false);
  const classes = useStyles4({
    showTooltip,
    compact,
    avatarClickable: !!onClickAvatar,
    numOfSubtitles: (_a = subtitles == null ? void 0 : subtitles.length) != null ? _a : 0,
    alignment,
    disabled
  });
  const titleElementRef = useRef(null);
  const el = titleElementRef;
  useEffect(() => {
    var _a2, _b, _c, _d;
    if (((_a2 = el == null ? void 0 : el.current) == null ? void 0 : _a2.scrollWidth) && ((_b = el == null ? void 0 : el.current) == null ? void 0 : _b.offsetWidth) && ((_c = el == null ? void 0 : el.current) == null ? void 0 : _c.scrollWidth) > ((_d = el == null ? void 0 : el.current) == null ? void 0 : _d.offsetWidth)) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  }, [el]);
  return /* @__PURE__ */ React7.createElement(Box3, {
    className: clsx3(classes.userCluster, className)
  }, /* @__PURE__ */ React7.createElement(React7.Fragment, null, Avatar4 || /* @__PURE__ */ React7.createElement(NxAvatar, {
    avatarHashId,
    avatarUrl,
    className: classes.avatar,
    disabled,
    hasBorder: true,
    height: compact ? 32 : avatarHeight,
    onClickAvatar,
    onlineStatus,
    randomPersona,
    randomPersonaIndex,
    showSubAvatar: !compact && showSubAvatar,
    showTooltipForOnlineStatus,
    subAvatarHashId,
    subAvatarUrl,
    SubIcon,
    width: compact ? 32 : avatarWidth
  }), /* @__PURE__ */ React7.createElement(Box3, {
    className: classes.titlesContainer
  }, /* @__PURE__ */ React7.createElement(NxTypography, {
    className: classes.ellipsisOverflow,
    colorToken: "ColorTextAlt2",
    variant: "overline"
  }, subHeader), title && /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(NxTooltip, {
    arrow: true,
    disableHoverListener: !showTooltip,
    placement: "top",
    title
  }, /* @__PURE__ */ React7.createElement(Box3, null, /* @__PURE__ */ React7.createElement(NxTypography, {
    className: classes.titleClass,
    color: "inherit",
    "data-cy": title,
    innerRef: titleElementRef,
    variant: "body2"
  }, title))), subtitles == null ? void 0 : subtitles.map(({
    title: subtitle,
    tooltip,
    className: subtitleClassName,
    subtitleVariant
  }, index) => /* @__PURE__ */ React7.createElement(NxUserClusterSubtitle, {
    key: typeof subtitle === "string" ? subtitle : `nx-user-cluster-subtitle-${index}`,
    className: subtitleClassName,
    disabled,
    subtitle,
    subtitleVariant,
    tooltip
  }))))));
}

// src/user-cluster/UserCluster.d.ts
var OnlineStatus = /* @__PURE__ */ ((OnlineStatus2) => {
  OnlineStatus2["Online"] = "online";
  OnlineStatus2["Idle"] = "idle";
  OnlineStatus2["Offline"] = "offline";
  OnlineStatus2["Placeholder"] = "placeholder";
  return OnlineStatus2;
})(OnlineStatus || {});

// src/user-cluster/NxUserOnlineStatus.tsx
import { useTheme as useTheme3 } from "@material-ui/core";
import React8 from "react";

// src/user-cluster/NxUserOnlineStatus.styles.ts
import { makeStyles as makeStyles6 } from "@material-ui/core";
var useStyles5 = makeStyles6((theme) => ({
  statusBadge: ({
    statusColor,
    width,
    height,
    removeBorder,
    left,
    top,
    position
  }) => ({
    backgroundColor: statusColor,
    border: removeBorder ? void 0 : `2px solid ${theme.palette.ColorBackgroundBody}`,
    width,
    height,
    position,
    borderRadius: theme.mixins.cornerRadius["border-radius-1000"],
    top,
    left
  }),
  statusTitle: {
    textTransform: "capitalize",
    color: theme.palette.common.white
  }
}));

// src/user-cluster/NxUserOnlineStatus.tsx
function NxUserOnlineStatus({
  onlineStatus,
  showTooltip = true,
  width = 16,
  height = 16,
  removeBorder,
  left = 38,
  top = 38,
  position = "absolute"
}) {
  const theme = useTheme3();
  const colorMap = {
    ["idle" /* Idle */]: theme.palette.OverlayColorBackgroundWarn,
    ["offline" /* Offline */]: theme.palette.ColorIconDisabled,
    ["online" /* Online */]: theme.palette.OverlayColorBackgroundSuccess,
    ["placeholder" /* Placeholder */]: theme.palette.ColorIconDisabled
  };
  const classes = useStyles5({
    statusColor: colorMap[onlineStatus],
    width,
    height,
    removeBorder,
    left,
    top,
    position
  });
  const statusBadge = /* @__PURE__ */ React8.createElement("div", {
    className: classes.statusBadge
  });
  return showTooltip ? /* @__PURE__ */ React8.createElement(NxTooltip, {
    arrow: true,
    placement: "top",
    title: /* @__PURE__ */ React8.createElement(NxTypography, {
      className: classes.statusTitle,
      variant: "body4"
    }, onlineStatus === "placeholder" /* Placeholder */ ? "offline" : onlineStatus)
  }, statusBadge) : statusBadge;
}

// src/avatar/NxAvatar.tsx
var useStyles6 = makeStyles7((theme) => ({
  avatarContainer: ({
    avatarClickable,
    hasBorder,
    disabled,
    height,
    width,
    borderColor
  }) => ({
    position: "relative",
    cursor: avatarClickable ? "pointer" : "auto",
    border: hasBorder ? `2px solid ${borderColor != null ? borderColor : theme.palette.ColorBackgroundBase}` : "2px solid transparent",
    borderRadius: "50%",
    opacity: disabled ? "30%" : "100%",
    height: height + 4,
    width: width + 4
  }),
  avatarClass: ({ height, width }) => ({
    height,
    width,
    overflow: "hidden"
  }),
  subAvatarContainer: {
    position: "absolute",
    height: 24,
    width: 24,
    bottom: 0,
    right: 0
  },
  subIconContainer: {
    position: "absolute",
    bottom: 0,
    right: 0,
    marginBottom: -theme.spacing(1)
  },
  subAvatarBorder: {
    border: `2px solid ${theme.palette.ColorBackgroundAlt}`,
    backgroundColor: theme.palette.ColorBackgroundAlt,
    borderRadius: "50%"
  },
  subAvatarClass: {
    height: 20,
    width: 20,
    zIndex: 100
  }
}));
function NxAvatar({
  avatarUrl,
  avatarHashId,
  subAvatarUrl,
  subAvatarHashId,
  showSubAvatar,
  height = 54,
  width = 54,
  onClickAvatar,
  disabled = false,
  className,
  onlineStatus,
  showTooltipForOnlineStatus,
  SubIcon,
  hasBorder = true,
  borderColor,
  randomPersona,
  randomPersonaIndex,
  tooltipTitle = ""
}) {
  const classes = useStyles6({
    height,
    width,
    avatarClickable: !!onClickAvatar,
    disabled,
    hasBorder,
    borderColor
  });
  return /* @__PURE__ */ React9.createElement(NxTooltip, {
    arrow: true,
    placement: "top",
    title: tooltipTitle
  }, /* @__PURE__ */ React9.createElement(Box4, {
    className: clsx4(classes.avatarContainer, className),
    height: "fit-content",
    onClick: onClickAvatar,
    position: "relative",
    width: "fit-content"
  }, avatarUrl ? /* @__PURE__ */ React9.createElement(Avatar, {
    alt: "avatar",
    className: classes.avatarClass,
    src: avatarUrl
  }) : /* @__PURE__ */ React9.createElement(NxRandomAvatar, {
    hashId: avatarHashId,
    height,
    persona: randomPersona,
    personaIndex: randomPersonaIndex,
    viewBox: "0 0 150 150",
    width
  }), onlineStatus && !showSubAvatar && !SubIcon && /* @__PURE__ */ React9.createElement(NxUserOnlineStatus, {
    onlineStatus,
    showTooltip: showTooltipForOnlineStatus
  }), showSubAvatar && /* @__PURE__ */ React9.createElement(Box4, {
    className: clsx4(classes.subAvatarContainer, classes.subAvatarBorder)
  }, subAvatarUrl ? /* @__PURE__ */ React9.createElement(Avatar, {
    alt: "subAvatar",
    className: classes.subAvatarClass,
    src: subAvatarUrl
  }) : /* @__PURE__ */ React9.createElement(NxRandomAvatar, {
    hashId: subAvatarHashId,
    height: 20,
    persona: randomPersona,
    personaIndex: randomPersonaIndex,
    viewBox: "0 0 150 150",
    width: 20
  })), SubIcon && !showSubAvatar && /* @__PURE__ */ React9.createElement(Box4, {
    className: classes.subIconContainer
  }, SubIcon)));
}

// src/avatar-group/NxAvatarGroup.tsx
import React10 from "react";
import { Box as Box5, makeStyles as makeStyles8, useTheme as useTheme4 } from "@material-ui/core";
import { MUIThemeModeEnum } from "@playvs-inc/nexus-theme";
var useStyles7 = makeStyles8((theme) => ({
  remainingTeamsAvatar: ({
    overlay,
    height,
    width,
    spacing
  }) => ({
    backgroundColor: theme.palette.type === MUIThemeModeEnum.Dark ? theme.palette.OverlayColorBackgroundBrand : theme.palette.ColorBackgroundBrand,
    borderRadius: "50%",
    zIndex: 200,
    height: height + 4,
    width: width + 4,
    marginLeft: theme.spacing(spacing),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `2px solid ${overlay ? theme.palette.OverlayColorOpBlack3 : theme.palette.ColorBackgroundBase}`,
    color: theme.palette.type === MUIThemeModeEnum.Dark ? theme.palette.OverlayColorTextInvert : theme.palette.ColorTextBase
  })
}));
function NxAvatarGroup({
  avatars,
  height = 54,
  width = 54,
  overlay = false,
  spacing = -3,
  maxNumAvatars
}) {
  const theme = useTheme4();
  const classes = useStyles7({ overlay, height, width, spacing });
  const remainingTeamsSize = maxNumAvatars ? avatars.length - maxNumAvatars : 0;
  const displayAvatars = maxNumAvatars ? avatars.slice(0, maxNumAvatars) : avatars;
  return /* @__PURE__ */ React10.createElement(Box5, {
    display: "flex",
    gridGap: theme.spacing(1)
  }, displayAvatars.map((props, ndx) => /* @__PURE__ */ React10.createElement(Box5, {
    key: props.avatarHashId,
    marginLeft: ndx ? spacing : 0
  }, /* @__PURE__ */ React10.createElement(NxAvatar, __spreadProps(__spreadValues({
    height,
    width
  }, props), {
    borderColor: overlay ? theme.palette.OverlayColorOpBlack3 : theme.palette.ColorBackgroundBase,
    hasBorder: true
  })))), remainingTeamsSize > 0 && /* @__PURE__ */ React10.createElement(NxTooltip, {
    arrow: true,
    placeholder: "top",
    title: avatars.slice(maxNumAvatars).map((a) => a.tooltipTitle).filter((title) => title).join(", ")
  }, /* @__PURE__ */ React10.createElement("div", {
    className: classes.remainingTeamsAvatar
  }, /* @__PURE__ */ React10.createElement(NxTypography, {
    color: "inherit",
    variant: "body2"
  }, "+", remainingTeamsSize))));
}

// src/award-achievement-card/NxWeeklyAwardAchievementCard.tsx
import React11 from "react";
import { Box as Box6, Card, makeStyles as makeStyles9 } from "@material-ui/core";
import clsx5 from "clsx";

// src/award-achievement-card/WeeklyAwardAchievementCard.helpers.ts
var formatDateMDY = (date) => new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric"
}).format(new Date(date));
var formatDateMD = (date) => new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit"
}).format(new Date(date));

// src/award-achievement-card/NxWeeklyAwardAchievementCard.tsx
var useStyles8 = makeStyles9((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius * 2.5,
    boxShadow: theme.mixins.boxShadow.elevation1,
    display: "flex",
    flexDirection: "row",
    width: 298,
    height: 137,
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(2)
  },
  titleText: {
    color: theme.palette.ColorTextBase,
    marginBottom: theme.spacing(1)
  },
  dateText: {
    color: theme.palette.ColorTextBase,
    marginBottom: theme.spacing(0.25)
  },
  seasonText: {
    color: theme.palette.ColorTextBase,
    marginBottom: theme.spacing(1)
  },
  rightContainer: {
    paddingLeft: theme.spacing(2)
  },
  leftContainer: {
    marginTop: "auto"
  }
}));
function NxWeeklyAwardAchievementCard({
  achievementRecord,
  className,
  spot
}) {
  const classes = useStyles8();
  return /* @__PURE__ */ React11.createElement(Card, {
    className: clsx5(classes.root, className)
  }, /* @__PURE__ */ React11.createElement(Box6, {
    className: classes.leftContainer
  }, spot), /* @__PURE__ */ React11.createElement(Box6, {
    className: classes.rightContainer
  }, /* @__PURE__ */ React11.createElement(NxTypography, {
    className: classes.titleText,
    variant: "body2"
  }, "Player of the Week"), /* @__PURE__ */ React11.createElement(NxTypography, {
    className: classes.dateText,
    variant: "body3"
  }, formatDateMD(achievementRecord.startsAt), " -", " ", formatDateMDY(achievementRecord.endsAt)), /* @__PURE__ */ React11.createElement(NxTypography, {
    className: classes.seasonText,
    variant: "body3"
  }, achievementRecord.seasonName)));
}

// src/awards/seasonal-award/NxSeasonalAwardsTable.tsx
import React29, { useMemo } from "react";
import { useFlexLayout, useTable } from "react-table";
import { Box as Box12 } from "@material-ui/core";

// src/awards/seasonal-award/SeasonalAwards.d.ts
var EventAction = /* @__PURE__ */ ((EventAction2) => {
  EventAction2["edit"] = "edit";
  EventAction2["delete"] = "delete";
  EventAction2["assign"] = "assign";
  return EventAction2;
})(EventAction || {});

// src/awards/seasonal-award/NxSeasonalAwards.styles.tsx
import { makeStyles as makeStyles10 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles9 = makeStyles10((theme) => ({
  table: {
    overflow: "auto"
  },
  tableGroup: {
    display: "block",
    "@media (max-width:900px)": {
      display: "inline-table"
    }
  },
  tableRow: {
    boxShadow: theme.mixins.divider.bottom,
    padding: theme.spacing(2, 4, 2, 4),
    "&:last-child": {
      boxShadow: "none"
    }
  },
  nameContainer: {
    width: "100%",
    minWidth: 0
  },
  name: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    minWidth: 0
  },
  headerRow: {
    padding: theme.spacing(2, 4, 0, 4)
  },
  headerCell: {
    color: theme.palette.ColorTextBase,
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginBottom: theme.spacing(3)
  },
  avatar: {
    height: 40,
    width: 40
  },
  exportImageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    cursor: "pointer",
    marginLeft: "40px",
    "@media (max-width:900px)": {
      marginLeft: "33px"
    }
  },
  exportPdfContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    cursor: "pointer",
    marginLeft: "35px",
    "@media (max-width:900px)": {
      marginLeft: "28px"
    }
  },
  awardContainer: {
    cursor: "pointer"
  }
}));

// src/awards/seasonal-award/NxSeasonalAwardsTableCells.tsx
import React28, { useState as useState3 } from "react";
import { Avatar as Avatar2, Box as Box11, useTheme as useTheme8 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
import { AddteamHover, Image, Pdf } from "@playvs-inc/nexus-icons";
import { NxRandomAvatar as NxRandomAvatar2 } from "@playvs-inc/nexus-random-avatars";

// src/esport-avatar/NxEsportAvatar.tsx
import React14 from "react";
import { useTheme as useTheme6 } from "@material-ui/core";
import { useEsport } from "@playvs-inc/nexus-theme";
import { NxIcon as NxIcon2 } from "@playvs-inc/nexus-icons";

// src/esport-avatar/NxEsportIcon.tsx
import React12 from "react";
import { makeStyles as makeStyles11 } from "@material-ui/core";
import { NxIcon } from "@playvs-inc/nexus-icons";
var useStyles10 = makeStyles11(() => ({
  icon: ({ mode }) => ({
    filter: mode === "light" ? "brightness(0)" : "brightness(0) invert(1)"
  }),
  svg: ({ height, width }) => ({
    height,
    width
  })
}));
function NxEsportIcon(_a) {
  var _b = _a, {
    esportSlug,
    height = 20,
    width = 20,
    mode = "light"
  } = _b, props = __objRest(_b, [
    "esportSlug",
    "height",
    "width",
    "mode"
  ]);
  const styles = useStyles10({ height, width, mode });
  return /* @__PURE__ */ React12.createElement(NxIcon, __spreadValues({}, props), /* @__PURE__ */ React12.createElement("svg", {
    className: styles.svg,
    "data-cy": esportSlug,
    fill: "none",
    height,
    viewBox: "0 0 20 20",
    width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React12.createElement("image", {
    className: styles.icon,
    xlinkHref: `https://s3.amazonaws.com/assets.playvs.com/esports/${esportSlug}/Icon.svg`
  })));
}

// src/esport-avatar/EsportAvatar.helpers.tsx
import React13 from "react";
import { useTheme as useTheme5 } from "@material-ui/core";
var useGetEsportsProps = (esport, disabled, height, width) => {
  const theme = useTheme5();
  return {
    Avatar: () => /* @__PURE__ */ React13.createElement(NxEsportIcon, {
      esportSlug: esport != null ? esport : "",
      height,
      width
    }),
    backgroundColor: disabled ? theme.palette.ColorBackgroundAlt3 : theme.palette.ColorBackgroundAccent,
    color: ""
  };
};

// src/esport-avatar/styles.ts
import { makeStyles as makeStyles12 } from "@material-ui/core";
var useStyles11 = makeStyles12((theme) => ({
  avatarWrapper: ({ backgroundColor }) => ({
    backgroundColor,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    padding: theme.spacing(1)
  }),
  icon: ({ iconHeight, iconWidth }) => ({
    height: iconHeight,
    width: iconWidth
  })
}));

// src/esport-avatar/NxEsportAvatar.tsx
function NxEsportAvatar({
  className,
  esport: esportSlug,
  disabled,
  iconHeight,
  iconWidth,
  avatarUrl
}) {
  var _a, _b;
  const theme = useTheme6();
  const esport = useEsport(esportSlug != null ? esportSlug : "");
  const esportProps = useGetEsportsProps(esportSlug, disabled, iconHeight, iconWidth);
  const backgroundColor = disabled ? theme.palette.ColorIconDisabled : ((_a = esport == null ? void 0 : esport.palette) == null ? void 0 : _a.baseColor) || esportProps.backgroundColor;
  const color = (esport == null ? void 0 : esport.palette[1]) || esportProps.color;
  const styles = useStyles11({
    backgroundColor,
    iconWidth,
    iconHeight
  });
  const customAvatar = avatarUrl && /* @__PURE__ */ React14.createElement(NxIcon2, {
    className: styles.icon,
    color
  }, /* @__PURE__ */ React14.createElement("img", {
    alt: (_b = esport == null ? void 0 : esport.name) != null ? _b : "Esport Icon",
    src: avatarUrl
  }));
  return /* @__PURE__ */ React14.createElement("span", {
    className: `${styles.avatarWrapper} ${className}`
  }, avatarUrl && customAvatar || /* @__PURE__ */ React14.createElement(NxEsportIcon, {
    esportSlug: esportSlug != null ? esportSlug : "",
    height: iconHeight,
    mode: "dark",
    width: iconWidth
  }));
}

// src/button/NxButton.tsx
import React19 from "react";
import { makeStyles as makeStyles17, Box as Box7 } from "@material-ui/core";

// src/loading-spinner/NxLoadingSpinner.tsx
import React15 from "react";
import { makeStyles as makeStyles13 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles12 = makeStyles13((theme) => {
  var _a, _b, _c, _d;
  return {
    largeSpinner: {
      height: "80px",
      width: "80px"
    },
    largeOuterBob: {
      strokeDasharray: "285 0",
      strokeDashoffset: -60,
      animation: "LoadingSpinner_largeOuterBob 2.5s linear infinite",
      stroke: (_a = theme.palette.loader) == null ? void 0 : _a.large.outerBob,
      strokeWidth: 5,
      fill: "none",
      strokeLinecap: "round"
    },
    largeInnerBob: {
      strokeDasharray: "222 0",
      strokeDashoffset: 140,
      animation: "LoadingSpinner_largeInnerBob 2.5s linear infinite",
      stroke: (_b = theme.palette.loader) == null ? void 0 : _b.large.innerBob,
      strokeWidth: 4,
      fill: "none",
      strokeLinecap: "round"
    },
    mediumSpinner: {
      height: "40px",
      width: "40px"
    },
    mediumTopBob: {
      strokeDasharray: "128 0",
      strokeDashoffset: -20,
      animation: "LoadingSpinner_mediumTopBob 2.5s linear infinite",
      stroke: (_c = theme.palette.loader) == null ? void 0 : _c.medium.topBob,
      strokeWidth: 3,
      fill: "none",
      strokeLinecap: "round"
    },
    mediumBackgroundBob: {
      stroke: (_d = theme.palette.loader) == null ? void 0 : _d.medium.backgroundBob,
      strokeWidth: 3,
      fill: "none"
    },
    smallSpinner: {
      height: "20px",
      width: "20px"
    },
    smallTopBob: ({ color }) => {
      var _a2, _b2;
      return {
        strokeDasharray: "63 0",
        strokeDashoffset: -10,
        animation: "LoadingSpinner_smallTopBob 2.5s linear infinite",
        stroke: color === "secondary" ? (_a2 = theme.palette.loader) == null ? void 0 : _a2.button.secondary : (_b2 = theme.palette.loader) == null ? void 0 : _b2.button.primary,
        strokeWidth: 1.5,
        fill: "none",
        strokeLinecap: "round"
      };
    },
    smallBackgroundBob: ({
      color
    }) => {
      var _a2, _b2;
      return {
        stroke: color === "secondary" ? (_a2 = theme.palette.loader) == null ? void 0 : _a2.button.secondaryBackground : (_b2 = theme.palette.loader) == null ? void 0 : _b2.button.primaryBackground,
        strokeWidth: 1.5,
        fill: "none",
        height: "50%",
        width: "50%"
      };
    },
    "@global": {
      "@keyframes LoadingSpinner_largeOuterBob": {
        "33%": {
          strokeDasharray: "170 84",
          strokeDashoffset: -60
        },
        "66%": {
          strokeDasharray: "170 84",
          strokeDashoffset: "110"
        },
        "100%": {
          strokeDasharray: "253 1",
          strokeDashoffset: "193"
        }
      },
      "@keyframes LoadingSpinner_largeInnerBob": {
        "33%": {
          strokeDasharray: "148 74",
          strokeDashoffset: 66
        },
        "66%": {
          strokeDasharray: "148 74",
          strokeDashoffset: -82
        },
        "100%": {
          strokeDasharray: "221 1",
          strokeDashoffset: -82
        }
      },
      "@keyframes LoadingSpinner_mediumTopBob": {
        "33%": {
          strokeDasharray: "86 42",
          strokeDashoffset: -20
        },
        "66%": {
          strokeDasharray: "86 42",
          strokeDashoffset: 66
        },
        "100%": {
          strokeDasharray: "127 1",
          strokeDashoffset: "107"
        }
      },
      "@keyframes LoadingSpinner_smallTopBob": {
        "33%": {
          strokeDasharray: "42 21",
          strokeDashoffset: -10
        },
        "66%": {
          strokeDasharray: "42 21",
          strokeDashoffset: 32
        },
        "100%": {
          strokeDasharray: "62 1",
          strokeDashoffset: "52"
        }
      }
    }
  };
});
function LoadingSpinner({
  size,
  color
}) {
  const {
    largeSpinner,
    largeOuterBob,
    largeInnerBob,
    mediumSpinner,
    mediumBackgroundBob,
    mediumTopBob,
    smallSpinner,
    smallBackgroundBob,
    smallTopBob
  } = useStyles12({ color });
  switch (size) {
    case "small":
      return /* @__PURE__ */ React15.createElement("svg", {
        className: smallSpinner,
        "data-cy": "spinner"
      }, /* @__PURE__ */ React15.createElement("path", {
        className: smallBackgroundBob,
        d: "M10.1,5.16v-1c0-0.39,0-1.14,0-1.74c-0.17,0-0.34,0-0.5,0C6.32,2.38,3.33,4.3,2,7.3c-1.17,2.57-1.27,6.37,1.97,9.29  c2.66,2.17,6.38,2.5,9.37,0.81c2.8-1.53,4.3-4.35,4.11-7.63h-1.79h-1.04l0.43-0.94l3.16-6.94l-7.19,2.89L10.1,5.16z"
      }), /* @__PURE__ */ React15.createElement("path", {
        className: smallTopBob,
        d: "M10.1,5.16v-1c0-0.39,0-1.14,0-1.74c-0.17,0-0.34,0-0.5,0C6.32,2.38,3.33,4.3,2,7.3c-1.17,2.57-1.27,6.37,1.97,9.29  c2.66,2.17,6.38,2.5,9.37,0.81c2.8-1.53,4.3-4.35,4.11-7.63h-1.79h-1.04l0.43-0.94l3.16-6.94l-7.19,2.89L10.1,5.16z"
      }));
    case "medium":
      return /* @__PURE__ */ React15.createElement("svg", {
        className: mediumSpinner,
        "data-cy": "spinner"
      }, /* @__PURE__ */ React15.createElement("path", {
        className: mediumBackgroundBob,
        d: "M20.18,10.47V8.43c0-0.8,0-2.33,0-3.56c-0.35,0-0.69,0-1.03,0c-6.7-0.07-12.8,3.86-15.52,9.97  c-2.4,5.26-2.6,13.02,4.03,18.99c5.43,4.44,13.03,5.1,19.15,1.65c5.73-3.13,8.79-8.89,8.39-15.58h-3.66h-2.13l0.88-1.93L36.75,3.8  L22.06,9.7L20.18,10.47z"
      }), /* @__PURE__ */ React15.createElement("path", {
        className: mediumTopBob,
        d: "M20.18,10.47V8.43c0-0.8,0-2.33,0-3.56c-0.35,0-0.69,0-1.03,0c-6.7-0.07-12.8,3.86-15.52,9.97  c-2.4,5.26-2.6,13.02,4.03,18.99c5.43,4.44,13.03,5.1,19.15,1.65c5.73-3.13,8.79-8.89,8.39-15.58h-3.66h-2.13l0.88-1.93L36.75,3.8  L22.06,9.7L20.18,10.47z"
      }));
    case "large":
    default:
      return /* @__PURE__ */ React15.createElement("svg", {
        className: largeSpinner,
        "data-cy": "spinner"
      }, /* @__PURE__ */ React15.createElement("path", {
        className: largeOuterBob,
        d: "M40.5,20.55v-4.06c0-1.6,0-4.64,0-7.09c-0.69,0-1.37,0-2.04,0c-13.34-0.13-25.48,7.68-30.9,19.85   c-4.77,10.47-5.17,25.93,8.02,37.82c10.82,8.84,25.95,10.15,38.12,3.28c11.41-6.22,17.51-17.7,16.7-31.02h-7.29h-4.24l1.75-3.85   L73.49,7.27L44.25,19.02L40.5,20.55z"
      }), /* @__PURE__ */ React15.createElement("path", {
        className: largeInnerBob,
        d: "M11.44,30.99L11.44,30.99c-4.15,9.11-4.51,22.54,6.94,32.89c9.48,7.72,22.53,8.81,33.23,2.77  c8.85-4.82,14-13,14.56-23.07h-13.9l12.94-28.41L36.25,26.86V13.71C25.52,14.42,15.82,21.15,11.44,30.99z"
      }));
  }
}

// src/loading-spinner/enrollment/EnrollmentLoadingSpinner.tsx
import React16 from "react";
import { makeStyles as makeStyles14 } from "@material-ui/core";
var useStyles13 = makeStyles14((theme) => {
  var _a, _b, _c, _d;
  return {
    overlayWrapper: {
      position: "relative",
      display: "inline-block"
    },
    spotWrapper: {
      height: "12.5rem",
      width: "12.5rem"
    },
    loadingSpinnerWrapper: {
      position: "absolute",
      top: "3.8rem",
      left: "4.35rem"
    },
    loadingSpinner: {
      strokeWidth: 4,
      strokeLinecap: "round"
    },
    loadingSpinnerOuter: {
      stroke: (_b = (_a = theme.palette.loader) == null ? void 0 : _a.enrollment) == null ? void 0 : _b.outerSpinner
    },
    loadingSpinnerInner: {
      stroke: (_d = (_c = theme.palette.loader) == null ? void 0 : _c.enrollment) == null ? void 0 : _d.innerSpinner
    },
    animatedSpinner: {
      strokeDasharray: 100,
      transformOrigin: "center",
      animation: "EnrollmentLoadingSpinner_spinner 1.0s linear infinite"
    },
    "@global": {
      "@keyframes EnrollmentLoadingSpinner_spinner": {
        "25%": {
          transform: "rotate(0.25turn)"
        },
        "50%": {
          transform: "rotate(0.5turn)"
        },
        "75%": {
          transform: "rotate(0.75turn)"
        },
        "100%": {
          transform: "rotate(1turn)"
        }
      }
    }
  };
});
function EnrollmentLoadingSpinner({
  spot
}) {
  const {
    overlayWrapper,
    spotWrapper,
    loadingSpinnerWrapper,
    loadingSpinner,
    loadingSpinnerOuter,
    loadingSpinnerInner,
    animatedSpinner
  } = useStyles13();
  return /* @__PURE__ */ React16.createElement("div", {
    className: overlayWrapper
  }, /* @__PURE__ */ React16.createElement("div", {
    className: spotWrapper
  }, spot), /* @__PURE__ */ React16.createElement("div", {
    className: loadingSpinnerWrapper
  }, /* @__PURE__ */ React16.createElement("svg", {
    className: `${loadingSpinner} ${loadingSpinnerInner}`,
    fill: "none",
    height: "48",
    viewBox: "0 0 48 48",
    width: "48",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React16.createElement("circle", {
    cx: "24",
    cy: "24",
    fill: "none",
    r: "22"
  }))), /* @__PURE__ */ React16.createElement("div", {
    className: loadingSpinnerWrapper
  }, /* @__PURE__ */ React16.createElement("svg", {
    className: `${loadingSpinner} ${loadingSpinnerOuter}`,
    fill: "none",
    height: "48",
    viewBox: "0 0 48 48",
    width: "48",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React16.createElement("circle", {
    className: animatedSpinner,
    cx: "24",
    cy: "24",
    fill: "none",
    r: "22"
  }))));
}

// src/loading-spinner/NxSkeletonLoader.tsx
import React17 from "react";
import { Skeleton } from "@material-ui/lab";
import { makeStyles as makeStyles15 } from "@material-ui/core";
var useStyles14 = makeStyles15((theme) => ({
  skeleton: ({ variant }) => ({
    borderRadius: variant === "circle" ? "50%" : 10,
    backgroundColor: theme.palette.ColorBackgroundAlt2
  })
}));
function NxSkeletonLoader({
  variant,
  height,
  width
}) {
  const classes = useStyles14({ variant });
  return /* @__PURE__ */ React17.createElement(Skeleton, {
    className: classes.skeleton,
    height,
    variant,
    width
  });
}

// src/button/NxButtonBase.tsx
import React18 from "react";
import { ButtonBase, makeStyles as makeStyles16 } from "@material-ui/core";
import { colors as colors2 } from "@playvs-inc/nexus-core";
import { MUIThemeModeEnum as MUIThemeModeEnum2 } from "@playvs-inc/nexus-theme";
var useStyles15 = makeStyles16((theme) => ({
  default: ({
    fullWidth,
    shouldUseOverlayColors,
    m,
    mt,
    mr,
    mb,
    ml,
    p,
    pt,
    pr,
    pb,
    pl
  }) => ({
    width: fullWidth ? "100%" : "auto",
    borderRadius: theme.mixins.cornerRadius["border-radius-4"],
    textTransform: "capitalize",
    margin: m,
    marginTop: mt,
    marginRight: mr,
    marginBottom: mb,
    marginLeft: ml,
    padding: p != null ? p : theme.spacing(1, 2),
    paddingTop: pt,
    paddingRight: pr,
    paddingBottom: pb,
    paddingLeft: pl,
    "&:disabled": {
      color: shouldUseOverlayColors ? theme.palette.OverlayColorTextDisabled : theme.palette.ColorTextDisabled,
      backgroundColor: shouldUseOverlayColors ? theme.palette.OverlayColorBackgroundAlt3 : theme.palette.ColorBackgroundAlt3
    }
  }),
  primary: {
    border: "1px solid transparent",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.ColorBackgroundAccent,
    "&:hover, &:active": {
      backgroundColor: theme.palette.ColorBackgroundAccentAlt
    }
  },
  secondary: ({ shouldUseOverlayColors }) => ({
    border: `1px solid ${shouldUseOverlayColors ? theme.palette.OverlayBorderDark : theme.palette.BorderDark}`,
    color: shouldUseOverlayColors ? theme.palette.OverlayColorTextBase : theme.palette.ColorTextAlt,
    "&:hover, &:active": {
      backgroundColor: shouldUseOverlayColors ? theme.palette.OverlayColorBackgroundAlt3 : theme.palette.ColorBackgroundAlt3,
      color: shouldUseOverlayColors ? theme.palette.OverlayColorTextBase : theme.palette.ColorTextBase
    },
    "&:disabled": {
      borderColor: shouldUseOverlayColors ? theme.palette.OverlayBorderMedium : theme.palette.BorderMedium
    }
  }),
  text: ({ shouldUseOverlayColors }) => ({
    border: "1px solid transparent",
    color: shouldUseOverlayColors ? theme.palette.OverlayColorTextBase : theme.palette.ColorTextAlt,
    "&:hover, &:active": {
      backgroundColor: shouldUseOverlayColors ? theme.palette.OverlayColorBackgroundAlt3 : theme.palette.ColorBackgroundAlt3
    }
  }),
  error: {
    border: "1px solid transparent",
    backgroundColor: colors2.RedError[4],
    color: theme.palette.type === MUIThemeModeEnum2.Light ? theme.palette.common.white : theme.palette.ColorTextBase,
    "&:hover, &:active": {
      backgroundColor: colors2.RedError[5]
    }
  },
  success: {
    border: "1px solid transparent",
    backgroundColor: colors2.GreenSuccess[5],
    color: theme.palette.type === MUIThemeModeEnum2.Light ? theme.palette.common.white : theme.palette.ColorTextBase,
    "&:hover, &:active": {
      backgroundColor: colors2.GreenSuccess[6]
    }
  },
  resource: {
    border: "none",
    color: theme.palette.ColorTextAlt2,
    backgroundColor: theme.palette.ColorBackgroundAlt,
    "&:hover, &:active": {
      color: theme.palette.ColorTextBase,
      backgroundColor: theme.palette.ColorBackgroundAlt2
    }
  }
}));
function NxButtonBase(_a) {
  var _b = _a, {
    children,
    variant,
    fullWidth,
    m,
    mt,
    mr,
    mb,
    ml,
    p,
    pt,
    pr,
    pb,
    pl,
    shouldUseOverlayColors,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "variant",
    "fullWidth",
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "shouldUseOverlayColors",
    "className"
  ]);
  const classes = useStyles15({
    fullWidth,
    m,
    mt,
    mr,
    mb,
    ml,
    p,
    pt,
    pr,
    pb,
    pl,
    shouldUseOverlayColors
  });
  const classNames = `${classes.default} ${classes[variant]} ${className}`;
  return /* @__PURE__ */ React18.createElement(ButtonBase, __spreadValues({
    className: classNames
  }, rest), children);
}

// src/button/NxButton.tsx
var useStyles16 = makeStyles17(() => ({
  button: ({ loading }) => ({
    visibility: loading ? "hidden" : "visible"
  })
}));
function NxButton(_a) {
  var _b = _a, {
    label,
    variant,
    loading = false,
    disabled
  } = _b, rest = __objRest(_b, [
    "label",
    "variant",
    "loading",
    "disabled"
  ]);
  const styles = useStyles16({ loading });
  return /* @__PURE__ */ React19.createElement(NxButtonBase, __spreadValues({
    disabled: loading || disabled,
    variant
  }, rest), loading && /* @__PURE__ */ React19.createElement(Box7, {
    position: "absolute"
  }, /* @__PURE__ */ React19.createElement(LoadingSpinner, {
    color: "secondary",
    size: "small"
  })), /* @__PURE__ */ React19.createElement(NxTypography, {
    className: styles.button,
    color: "inherit",
    "data-cy": label,
    variant: "button"
  }, label));
}

// src/button/NxIconButton.tsx
import React20 from "react";
import { makeStyles as makeStyles18 } from "@material-ui/core";
var useStyles17 = makeStyles18(() => ({
  iconWrapper: ({
    hasLabel,
    verticalAlign
  }) => ({
    display: "flex",
    flexDirection: verticalAlign ? "column" : "row",
    alignItems: verticalAlign ? "center" : "end",
    gap: hasLabel ? "0.5em" : 0,
    "&> svg": {
      color: "inherit"
    }
  })
}));
function NxIconButton(_a) {
  var _b = _a, {
    label,
    variant,
    loading,
    disabled,
    icon,
    verticalAlign
  } = _b, rest = __objRest(_b, [
    "label",
    "variant",
    "loading",
    "disabled",
    "icon",
    "verticalAlign"
  ]);
  const styles = useStyles17({ hasLabel: Boolean(label), verticalAlign });
  return /* @__PURE__ */ React20.createElement(NxButtonBase, __spreadValues({
    disabled: loading || disabled,
    variant
  }, rest), loading ? /* @__PURE__ */ React20.createElement(LoadingSpinner, {
    color: "secondary",
    size: "small"
  }) : /* @__PURE__ */ React20.createElement("div", {
    className: styles.iconWrapper
  }, icon, /* @__PURE__ */ React20.createElement(NxTypography, {
    color: "inherit",
    variant: verticalAlign ? "body5" : "button"
  }, label)));
}

// src/button/NxTextLink.tsx
import React22 from "react";

// src/button/NxTextLinkBase.tsx
import React21 from "react";
import { Link, makeStyles as makeStyles19 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles18 = makeStyles19((theme) => ({
  default: {
    cursor: "pointer",
    color: theme.palette.ColorTextLink,
    "&:hover, &:active": {
      color: theme.palette.ColorTextLinkHover,
      textDecoration: "none"
    }
  }
}));
function NxTextLinkBase(_a) {
  var _b = _a, {
    children,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "className"
  ]);
  const classes = useStyles18();
  return /* @__PURE__ */ React21.createElement(Link, __spreadValues({
    className: `${classes.default} ${className}`
  }, rest), children);
}

// src/button/NxTextLink.tsx
function NxTextLink(_a) {
  var _b = _a, {
    label,
    labelVariant = "body1"
  } = _b, rest = __objRest(_b, [
    "label",
    "labelVariant"
  ]);
  return /* @__PURE__ */ React22.createElement(NxTextLinkBase, __spreadValues({}, rest), /* @__PURE__ */ React22.createElement(NxTypography, {
    color: "inherit",
    component: "span",
    variant: labelVariant
  }, label));
}

// src/button/NxTextLinkExternal.tsx
import React23 from "react";
import { Linkout } from "@playvs-inc/nexus-icons";
import { makeStyles as makeStyles20 } from "@material-ui/core";
var useStyles19 = makeStyles20(() => ({
  iconWrapper: {
    display: "flex"
  }
}));
function NxTextLinkExternal(_a) {
  var _b = _a, {
    label,
    labelVariant = "body1"
  } = _b, rest = __objRest(_b, [
    "label",
    "labelVariant"
  ]);
  const classes = useStyles19();
  return /* @__PURE__ */ React23.createElement(NxTextLinkBase, __spreadValues({
    rel: "noopener",
    target: "_blank"
  }, rest), /* @__PURE__ */ React23.createElement("div", {
    className: classes.iconWrapper
  }, /* @__PURE__ */ React23.createElement(NxTypography, {
    color: "inherit",
    component: "span",
    variant: labelVariant
  }, label), /* @__PURE__ */ React23.createElement(Linkout, {
    color: "inherit"
  })));
}

// src/button/NxDropdownButton.tsx
import React26 from "react";
import { Box as Box9 } from "@material-ui/core";
import { CarretDown, CarretUp } from "@playvs-inc/nexus-icons";

// src/button/NxDropdownButton.styles.tsx
import { makeStyles as makeStyles21 } from "@material-ui/core";
var useStyles20 = makeStyles21((theme) => ({
  dropdownContainer: ({ fullWidth }) => fullWidth ? {
    width: "100%"
  } : {},
  button: ({
    fullWidth,
    isOpen,
    isIconButton
  }) => __spreadValues(__spreadValues(__spreadValues({
    padding: theme.spacing(1, 1.25)
  }, isIconButton ? {
    borderRadius: "50%"
  } : {}), fullWidth ? {
    padding: theme.spacing(2),
    borderRadius: 0,
    zIndex: 1400,
    backgroundColor: theme.palette.ColorBackgroundAccent,
    "&:hover": {
      backgroundColor: theme.palette.ColorBackgroundAccentAlt
    }
  } : {}), fullWidth && isOpen ? {
    backgroundColor: theme.palette.ColorBackgroundBody,
    "&:hover": {
      backgroundColor: theme.palette.ColorBackgroundAlt2
    }
  } : {}),
  comboButton: ({ isOpen }) => __spreadValues({
    "&:disabled": {
      borderLeft: "none",
      color: theme.palette.ColorTextBase,
      pointerEvents: "all"
    },
    "&:disabled:hover": {
      cursor: "not-allowed"
    },
    "&:hover": {
      backgroundColor: isOpen ? theme.palette.ColorBackgroundAlt2 : "none",
      cursor: "pointer"
    }
  }, isOpen ? { backgroundColor: theme.palette.ColorBackgroundAlt2 } : {}),
  buttonLabel: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between"
  },
  list: {
    padding: 0
  },
  paper: ({
    fullWidth,
    menuBackgroundColor
  }) => __spreadValues({
    padding: theme.spacing(1),
    borderRadius: fullWidth ? 0 : theme.spacing(1.5),
    backgroundColor: menuBackgroundColor || theme.palette.ColorBackgroundBase
  }, fullWidth ? { left: "0 !important", maxWidth: "100%" } : {}),
  menuGroupLabel: {
    color: theme.palette.ColorTextDisabled,
    padding: theme.spacing(2, 1)
  },
  menuItemLabel: {
    display: "flex"
  },
  menuItem: {
    height: theme.spacing(5.5),
    padding: theme.spacing(1.25),
    borderRadius: theme.spacing(0.5),
    justifyContent: "space-between",
    "&:hover": {
      backgroundColor: theme.palette.ColorBackgroundAlt2
    }
  },
  menuItemIcon: {
    display: "flex",
    alignItems: "center",
    paddingRight: theme.spacing(1.25)
  },
  linkout: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1.25)
  },
  backdrop: {
    backgroundColor: theme.palette.OverlayColorOpBlack3,
    zIndex: 1300
  },
  iconWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(0.5),
    "&> svg": {
      color: "inherit"
    }
  }
}));

// src/button/dropdown-menu/DropdownMenu.tsx
import React25 from "react";
import { Box as Box8, Menu, MenuItem } from "@material-ui/core";
import { Linkout as Linkout2 } from "@playvs-inc/nexus-icons";
import clsx6 from "clsx";

// src/button/NxDropdownButtonWrapper.tsx
import React24 from "react";
import { Backdrop } from "@material-ui/core";
function NxDropdownButtonWrapper({
  children,
  open,
  fullWidth
}) {
  const classes = useStyles20({});
  return fullWidth && open ? /* @__PURE__ */ React24.createElement(Backdrop, {
    className: classes.backdrop,
    open: true
  }, children) : children;
}

// src/button/dropdown-menu/DropdownMenu.tsx
function DropdownMenu({
  menuItems,
  anchorEl,
  isOpen,
  handleClose,
  fullWidth,
  menuWidth,
  MenuPaperProps,
  classes
}) {
  return /* @__PURE__ */ React25.createElement(NxDropdownButtonWrapper, {
    fullWidth,
    open: isOpen
  }, /* @__PURE__ */ React25.createElement(Menu, {
    anchorEl,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    classes: { paper: classes.paper, list: classes.list },
    getContentAnchorEl: null,
    keepMounted: true,
    onClose: handleClose,
    open: Boolean(anchorEl),
    PaperProps: __spreadValues({
      style: {
        width: fullWidth ? "100%" : menuWidth
      }
    }, MenuPaperProps),
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, menuItems.map((menuGroup) => /* @__PURE__ */ React25.createElement(Box8, {
    key: menuGroup.label || "menuGroup"
  }, menuGroup.label && /* @__PURE__ */ React25.createElement(NxTypography, {
    className: classes.menuGroupLabel,
    variant: "overline"
  }, menuGroup.label), menuGroup.items.map((item) => /* @__PURE__ */ React25.createElement(MenuItem, {
    key: item.label,
    className: clsx6(classes.menuItem, item == null ? void 0 : item.className),
    disabled: item.disabled,
    id: item == null ? void 0 : item.id,
    onClick: (e) => {
      handleClose(e);
      item.onClick();
    }
  }, /* @__PURE__ */ React25.createElement(Box8, {
    className: classes.menuItemLabel
  }, !!item.Icon && /* @__PURE__ */ React25.createElement(Box8, {
    className: classes.menuItemIcon
  }, /* @__PURE__ */ React25.createElement(item.Icon, null)), /* @__PURE__ */ React25.createElement(NxTypography, {
    variant: "body3"
  }, item.label)), item.isExternalLink && /* @__PURE__ */ React25.createElement(Box8, {
    className: classes.linkout
  }, /* @__PURE__ */ React25.createElement(Linkout2, null))))))));
}

// src/button/NxDropdownButton.tsx
function NxDropdownButton(_a) {
  var _b = _a, {
    label,
    variant,
    menuItems,
    loading = false,
    disabled,
    menuWidth,
    shouldUseOverlayColors,
    fullWidth,
    icon,
    menuBackgroundColor,
    labelIcon,
    MenuPaperProps,
    buttonOnClick
  } = _b, rest = __objRest(_b, [
    "label",
    "variant",
    "menuItems",
    "loading",
    "disabled",
    "menuWidth",
    "shouldUseOverlayColors",
    "fullWidth",
    "icon",
    "menuBackgroundColor",
    "labelIcon",
    "MenuPaperProps",
    "buttonOnClick"
  ]);
  const [anchorEl, setAnchorEl] = React26.useState(null);
  const isOpen = Boolean(anchorEl);
  const classes = useStyles20({
    shouldUseOverlayColors,
    fullWidth,
    isOpen,
    isIconButton: Boolean(icon),
    menuBackgroundColor
  });
  const handleClick = (event) => {
    if (buttonOnClick) {
      buttonOnClick();
    }
    event.stopPropagation();
    setAnchorEl(event.currentTarget.parentElement);
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const renderedLabel = labelIcon ? /* @__PURE__ */ React26.createElement("div", {
    className: classes.iconWrapper
  }, labelIcon, /* @__PURE__ */ React26.createElement(NxTypography, {
    color: "inherit",
    variant: "button"
  }, label), isOpen ? /* @__PURE__ */ React26.createElement(CarretUp, {
    color: "inherit"
  }) : /* @__PURE__ */ React26.createElement(CarretDown, {
    color: "inherit"
  })) : /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(NxTypography, {
    color: "inherit",
    variant: "button"
  }, label), isOpen ? /* @__PURE__ */ React26.createElement(CarretUp, {
    color: "inherit"
  }) : /* @__PURE__ */ React26.createElement(CarretDown, {
    color: "inherit"
  }));
  return /* @__PURE__ */ React26.createElement(Box9, {
    className: classes.dropdownContainer
  }, icon ? /* @__PURE__ */ React26.createElement(NxIconButton, __spreadProps(__spreadValues({
    disabled: loading || disabled,
    icon,
    label,
    onClick: isOpen ? handleClose : handleClick,
    variant
  }, rest), {
    className: classes.button
  })) : /* @__PURE__ */ React26.createElement(NxButtonBase, __spreadValues({
    className: classes.button,
    disabled: loading || disabled,
    fullWidth,
    onClick: isOpen ? handleClose : handleClick,
    variant: fullWidth && isOpen ? "text" : variant
  }, rest), /* @__PURE__ */ React26.createElement(Box9, {
    className: classes.buttonLabel
  }, loading ? /* @__PURE__ */ React26.createElement(LoadingSpinner, {
    color: "secondary",
    size: "small"
  }) : /* @__PURE__ */ React26.createElement(React26.Fragment, null, renderedLabel))), /* @__PURE__ */ React26.createElement(DropdownMenu, {
    anchorEl,
    classes,
    fullWidth,
    handleClose,
    isOpen,
    menuItems,
    MenuPaperProps,
    menuWidth
  }));
}

// src/button/NxComboButton.tsx
import React27 from "react";
import { Box as Box10, ButtonGroup, useTheme as useTheme7 } from "@material-ui/core";
import { CarretDown as CarretDown2, CarretUp as CarretUp2 } from "@playvs-inc/nexus-icons";
import clsx7 from "clsx";
function NxComboButton(_a) {
  var _b = _a, {
    label,
    variant = "secondary",
    menuItems,
    loading = false,
    disabled,
    menuWidth,
    shouldUseOverlayColors,
    fullWidth,
    menuBackgroundColor,
    labelIcon,
    MenuPaperProps,
    primaryOnClick,
    buttonOnClick,
    buttonGroupVariant = "outlined"
  } = _b, rest = __objRest(_b, [
    "label",
    "variant",
    "menuItems",
    "loading",
    "disabled",
    "menuWidth",
    "shouldUseOverlayColors",
    "fullWidth",
    "menuBackgroundColor",
    "labelIcon",
    "MenuPaperProps",
    "primaryOnClick",
    "buttonOnClick",
    "buttonGroupVariant"
  ]);
  const [anchorEl, setAnchorEl] = React27.useState(null);
  const isOpen = Boolean(anchorEl);
  const theme = useTheme7();
  const classes = useStyles20({
    shouldUseOverlayColors,
    fullWidth,
    isOpen,
    menuBackgroundColor
  });
  const handlePrimaryClick = (event) => {
    primaryOnClick == null ? void 0 : primaryOnClick(event);
    event.stopPropagation();
  };
  const handleDropdownClick = (event) => {
    buttonOnClick == null ? void 0 : buttonOnClick(event);
    event.stopPropagation();
    setAnchorEl(event.currentTarget.parentElement);
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  return /* @__PURE__ */ React27.createElement(Box10, {
    className: classes.dropdownContainer
  }, /* @__PURE__ */ React27.createElement(ButtonGroup, {
    disabled: loading || disabled,
    disableFocusRipple: true,
    disableRipple: true,
    variant: buttonGroupVariant
  }, /* @__PURE__ */ React27.createElement(NxButtonBase, __spreadValues({
    className: clsx7(classes.button),
    onClick: handlePrimaryClick,
    variant
  }, rest), loading ? /* @__PURE__ */ React27.createElement(LoadingSpinner, {
    color: "secondary",
    size: "small"
  }) : /* @__PURE__ */ React27.createElement(NxTypography, {
    color: "inherit",
    variant: "button"
  }, label)), /* @__PURE__ */ React27.createElement(NxButtonBase, {
    className: clsx7(classes.button, classes.comboButton),
    onClick: isOpen ? handleClose : handleDropdownClick,
    size: "small",
    variant
  }, isOpen ? /* @__PURE__ */ React27.createElement(CarretUp2, {
    color: disabled ? theme.palette.ColorTextDisabled : "inherit"
  }) : /* @__PURE__ */ React27.createElement(CarretDown2, {
    color: disabled ? theme.palette.ColorTextDisabled : "inherit"
  }))), /* @__PURE__ */ React27.createElement(DropdownMenu, {
    anchorEl,
    classes,
    fullWidth,
    handleClose,
    isOpen,
    menuItems,
    MenuPaperProps,
    menuWidth
  }));
}

// src/awards/seasonal-award/NxSeasonalAwardsTableCells.tsx
function HeaderCell({
  column
}) {
  const { classes } = column;
  return /* @__PURE__ */ React28.createElement(NxTypography, {
    className: classes.headerCell,
    variant: "overline"
  }, column.header);
}
function TeamCell({
  value,
  column
}) {
  const theme = useTheme8();
  const { classes } = column;
  return /* @__PURE__ */ React28.createElement(Box11, {
    display: "flex",
    height: "100%"
  }, /* @__PURE__ */ React28.createElement(Box11, {
    display: "flex",
    m: "auto 0",
    minWidth: 0
  }, /* @__PURE__ */ React28.createElement(Box11, {
    alignItems: "center",
    display: "flex",
    minWidth: 0
  }, /* @__PURE__ */ React28.createElement(NxEsportAvatar, {
    esport: value.esportSlug,
    iconHeight: 16,
    iconWidth: 16
  })), /* @__PURE__ */ React28.createElement(Box11, {
    className: classes.nameContainer,
    m: "auto 0",
    ml: theme.spacing(0.3),
    pr: theme.spacing(0.1)
  }, /* @__PURE__ */ React28.createElement(NxTypography, {
    className: classes.name,
    variant: "body1"
  }, value.name))));
}
function PlayerCell({
  value,
  column
}) {
  const theme = useTheme8();
  const { classes } = column;
  return /* @__PURE__ */ React28.createElement(Box11, {
    display: "flex"
  }, value.avatarUrl ? /* @__PURE__ */ React28.createElement(Avatar2, {
    alt: "avatar",
    className: column.classes.avatar,
    src: value.avatarUrl
  }) : /* @__PURE__ */ React28.createElement(NxRandomAvatar2, {
    hashId: value.id,
    height: 40,
    persona: "Firebob",
    width: 40
  }), /* @__PURE__ */ React28.createElement(Box11, {
    m: "auto 0",
    minWidth: 0,
    ml: theme.spacing(0.25),
    pr: theme.spacing(0.1)
  }, /* @__PURE__ */ React28.createElement(NxTypography, {
    className: classes.name,
    variant: "body2"
  }, value.name)));
}
function AwardCell({
  value,
  column,
  cell
}) {
  const [isHovering, setIsHovering] = useState3(false);
  if (value) {
    return /* @__PURE__ */ React28.createElement(Box11, {
      className: column.classes.awardContainer,
      display: "flex",
      flexDirection: "row",
      height: "100%",
      onMouseEnter: () => {
        setIsHovering(true);
      },
      onMouseLeave: () => {
        setIsHovering(false);
      },
      width: "100%"
    }, isHovering ? /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(NxButton, {
      label: "Edit",
      onClick: () => {
        var _a;
        (_a = column.eventHandler) == null ? void 0 : _a.call(column, {
          id: (value == null ? void 0 : value.id) || "",
          action: "edit" /* edit */
        });
      },
      variant: "text"
    }), /* @__PURE__ */ React28.createElement(NxButton, {
      label: "Delete",
      onClick: () => {
        var _a;
        (_a = column.eventHandler) == null ? void 0 : _a.call(column, {
          id: (value == null ? void 0 : value.id) || "",
          action: "delete" /* delete */
        });
      },
      variant: "text"
    })) : /* @__PURE__ */ React28.createElement(Box11, {
      m: "auto 0",
      mr: 1
    }, /* @__PURE__ */ React28.createElement(NxTypography, {
      variant: "body2"
    }, value == null ? void 0 : value.awardType.title)));
  }
  const rawData = cell.row.original;
  return /* @__PURE__ */ React28.createElement(Box11, {
    display: "flex",
    height: "100%",
    onClick: () => {
      var _a;
      (_a = column.eventHandler) == null ? void 0 : _a.call(column, {
        id: rawData.generatedId,
        action: "assign" /* assign */
      });
    },
    style: { cursor: "pointer" }
  }, /* @__PURE__ */ React28.createElement(Box11, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    m: "auto 0"
  }, /* @__PURE__ */ React28.createElement(AddteamHover, null), /* @__PURE__ */ React28.createElement(Box11, {
    ml: 1
  }, /* @__PURE__ */ React28.createElement(NxTypography, {
    colorToken: "ColorTextBase",
    variant: "button"
  }, "Nominate Player"))));
}
function ExportImageCell({
  value,
  column
}) {
  if (!value) {
    return null;
  }
  return /* @__PURE__ */ React28.createElement(Box11, {
    className: column.classes.exportImageContainer,
    onClick: () => {
      var _a;
      (_a = column.eventHandler) == null ? void 0 : _a.call(column, { id: value == null ? void 0 : value.id });
    }
  }, /* @__PURE__ */ React28.createElement(Box11, {
    m: "auto 0"
  }, /* @__PURE__ */ React28.createElement(Image, null)));
}
function ExportPdfCell({
  value,
  column
}) {
  if (!value) {
    return null;
  }
  return /* @__PURE__ */ React28.createElement(Box11, {
    className: column.classes.exportPdfContainer,
    onClick: () => {
      var _a;
      (_a = column.eventHandler) == null ? void 0 : _a.call(column, { id: value == null ? void 0 : value.id });
    }
  }, /* @__PURE__ */ React28.createElement(Box11, {
    m: "auto 0"
  }, /* @__PURE__ */ React28.createElement(Pdf, null)));
}

// src/awards/seasonal-award/NxSeasonalAwardsTable.tsx
function NxSeasonalAwardsTable({
  data,
  editAwardHandler,
  deleteAwardHandler,
  assignAwardHandler,
  generateImage,
  generatePdf
}) {
  const classes = useStyles9();
  const awardsColumns = useMemo(() => {
    const columns = [
      {
        accessor: "team",
        Header: HeaderCell,
        header: "Team(s)",
        Cell: TeamCell,
        width: 200,
        classes
      },
      {
        accessor: "player",
        Header: HeaderCell,
        header: "Player",
        Cell: PlayerCell,
        width: 200,
        classes
      },
      {
        id: "assign-award",
        accessor: "assignedAward",
        Header: HeaderCell,
        header: "Award",
        Cell: AwardCell,
        classes,
        width: 200,
        eventHandler: (eventData) => {
          switch (eventData.action) {
            case "edit" /* edit */:
              editAwardHandler(eventData.id);
              break;
            case "delete" /* delete */:
              deleteAwardHandler(eventData.id);
              break;
            default:
              assignAwardHandler(eventData.id);
              break;
          }
        }
      },
      {
        id: "export-image",
        accessor: "assignedAward",
        Header: HeaderCell,
        header: "Social Media",
        Cell: ExportImageCell,
        classes,
        maxWidth: 120,
        eventHandler: (eventData) => {
          generateImage(eventData.id);
        }
      },
      {
        id: "export-pdf",
        accessor: "assignedAward",
        Header: HeaderCell,
        header: "Certificate",
        Cell: ExportPdfCell,
        classes,
        maxWidth: 120,
        eventHandler: (eventData) => {
          generatePdf(eventData.id);
        }
      }
    ];
    return columns;
  }, [classes]);
  const awardsData = useMemo(() => data, [data]);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns: awardsColumns,
    data: awardsData
  }, useFlexLayout);
  return /* @__PURE__ */ React29.createElement(Box12, __spreadProps(__spreadValues({}, getTableProps()), {
    className: classes.table
  }), /* @__PURE__ */ React29.createElement(Box12, {
    className: classes.headerRow
  }, headerGroups.map((headerGroup) => /* @__PURE__ */ React29.createElement("div", __spreadValues({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column) => /* @__PURE__ */ React29.createElement("div", __spreadValues({
    "data-cy": column.id
  }, column.getHeaderProps()), column.render("Header")))))), /* @__PURE__ */ React29.createElement("div", __spreadProps(__spreadValues({}, getTableBodyProps()), {
    className: classes.tableGroup
  }), rows.map((row, i) => {
    prepareRow(row);
    return /* @__PURE__ */ React29.createElement("tr", __spreadValues({
      className: classes.tableRow,
      "data-cy": "scoreRaw"
    }, row.getRowProps()), row.cells.map((cell) => /* @__PURE__ */ React29.createElement("td", __spreadValues({}, cell.getCellProps()), cell.render("Cell"))));
  })));
}

// src/banners/NxEsportBanner/NxEsportBanner.tsx
import { Box as Box14, makeStyles as makeStyles26, useMediaQuery as useMediaQuery3, useTheme as useTheme10 } from "@material-ui/core";
import { useEsport as useEsport4 } from "@playvs-inc/nexus-theme";
import React35, { useMemo as useMemo2, useRef as useRef2 } from "react";

// src/personas/esports/esportPersona.helpers.ts
var EsportSlug = {
  LeagueOfLegends: "league-of-legends",
  RocketLeague: "rocket-league",
  Overwatch: "overwatch",
  Valorant: "valorant",
  Hearthstone: "hearthstone",
  Madden21PS4: "madden-21-ps4",
  Madden: "madden-21-solos-ps4",
  Madden21XboxOne: "madden-21-xbox-one",
  Madden21SolosXboxOne: "madden-21-solos-xbox-one",
  SmashBrosUltimate: "super-smash-bros-ultimate",
  SmashBrosUltimateSolos: "super-smash-bros-ultimate-solos",
  Splatoon: "splatoon-2",
  MarioKart: "mario-kart",
  NBA2K: "nba2k",
  FC: "ea-sports-fc",
  Chess: "chess",
  StreetFighter: "street-fighter",
  F1: "f1",
  Minecraft: "minecraft",
  Fortnite: "fortnite",
  Fortnite2: "fortnite-2",
  PokemonUnite: "pokemon-unite",
  CollegeFootball25: "college-football",
  ARAM: "aram",
  RocketLeagueGMA: "rocket-league-gma",
  RocketLeagueDuos: "rocket-league-duos",
  ChessKids: "chess-kids"
};
var esportTokenSlugMap = {
  [EsportSlug.LeagueOfLegends]: "LoL",
  [EsportSlug.Splatoon]: "Splatoon",
  [EsportSlug.MarioKart]: "Mk",
  [EsportSlug.NBA2K]: "NBA",
  [EsportSlug.Overwatch]: "OW",
  [EsportSlug.Valorant]: "Vlr",
  [EsportSlug.RocketLeague]: "RL",
  [EsportSlug.SmashBrosUltimate]: "SU",
  [EsportSlug.Hearthstone]: "HS",
  [EsportSlug.Madden]: "Madden",
  [EsportSlug.Madden21PS4]: "Madden",
  [EsportSlug.Madden21XboxOne]: "Madden",
  [EsportSlug.Madden21SolosXboxOne]: "Madden",
  [EsportSlug.FC]: "FC",
  [EsportSlug.Chess]: "Chess",
  [EsportSlug.StreetFighter]: "SF6",
  [EsportSlug.PokemonUnite]: "PU",
  [EsportSlug.F1]: "F1",
  [EsportSlug.Minecraft]: "MC",
  [EsportSlug.Fortnite]: "Fn",
  [EsportSlug.CollegeFootball25]: "CFB25",
  [EsportSlug.ARAM]: "ARAM"
};
var getEsportPaletteKey = (esportSlug, variant = "Base") => {
  const esportTokenSlug = esportSlug ? esportTokenSlugMap[esportSlug] : "";
  return `ColorEsportAccent${esportTokenSlug}${variant}`;
};
var getEsportColorValue = (theme, esportSlug, variant) => {
  const paletteKey = getEsportPaletteKey(esportSlug, variant);
  return theme.palette[paletteKey];
};
var slugToToken = (esportSlug) => esportTokenSlugMap[esportSlug] || "";
var composeEsportGradient = (esportSlug, theme) => {
  let tokenSlug = esportSlug ? esportTokenSlugMap[esportSlug] : "";
  if (!tokenSlug && esportSlug) {
    tokenSlug = esportSlug.charAt(0).toUpperCase() + esportSlug.slice(1);
  }
  const start = theme.palette[`ColorEsportGradient${tokenSlug}Start`];
  const end = theme.palette[`ColorEsportGradient${tokenSlug}End`];
  return { start, end };
};

// src/personas/esports/hearthstonePersona.ts
var hearthstonePersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/HearthstoneLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/HearthstoneLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/HearthstoneMatch.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/HearthstoneScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/HearthstoneStandings.jpg"
};

// src/personas/esports/leaguePersona.ts
var leaguePersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/LoLLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/LoLLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/LoLMatches.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/LoLScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/LoLStandings.jpg"
};

// src/personas/esports/maddenPersona.ts
var maddenPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Madden2K24League.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Madden2K24League.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Madden2K24Match.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Madden2K24Scrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Madden2K24Standings.jpg"
};

// src/personas/esports/marioKartPersona.ts
var marioKartPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/MarioKartLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/MarioKartLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/MarioKartMatch.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/MarioKartScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/MarioKartStandings.jpg"
};

// src/personas/esports/nbaPersona.ts
var nbaPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/NBA2K24League.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/NBA2K24League.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/NBA2K24Match.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/NBA2K24Scrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/NBA2K24Standings.jpg"
};

// src/personas/esports/overwatchPersona.ts
var overwatchPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/OverwatchLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/OverwatchLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/OverwatchMatch.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/OverwatchScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/OverwatchStandings.jpg"
};

// src/personas/esports/rocketLeaguePersona.ts
var rocketLeaguePersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/RLLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/RLLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/RLMatch.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/RLScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/RLStandings.jpg"
};

// src/personas/esports/smashBrosPersona.ts
var smashBrosPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/SmashLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/SmashLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/SmashMatch.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/SmashScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/SmashStandings.jpg"
};

// src/personas/esports/splatoonPersona.ts
var splatoonPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Splatoon3League.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Splatoon3League.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Splatoon3Match.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Splatoon3Scrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/Splatoon3Standings.jpg"
};

// src/personas/esports/playVsPersona.ts
var playVsPersona = {
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayvsExplore.jpg",
  schedule: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayvsSchedule.jpg",
  manage: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayvsManageTeams.jpg",
  "my-school": "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayvsMySchool.jpg",
  org: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayvsMySchool.jpg"
};

// src/personas/esports/valorantPersona.ts
var valorantPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/ValorantLeagueNew.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/ValorantLeagueNew.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/ValorantMatchNew.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/ValorantScrimmageNew.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/ValorantStandingsNew.jpg"
};

// src/personas/esports/fcPersona.ts
var fcPersona = {
  league: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/FCLeague.jpg",
  explore: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/FCLeague.jpg",
  match: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/FCMatch.jpg",
  scrimmage: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/FCScrimmage.jpg",
  standings: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/esports/FCStandings.jpg"
};

// src/personas/Personas.d.ts
var PersonaImageVariant = /* @__PURE__ */ ((PersonaImageVariant2) => {
  PersonaImageVariant2["League"] = "league";
  PersonaImageVariant2["Standings"] = "standings";
  PersonaImageVariant2["Match"] = "match";
  PersonaImageVariant2["Scrimmage"] = "scrimmage";
  PersonaImageVariant2["Explore"] = "explore";
  PersonaImageVariant2["Schedule"] = "schedule";
  PersonaImageVariant2["MySchool"] = "my-school";
  PersonaImageVariant2["ManageTeams"] = "manage";
  PersonaImageVariant2["Org"] = "org";
  PersonaImageVariant2["Resources"] = "resources";
  PersonaImageVariant2["Competitions"] = "competitions";
  PersonaImageVariant2["Product"] = "product";
  return PersonaImageVariant2;
})(PersonaImageVariant || {});
var PlayVsImageVariant = /* @__PURE__ */ ((PlayVsImageVariant2) => {
  PlayVsImageVariant2[PlayVsImageVariant2["explore"] = 0] = "explore";
  PlayVsImageVariant2[PlayVsImageVariant2["schedule"] = 1] = "schedule";
  PlayVsImageVariant2[PlayVsImageVariant2["my-school"] = 2] = "my-school";
  PlayVsImageVariant2[PlayVsImageVariant2["manage"] = 3] = "manage";
  PlayVsImageVariant2[PlayVsImageVariant2["resources"] = 4] = "resources";
  PlayVsImageVariant2[PlayVsImageVariant2["competitions"] = 5] = "competitions";
  PlayVsImageVariant2[PlayVsImageVariant2["product"] = 6] = "product";
  return PlayVsImageVariant2;
})(PlayVsImageVariant || {});

// src/personas/Persona.helpers.ts
import { capitalize as capitalize2 } from "@material-ui/core";
import {
  Leagueoflegends,
  Mariokart,
  Nba2K,
  Overwatch,
  Rocketleague,
  Smashbros,
  Madden2,
  Hearthstone,
  Valorant,
  Splatoon3,
  Fc,
  Chess
} from "@playvs-inc/nexus-icons";
var personaImagesMap = {
  [EsportSlug.LeagueOfLegends]: leaguePersona,
  [EsportSlug.Splatoon]: splatoonPersona,
  [EsportSlug.MarioKart]: marioKartPersona,
  [EsportSlug.NBA2K]: nbaPersona,
  [EsportSlug.Overwatch]: overwatchPersona,
  [EsportSlug.RocketLeague]: rocketLeaguePersona,
  [EsportSlug.SmashBrosUltimate]: smashBrosPersona,
  [EsportSlug.Madden]: maddenPersona,
  [EsportSlug.Madden21PS4]: maddenPersona,
  [EsportSlug.Madden21XboxOne]: maddenPersona,
  [EsportSlug.Madden21SolosXboxOne]: maddenPersona,
  [EsportSlug.Hearthstone]: hearthstonePersona,
  PlayVs: playVsPersona,
  [EsportSlug.Valorant]: valorantPersona,
  [EsportSlug.FC]: fcPersona
};
var variantSlugMap = __spreadProps(__spreadValues({}, PersonaImageVariant), {
  ["my-school" /* MySchool */]: "MySchool",
  ["org" /* Org */]: "MySchool"
});
var otherMap = __spreadProps(__spreadValues({}, PersonaImageVariant), {
  ["my-school" /* MySchool */]: "MySchool",
  org: "MySchool"
});
var esportLogoMap = {
  [EsportSlug.LeagueOfLegends]: Leagueoflegends,
  [EsportSlug.Splatoon]: Splatoon3,
  [EsportSlug.MarioKart]: Mariokart,
  [EsportSlug.NBA2K]: Nba2K,
  [EsportSlug.Overwatch]: Overwatch,
  [EsportSlug.Valorant]: Valorant,
  [EsportSlug.RocketLeague]: Rocketleague,
  [EsportSlug.SmashBrosUltimate]: Smashbros,
  [EsportSlug.Madden]: Madden2,
  [EsportSlug.Madden21PS4]: Madden2,
  [EsportSlug.Madden21XboxOne]: Madden2,
  [EsportSlug.Madden21SolosXboxOne]: Madden2,
  [EsportSlug.Hearthstone]: Hearthstone,
  [EsportSlug.FC]: Fc,
  [EsportSlug.Chess]: Chess
};
var variantToToken = (variant) => {
  const variantToken = variant in variantSlugMap ? variantSlugMap[variant] : capitalize2(variant);
  return variantToken;
};
var composePlayVsGradient = (variant, theme) => {
  const tokenSlug = variant ? variantToToken(variant) : "";
  const start = theme.palette[`ColorPlayVsGradient${tokenSlug}Start`];
  const end = theme.palette[`ColorPlayVsGradient${tokenSlug}End`];
  return { start, end };
};
var composePersonaGradient = (esportSlug, variant, theme) => {
  if (variant && variant in PlayVsImageVariant) {
    return composePlayVsGradient(variant, theme);
  }
  return composeEsportGradient(esportSlug, theme);
};
function getPersonaImageVariantByPath(pathname) {
  const variant = Object.values(variantSlugMap).find((value) => pathname.includes(value));
  return variant;
}

// src/banners/shared/constants.ts
var BANNER_MAX_WIDTH_PX = 1360;
var PATTERN_BANNER_URL = "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayVsPatternBanner.svg";
var PLAYVS_BANNER_GRADIENT_COLOR = "#505658";
var PATTERN_BANNER_GRADIENT_ENDS = "#010101";
var PATTERN_BANNER_GRADIENT_MID = "rgba(1, 1, 1, 0)";
var SCHEDULE_BANNER_GRADIENT_COLOR = "#383C3E";
var TOP_NAV_BAR_HEIGHT = 92;
var GRADIENT_MID_COLOR_EXCEPTIONS = {
  ["explore" /* Explore */.toString()]: "#00394d10"
};
var GRADIENT_END_COLOR_EXCEPTIONS = {
  ["resources" /* Resources */.toString()]: "#010101"
};

// src/banners/shared/useBannerOffsets.ts
import { useEffect as useEffect2, useLayoutEffect, useState as useState4 } from "react";
import { useDebounce } from "use-debounce";
var LAYOUT_RECALCULATE_DELAY_MS = 250;
function useBannerOffsets({
  bannerContainerRef,
  size,
  isMobile
}) {
  const [boundingBoxes, setBoundingBoxes] = useState4({});
  const [debouncedBoundingBoxes] = useDebounce(boundingBoxes, LAYOUT_RECALCULATE_DELAY_MS, {
    leading: true,
    trailing: true
  });
  const [componentState, setComponentState] = useState4({
    screenWidth: 0,
    backdropWidth: 0,
    offsetX: 0,
    offsetY: 0
  });
  useLayoutEffect(() => {
    const { body } = document;
    const resizeHandler = () => {
      var _a;
      const bannerBoundingBox = (_a = bannerContainerRef.current) == null ? void 0 : _a.getBoundingClientRect();
      const bodyBoundingBox = body.getBoundingClientRect();
      setBoundingBoxes({
        bannerBoundingBox,
        bodyBoundingBox
      });
    };
    if (!window.ResizeObserver) {
      return () => {
      };
    }
    const resizeObs = new ResizeObserver(() => resizeHandler());
    if (body) {
      resizeObs.observe(body);
      setTimeout(() => resizeHandler(), 10);
    }
    return () => {
      resizeObs.disconnect();
    };
  }, [size]);
  useEffect2(() => {
    var _a, _b, _c;
    const { bannerBoundingBox } = debouncedBoundingBoxes;
    const { bodyBoundingBox } = debouncedBoundingBoxes;
    if (!bannerBoundingBox || !bodyBoundingBox) {
      return;
    }
    const textContainer = (_a = bannerContainerRef.current) == null ? void 0 : _a.querySelector(".NxBanner__TextContainer");
    let textContainerHeight;
    if (textContainer) {
      const textContainerBoundingBox = textContainer.getBoundingClientRect();
      textContainerHeight = textContainerBoundingBox.height;
    }
    setComponentState({
      screenWidth: bodyBoundingBox.width,
      backdropWidth: (_b = bannerBoundingBox == null ? void 0 : bannerBoundingBox.width) != null ? _b : 0,
      offsetX: (_c = bannerBoundingBox == null ? void 0 : bannerBoundingBox.x) != null ? _c : 0,
      offsetY: isMobile ? 108 : 16,
      textContainerHeight
    });
  }, [debouncedBoundingBoxes]);
  return componentState;
}

// src/esport-card/NxEsportCard.tsx
import React34, { useState as useState5 } from "react";
import clsx10 from "clsx";
import { makeStyles as makeStyles25, useMediaQuery as useMediaQuery2, useTheme as useTheme9 } from "@material-ui/core";
import { useEsport as useEsport3 } from "@playvs-inc/nexus-theme";

// src/pill/NxOverlayPill.tsx
import React31 from "react";
import clsx8 from "clsx";
import { makeStyles as makeStyles23 } from "@material-ui/core";
import { colors as colors3 } from "@playvs-inc/nexus-core";
import { MUIThemeModeEnum as MUIThemeModeEnum3 } from "@playvs-inc/nexus-theme";

// src/pill/NxPillBase.tsx
import React30 from "react";
import { makeStyles as makeStyles22, Box as Box13 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles21 = makeStyles22((theme) => ({
  small: { padding: theme.spacing(0.5, 1.25) },
  medium: { padding: theme.spacing(0.5, 2.25) },
  large: { padding: theme.spacing(1.25, 3) }
}));
function PillBase({
  size,
  label,
  className,
  "data-cy": dataCy
}) {
  const classes = useStyles21();
  const renderedClassName = `${className} ${classes[size]} `;
  return /* @__PURE__ */ React30.createElement(Box13, {
    borderRadius: "100px",
    className: renderedClassName,
    "data-cy": dataCy,
    textAlign: "center",
    width: "fit-content"
  }, typeof label === "string" ? /* @__PURE__ */ React30.createElement(NxTypography, {
    color: "inherit",
    variant: "overline"
  }, label) : label);
}

// src/pill/NxOverlayPill.tsx
var useStyles22 = makeStyles23((theme) => ({
  disabled: {
    backgroundColor: theme.palette.OverlayColorBackgroundInactive,
    color: theme.palette.type === MUIThemeModeEnum3.Dark ? theme.palette.ColorTextInvert : theme.palette.ColorTextBase
  },
  error: {
    backgroundColor: theme.palette.OverlayColorBackgroundError,
    color: theme.palette.OverlayColorTextBase
  },
  info: {
    backgroundColor: theme.palette.OverlayColorBackgroundInfo,
    color: theme.palette.OverlayColorTextBase
  },
  success: {
    backgroundColor: theme.palette.OverlayColorBackgroundSuccess,
    color: theme.palette.type === MUIThemeModeEnum3.Dark ? theme.palette.ColorTextInvert : theme.palette.ColorTextBase
  },
  misc: {
    backgroundColor: theme.palette.OverlayColorBackgroundMisc,
    color: theme.palette.OverlayColorTextBase
  },
  warn: {
    backgroundColor: theme.palette.OverlayColorBackgroundWarn,
    color: theme.palette.type === MUIThemeModeEnum3.Dark ? theme.palette.ColorTextInvert : theme.palette.ColorTextBase
  },
  brand: {
    backgroundColor: colors3.PvsOrange[8],
    color: theme.palette.OverlayColorTextBase
  },
  inactive: {
    backgroundColor: theme.palette.OverlayColorBackgroundInactive,
    color: theme.palette.OverlayColorTextBase
  }
}));
function OverlayPill(_a) {
  var _b = _a, {
    variant,
    className,
    "data-cy": dataCy
  } = _b, rest = __objRest(_b, [
    "variant",
    "className",
    "data-cy"
  ]);
  const classes = useStyles22();
  return /* @__PURE__ */ React31.createElement(PillBase, __spreadValues({
    className: clsx8(classes[variant], className),
    "data-cy": dataCy
  }, rest));
}

// src/pill/NxPill.tsx
import React32 from "react";
import clsx9 from "clsx";
import { makeStyles as makeStyles24 } from "@material-ui/core";
import { colors as colors4 } from "@playvs-inc/nexus-core";
import { MUIThemeModeEnum as MUIThemeModeEnum4 } from "@playvs-inc/nexus-theme";
var useStyles23 = makeStyles24((theme) => ({
  disabled: {
    backgroundColor: theme.palette.ColorBackgroundAlt3,
    color: theme.palette.ColorTextAlt
  },
  error: {
    backgroundColor: theme.palette.ColorBackgroundError,
    color: theme.palette.ColorTextError
  },
  info: {
    backgroundColor: theme.palette.ColorBackgroundInfo,
    color: theme.palette.ColorTextInfo
  },
  success: {
    backgroundColor: theme.palette.ColorBackgroundSuccess,
    color: theme.palette.ColorTextSuccess
  },
  misc: {
    backgroundColor: theme.palette.ColorBackgroundMisc,
    color: theme.palette.ColorTextAccent
  },
  warn: {
    backgroundColor: theme.palette.ColorBackgroundWarn,
    color: theme.palette.ColorTextWarn
  },
  brand: {
    backgroundColor: colors4.PvsOrange[8],
    color: theme.palette.type === MUIThemeModeEnum4.Dark ? theme.palette.ColorTextBase : theme.palette.ColorTextInvert
  },
  inactive: {
    backgroundColor: theme.palette.ColorBackgroundInactive,
    color: theme.palette.ColorTextAlt
  }
}));
function Pill(_a) {
  var _b = _a, {
    variant,
    className,
    "data-cy": dataCy
  } = _b, rest = __objRest(_b, [
    "variant",
    "className",
    "data-cy"
  ]);
  const classes = useStyles23();
  return /* @__PURE__ */ React32.createElement(PillBase, __spreadValues({
    className: clsx9(classes[variant], className),
    "data-cy": dataCy
  }, rest));
}

// src/esport-card/EsportCard.helpers.tsx
import React33 from "react";
import { useEsport as useEsport2 } from "@playvs-inc/nexus-theme";
var useGetEsportsProps2 = (esportSlug, esportName) => {
  const esport = useEsport2(esportSlug);
  return {
    image: `https://s3.amazonaws.com/assets.playvs.com/esports/${esportSlug}/GameCard.webp`,
    titleBackgroundColor: (esport == null ? void 0 : esport.palette[6]) || "#000000",
    title: esportName || (esport == null ? void 0 : esport.name) || "unsupported",
    pills: [],
    icon: (props) => /* @__PURE__ */ React33.createElement(NxEsportIcon, __spreadValues({
      esportSlug,
      mode: "dark"
    }, props))
  };
};

// src/esport-card/NxEsportCard.tsx
var useStyles24 = makeStyles25((theme) => ({
  button: {
    border: "none",
    backgroundColor: "inherit",
    padding: 0
  },
  container: {
    display: "flex",
    height: "auto",
    width: "100%",
    borderRadius: theme.shape.borderRadius * 3,
    border: `1px solid ${theme.palette.BorderLight}`,
    overflow: "hidden",
    position: "relative",
    transition: "100ms ease",
    aspectRatio: "222 / 273",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      "&:hover": {
        transform: "scale(1.1)",
        flexDirection: "row-reverse",
        zIndex: 100
      }
    }
  },
  image: {
    objectFit: "cover",
    position: "absolute",
    height: "100%",
    width: "100%",
    borderRadius: theme.shape.borderRadius * 3
  },
  imageLoading: ({
    titleBackgroundColor
  }) => ({
    objectFit: "cover",
    position: "absolute",
    height: "100%",
    width: "100%",
    borderRadius: theme.shape.borderRadius * 3,
    background: titleBackgroundColor
  }),
  titleText: {
    marginLeft: theme.spacing(2),
    color: theme.palette.OverlayColorTextBase
  },
  title: ({
    titleBackgroundColor
  }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-end",
    zIndex: 1,
    height: 62,
    background: `${titleBackgroundColor}CC`,
    borderRadius: `0 0 ${theme.shape.borderRadius * 3} ${theme.shape.borderRadius * 3}`,
    textAlign: "start",
    [theme.breakpoints.up("sm")]: {
      height: 84
    }
  }),
  pillSuperContainer: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1,
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2)
  },
  pillContainer: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: theme.spacing(1),
    zIndex: 1,
    flexDirection: "column"
  }
}));
function NxEsportCard(_a) {
  var _b = _a, {
    className,
    esport: esportSlug,
    esportName,
    onClick,
    gameType,
    teamFormat,
    platforms = []
  } = _b, props = __objRest(_b, [
    "className",
    "esport",
    "esportName",
    "onClick",
    "gameType",
    "teamFormat",
    "platforms"
  ]);
  var _a2, _b2;
  const esport = useEsport3(esportSlug);
  const theme = useTheme9();
  const isMobile = useMediaQuery2(theme.breakpoints.down("xs"));
  const [loaded, setLoaded] = useState5(false);
  const [isHovering, setIsHovering] = useState5(false);
  const esportProps = useGetEsportsProps2(esportSlug, esportName);
  const classes = useStyles24({
    titleBackgroundColor: ((_a2 = esport == null ? void 0 : esport.palette) == null ? void 0 : _a2.baseColor) || esportProps.titleBackgroundColor
  });
  const handleMouseEnter = () => {
    if (isMobile) {
      return;
    }
    setIsHovering(true);
  };
  const handleMouseLeave = () => {
    if (isMobile) {
      return;
    }
    setIsHovering(false);
  };
  const gameTypePill = gameType || esportProps.pills[0];
  const teamFormatDisplay = teamFormat === 1 ? "Solo" : `${teamFormat} Players`;
  const teamFormatPill = teamFormat ? teamFormatDisplay : esportProps.pills[1];
  const platformsPill = (platforms == null ? void 0 : platforms.length) && (platforms == null ? void 0 : platforms.join(", ")) || esportProps.pills[2];
  return /* @__PURE__ */ React34.createElement("button", __spreadValues({
    className: clsx10(classes.button, className),
    onClick,
    type: "button"
  }, props), /* @__PURE__ */ React34.createElement("div", {
    className: classes.container,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /* @__PURE__ */ React34.createElement("img", {
    alt: (_b2 = esport == null ? void 0 : esport.name) != null ? _b2 : esportName,
    className: loaded ? classes.image : classes.imageLoading,
    onLoad: () => setLoaded(true),
    src: esportProps.image
  }), isHovering ? /* @__PURE__ */ React34.createElement("div", {
    className: classes.pillSuperContainer
  }, gameTypePill && /* @__PURE__ */ React34.createElement("div", {
    className: classes.pillContainer
  }, /* @__PURE__ */ React34.createElement(OverlayPill, {
    label: gameTypePill,
    size: "small",
    variant: "disabled"
  })), teamFormatPill && /* @__PURE__ */ React34.createElement("div", {
    className: classes.pillContainer
  }, /* @__PURE__ */ React34.createElement(OverlayPill, {
    label: teamFormatPill,
    size: "small",
    variant: "disabled"
  })), platformsPill && /* @__PURE__ */ React34.createElement("div", {
    className: classes.pillContainer
  }, /* @__PURE__ */ React34.createElement(OverlayPill, {
    label: platformsPill,
    size: "small",
    variant: "disabled"
  })), (platforms == null ? void 0 : platforms.length) > 1 && /* @__PURE__ */ React34.createElement("div", {
    className: classes.pillContainer
  }, /* @__PURE__ */ React34.createElement(OverlayPill, {
    label: "Crossplay",
    size: "small",
    variant: "disabled"
  })), esportProps.pills[3] && /* @__PURE__ */ React34.createElement("div", {
    className: classes.pillContainer
  }, /* @__PURE__ */ React34.createElement(OverlayPill, {
    label: esportProps.pills[3],
    size: "small",
    variant: "disabled"
  }))) : /* @__PURE__ */ React34.createElement("div", {
    className: classes.title
  }, /* @__PURE__ */ React34.createElement(NxTypography, {
    className: classes.titleText,
    style: { fontWeight: 600 },
    variant: isMobile ? "h4" : "h2"
  }, esportProps.title || esportName))));
}

// src/banners/NxEsportBanner/NxEsportBanner.helpers.ts
import { capitalize as capitalize3 } from "@material-ui/core";
var getEsportBanner = (esportSlug, variant, overlay = false) => {
  const capitalizedVariant = capitalize3(variant);
  const filename = capitalizedVariant + (overlay ? "Overlay" : "");
  return `https://s3.amazonaws.com/assets.playvs.com/esports/${esportSlug}/${filename}.webp`;
};

// src/banners/shared/helpers.ts
var getBackdropTop = ({
  isMobileView,
  hasNoTopNavBar,
  bannerOffsetY
}) => {
  if (isMobileView) {
    return hasNoTopNavBar ? 0 : -1 - bannerOffsetY + TOP_NAV_BAR_HEIGHT;
  }
  return -1 - bannerOffsetY;
};
var getGradientColors = ({
  isMobileView,
  shouldUseDefaultStyle,
  variant
}) => {
  var _a, _b;
  let gradientMidColor = shouldUseDefaultStyle ? (_a = GRADIENT_MID_COLOR_EXCEPTIONS[variant]) != null ? _a : PATTERN_BANNER_GRADIENT_MID : "rgba(0, 57, 77, 0)";
  let gradientEndColor = shouldUseDefaultStyle ? (_b = GRADIENT_END_COLOR_EXCEPTIONS[variant]) != null ? _b : PATTERN_BANNER_GRADIENT_ENDS : PLAYVS_BANNER_GRADIENT_COLOR;
  if (isMobileView && variant === "resources" /* Resources */) {
    gradientMidColor = SCHEDULE_BANNER_GRADIENT_COLOR;
    gradientEndColor = SCHEDULE_BANNER_GRADIENT_COLOR;
  }
  return { gradientMidColor, gradientEndColor };
};

// src/banners/NxEsportBanner/NxEsportBanner.tsx
var useStyles25 = makeStyles26((theme) => ({
  widgetContainerMobile: {
    "&>div": {
      width: "100%"
    }
  },
  esportWatermark: ({ hasNoTopNavBar }) => ({
    top: hasNoTopNavBar ? 0 : -theme.spacing(4),
    right: -theme.spacing(3),
    "&>svg path": {
      fill: theme.palette.OverlayBorderLight
    },
    "&>svg": {
      height: 163,
      width: "auto",
      maxHeight: 163
    }
  }),
  breadcrumbs: {
    position: "relative",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
    [theme.breakpoints.up("sm")]: {
      position: "absolute",
      top: 40,
      marginBottom: theme.spacing(0),
      marginTop: theme.spacing(0)
    }
  },
  subtitle: {
    marginTop: theme.spacing(2)
  }
}));
function NxEsportBanner({
  size,
  esportSlug,
  variant,
  title,
  subtitle,
  widget,
  avatar,
  additionalContent,
  aboveTitleContent,
  useOverlayImage,
  breadcrumbs,
  hasNoTopNavBar,
  sponsorLogo,
  rightSideSponsorLogo,
  mobileRightSideSponsorLogo,
  shouldUseGradient = true,
  hideWatermark = false
}) {
  var _a, _b, _c;
  const theme = useTheme10();
  const isMobileView = useMediaQuery3(theme.breakpoints.down("xs"));
  const isTabletView = useMediaQuery3(theme.breakpoints.down("sm"));
  const esport = useEsport4(esportSlug);
  const classes = useStyles25({ hasNoTopNavBar });
  const bannerContainerRef = useRef2(null);
  const bannerOffsets = useBannerOffsets({
    size,
    bannerContainerRef,
    isMobile: isMobileView
  });
  const esportProps = useGetEsportsProps2(esportSlug);
  const EsportIconComponent = esportProps.icon;
  let bannerPortionHeight = size === "large" ? "376px" : "264px";
  if (isMobileView) {
    bannerPortionHeight = "unset";
  }
  let backdropHeight = `calc(max-content + ${bannerOffsets.offsetY + 1}px)`;
  if (!isMobileView) {
    backdropHeight = `${bannerOffsets.offsetY + (size === "large" ? 376 : 264) + 1}px`;
  }
  const mobileBackdropHeightNumber = Math.floor((_a = bannerOffsets.textContainerHeight) != null ? _a : 0) + 1 + (breadcrumbs ? theme.spacing(13) : theme.spacing(8));
  const mobileBackdropHeight = `calc(${mobileBackdropHeightNumber}px)`;
  const mobileBackdropHeightTotal = `calc(${mobileBackdropHeightNumber + (mobileRightSideSponsorLogo ? 56 : 0)}px)`;
  const backdropLeft = -1 - bannerOffsets.offsetX;
  const backdropTop = getBackdropTop({
    isMobileView,
    hasNoTopNavBar,
    bannerOffsetY: bannerOffsets.offsetY
  });
  let gradientStartColor = (_b = esport == null ? void 0 : esport.palette) == null ? void 0 : _b.gradientStart;
  let gradientEndColor = (_c = esport == null ? void 0 : esport.palette) == null ? void 0 : _c.gradientEnd;
  if (widget) {
    gradientStartColor = PATTERN_BANNER_GRADIENT_ENDS;
    gradientEndColor = PATTERN_BANNER_GRADIENT_ENDS;
  }
  const gradientBackground = shouldUseGradient ? `linear-gradient(0.25turn, ${gradientStartColor} 11%, rgba(0, 57, 77, 0) 51.89%, ${gradientEndColor} 85.92%)` : void 0;
  const expandedBackground = shouldUseGradient ? `linear-gradient(0.25turn, ${gradientStartColor} 40%, rgba(0, 57, 77, 0) 50%, ${gradientEndColor} 55%)` : void 0;
  const backdropImage = useMemo2(() => {
    if (widget) {
      return PATTERN_BANNER_URL;
    }
    return getEsportBanner(esportSlug, variant, useOverlayImage);
  }, [esportSlug, variant, useOverlayImage]);
  return /* @__PURE__ */ React35.createElement(Box14, __spreadProps(__spreadValues({}, { ref: bannerContainerRef }), {
    alignItems: !(isMobileView || !title) ? "center" : "flex-start",
    display: "flex",
    flexDirection: isMobileView ? "column" : "row",
    height: bannerPortionHeight,
    justifyContent: "space-between",
    maxWidth: isMobileView ? "100%" : `${BANNER_MAX_WIDTH_PX}px`,
    minHeight: isMobileView ? mobileBackdropHeightTotal : "unset",
    overflow: "visible",
    position: "relative",
    width: "100%"
  }), !!breadcrumbs && /* @__PURE__ */ React35.createElement(Box14, {
    className: classes.breadcrumbs
  }, breadcrumbs), /* @__PURE__ */ React35.createElement(Box14, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    gridGap: "1em",
    width: isMobileView ? "100%" : "unset"
  }, avatar, /* @__PURE__ */ React35.createElement(Box14, {
    className: "NxBanner__TextContainer",
    color: "OverlayColorTextBase",
    "data-testid": "NxEsportBanner__TextContainer",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gridGap: isMobileView ? theme.spacing(1) : theme.spacing(2),
    justifyContent: "center",
    px: isMobileView && !avatar ? [0, 2] : 0,
    width: isMobileView ? "100%" : "unset",
    zIndex: 1
  }, !!aboveTitleContent && aboveTitleContent, /* @__PURE__ */ React35.createElement(Box14, {
    display: "flex",
    flexDirection: "row",
    justifyContent: isMobileView ? "space-between" : "unset"
  }, sponsorLogo && !isMobileView && /* @__PURE__ */ React35.createElement(Box14, {
    mr: 2
  }, sponsorLogo), /* @__PURE__ */ React35.createElement(Box14, null, title && /* @__PURE__ */ React35.createElement(NxTypography, {
    colorToken: "OverlayColorTextBase",
    variant: isMobileView ? "display3" : "display"
  }, title), subtitle && (typeof subtitle === "string" ? /* @__PURE__ */ React35.createElement(NxTypography, {
    className: classes.subtitle,
    colorToken: "OverlayColorTextBase",
    variant: isMobileView ? "body1" : "subtitle1"
  }, subtitle) : subtitle)), sponsorLogo && isMobileView && /* @__PURE__ */ React35.createElement(Box14, {
    ml: 1
  }, sponsorLogo)), !!additionalContent && /* @__PURE__ */ React35.createElement(Box14, {
    color: "OverlayColorTextBase"
  }, additionalContent))), widget && size !== "small" && /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(Box14, {
    "data-testid": "NxEsportBanner__WidgetContainer",
    display: { xs: "none", md: "flex" },
    flexDirection: "row",
    flexGrow: 0,
    py: 2,
    zIndex: 1
  }, widget), /* @__PURE__ */ React35.createElement(Box14, {
    className: `NxEsportBanner__WidgetContainer ${isMobileView ? classes.widgetContainerMobile : ""}`,
    "data-testid": "NxEsportBanner__WidgetContainer",
    display: { xs: "flex", md: "none" },
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "center",
    py: 2,
    zIndex: 1
  }, widget)), !isMobileView && rightSideSponsorLogo && /* @__PURE__ */ React35.createElement(Box14, {
    alignSelf: "flex-end",
    display: "flex",
    flexDirection: "column",
    mb: 3
  }, /* @__PURE__ */ React35.createElement(Box14, {
    alignSelf: "center"
  }, rightSideSponsorLogo)), !isMobileView && /* @__PURE__ */ React35.createElement(Box14, {
    "data-testid": "NxEsportBanner__BackdropImage",
    height: backdropHeight,
    left: isTabletView ? 0 : -296,
    position: "absolute",
    style: {
      backgroundImage: `url(${backdropImage})`,
      backgroundSize: "auto 100%",
      backgroundPositionY: "center",
      backgroundPositionX: `center`,
      backgroundRepeat: "no-repeat",
      backgroundColor: shouldUseGradient ? gradientEndColor : void 0,
      maxWidth: "1360px",
      width: bannerOffsets.screenWidth + 2
    },
    top: backdropTop,
    zIndex: -2
  }), /* @__PURE__ */ React35.createElement(Box14, {
    "data-testid": "NxEsportBanner__ExtendedBackdrop",
    height: isMobileView ? mobileBackdropHeight : backdropHeight,
    left: isTabletView ? -16 : -296,
    position: "absolute",
    style: {
      backgroundImage: !isMobileView && shouldUseGradient ? gradientBackground : void 0,
      backgroundColor: isMobileView && shouldUseGradient ? gradientEndColor : void 0,
      backgroundRepeat: "no-repeat",
      width: bannerOffsets.screenWidth + 2,
      maxWidth: "1360px"
    },
    top: backdropTop,
    zIndex: -1
  }), /* @__PURE__ */ React35.createElement(Box14, {
    "data-testid": "NxEsportBanner__ExtendedBackdrop__Background",
    height: isMobileView ? mobileBackdropHeight : backdropHeight,
    left: isMobileView ? -16 : backdropLeft,
    position: "absolute",
    style: {
      backgroundColor: shouldUseGradient ? gradientEndColor : void 0,
      backgroundImage: isMobileView ? void 0 : expandedBackground,
      width: bannerOffsets.screenWidth + 2
    },
    top: backdropTop,
    zIndex: -3
  }), isMobileView && EsportIconComponent && !hideWatermark && !sponsorLogo && /* @__PURE__ */ React35.createElement(Box14, {
    className: classes.esportWatermark,
    "data-testid": "NxEsportBanner__EsportWatermark",
    position: "absolute",
    right: "0",
    top: "0",
    zIndex: -1
  }, /* @__PURE__ */ React35.createElement(EsportIconComponent, null)), isMobileView && mobileRightSideSponsorLogo && /* @__PURE__ */ React35.createElement(Box14, {
    maxWidth: "1360px",
    ml: -2,
    position: "absolute",
    top: mobileBackdropHeight,
    width: bannerOffsets.screenWidth + 2
  }, mobileRightSideSponsorLogo));
}

// src/banners/NxPlayVsBanner/NxPlayVsBanner.tsx
import React36, { useRef as useRef3 } from "react";
import { Box as Box15, makeStyles as makeStyles27, useMediaQuery as useMediaQuery4, useTheme as useTheme11 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";

// src/banners/NxPlayVsBanner/playvs-banner-image-map.ts
var playvsImageMap = {
  ["my-school" /* MySchool */]: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/playvs/MySchool.jpg",
  ["schedule" /* Schedule */]: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/playvs/Schedule.jpg",
  ["manage" /* ManageTeams */]: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/playvs/Manage+Teams.jpg",
  ["explore" /* Explore */]: "https://s3.amazonaws.com/assets.playvs.com/nexus-ui-assets/banners/playvs/Explore.jpg",
  ["resources" /* Resources */]: "https://s3.amazonaws.com/assets.playvs.com/nexus-personas/PlayVsPatternBanner.svg",
  ["competitions" /* Competitions */]: "https://s3.amazonaws.com/assets.playvs.com/stadium/StadiumCompetitionsBanner.jpg"
};

// src/banners/NxPlayVsBanner/NxPlayVsBanner.tsx
var useStyles26 = makeStyles27(() => ({
  widgetContainerMobile: {
    "&>div": {
      width: "100%"
    }
  }
}));
function NxPlayVsBanner({
  size,
  variant,
  title,
  subtitle,
  widget,
  avatar,
  additionalContent,
  rightContent,
  shouldUseDefaultBanner = false,
  hasNoTopNavBar,
  customContent,
  shouldUseGradient = true
}) {
  var _a, _b;
  const theme = useTheme11();
  const isMobileView = useMediaQuery4(theme.breakpoints.down("xs"));
  const isCustomContent = !!customContent;
  const classes = useStyles26();
  const bannerContainerRef = useRef3(null);
  const bannerOffsets = useBannerOffsets({
    size,
    bannerContainerRef,
    isMobile: isMobileView
  });
  let bannerPortionHeight = size === "large" ? "376px" : "264px";
  if (isMobileView) {
    bannerPortionHeight = "unset";
  }
  let backdropHeight = `calc(max-content + ${bannerOffsets.offsetY + 1}px)`;
  if (!isMobileView) {
    backdropHeight = `${bannerOffsets.offsetY + (size === "large" ? 376 : 264) + 1}px`;
  }
  const mobileBackdropHeight = isCustomContent ? "238px" : `calc(${Math.floor((_a = bannerOffsets.textContainerHeight) != null ? _a : 0) + 1 + theme.spacing(8)}px)`;
  const backdropTop = getBackdropTop({
    hasNoTopNavBar,
    isMobileView,
    bannerOffsetY: bannerOffsets.offsetY
  });
  const backdropLeft = -1 - bannerOffsets.offsetX;
  const shouldUseDefaultStyle = !!widget || shouldUseDefaultBanner || isCustomContent;
  const gradients = getGradientColors({
    isMobileView,
    shouldUseDefaultStyle,
    variant
  });
  const { gradientMidColor, gradientEndColor } = gradients;
  const backgroundColor = shouldUseGradient ? gradientEndColor : "";
  const gradientBackground = `linear-gradient(89.44deg, ${gradientEndColor} 13.7%, ${gradientMidColor} 69.93%, ${gradientEndColor} 99.33%)`;
  let backdropImage = (_b = playvsImageMap[variant]) != null ? _b : "";
  if (widget || shouldUseDefaultBanner) {
    backdropImage = PATTERN_BANNER_URL;
  } else if (!backdropImage) {
    backdropImage = playvsImageMap["my-school" /* MySchool */];
  }
  const shouldShowRightContent = Boolean(!widget && !!rightContent);
  return /* @__PURE__ */ React36.createElement(Box15, __spreadProps(__spreadValues({
    "data-testid": "NxPlayVsBanner__Container"
  }, { ref: bannerContainerRef }), {
    alignItems: !isMobileView ? "center" : "flex-start",
    display: "flex",
    flexDirection: isMobileView ? "column" : "row",
    height: bannerPortionHeight,
    justifyContent: "space-between",
    maxWidth: isMobileView ? "100%" : `${BANNER_MAX_WIDTH_PX}px`,
    minHeight: isMobileView ? mobileBackdropHeight : "unset",
    overflow: "visible",
    position: "relative",
    width: "100%"
  }), customContent, /* @__PURE__ */ React36.createElement(Box15, {
    alignItems: isMobileView ? "flex-start" : "center",
    "data-testid": "NxPlayVsBanner__ContentBox",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    gridGap: "1em"
  }, avatar, /* @__PURE__ */ React36.createElement(Box15, {
    className: "NxBanner__TextContainer",
    color: "OverlayColorTextBase",
    "data-testid": "NxPlayVsBanner__TextContainer",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gridGap: isMobileView ? theme.spacing(1) : theme.spacing(2),
    justifyContent: "center",
    px: isMobileView && !avatar ? [0, 2] : 0,
    zIndex: 1
  }, typeof title === "string" ? /* @__PURE__ */ React36.createElement(NxTypography, {
    colorToken: "OverlayColorTextBase",
    variant: isMobileView ? "display3" : "display"
  }, title) : title, subtitle && (typeof subtitle === "string" ? /* @__PURE__ */ React36.createElement(NxTypography, {
    colorToken: "OverlayColorTextBase",
    variant: isMobileView ? "body1" : "subtitle1"
  }, subtitle) : subtitle), !!additionalContent && /* @__PURE__ */ React36.createElement(Box15, {
    color: "OverlayColorTextBase"
  }, additionalContent))), widget && size !== "small" && /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(Box15, {
    "data-testid": "NxPlayVsBanner__WidgetContainer",
    display: { xs: "none", md: "flex" },
    flexDirection: "row",
    flexGrow: 0,
    py: 2,
    zIndex: 1
  }, widget), /* @__PURE__ */ React36.createElement(Box15, {
    className: `NxPlayVsBanner__WidgetContainer ${isMobileView ? classes.widgetContainerMobile : ""}`,
    "data-testid": "NxPlayVsBanner__WidgetContainer",
    display: { xs: "flex", md: "none" },
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "center",
    py: 2,
    zIndex: 1
  }, widget)), shouldShowRightContent && /* @__PURE__ */ React36.createElement(Box15, {
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
    zIndex: 1
  }, rightContent), isMobileView && /* @__PURE__ */ React36.createElement(Box15, {
    "data-testid": "NxPlayVsBanner__BackdropImageAndExtendedBackgroundDesktopMobile",
    height: mobileBackdropHeight,
    left: backdropLeft,
    position: "absolute",
    style: {
      backgroundSize: "auto 100%",
      backgroundPositionY: "center",
      backgroundPositionX: `${bannerOffsets.offsetX - 1}px`,
      backgroundRepeat: "no-repeat",
      backgroundColor
    },
    top: backdropTop,
    width: bannerOffsets.screenWidth + 2,
    zIndex: -2
  }), !isMobileView && /* @__PURE__ */ React36.createElement(Box15, {
    "data-testid": "NxPlayVsBanner__BackdropImageAndExtendedBackgroundDesktop",
    height: backdropHeight,
    left: backdropLeft,
    position: "absolute",
    style: {
      background: `url(${backdropImage})`,
      backgroundSize: "auto 100%",
      backgroundPositionY: "center",
      backgroundPositionX: widget ? "center" : "80%",
      backgroundRepeat: widget ? "repeat" : "no-repeat",
      backgroundColor
    },
    top: backdropTop,
    width: bannerOffsets.screenWidth + 2,
    zIndex: -2
  }), shouldUseGradient && /* @__PURE__ */ React36.createElement(Box15, {
    "data-testid": "NxPlayVsBanner__GradientOverlay",
    height: isMobileView ? mobileBackdropHeight : backdropHeight,
    left: backdropLeft,
    position: "absolute",
    style: {
      background: isMobileView ? gradientEndColor : gradientBackground,
      backgroundRepeat: "no-repeat"
    },
    top: backdropTop,
    width: bannerOffsets.screenWidth + 2,
    zIndex: -1
  }));
}

// src/breadcrumbs/NxBreadcrumbs.tsx
import React37 from "react";
import { Breadcrumbs as MuiBreadcrumbs, makeStyles as makeStyles28 } from "@material-ui/core";
import { CaretRight } from "@playvs-inc/nexus-icons";
import "@playvs-inc/nexus-theme";
var useStyles27 = makeStyles28((theme) => ({
  breadcrumbWrapper: {
    display: "flex",
    alignItems: "center"
  },
  link: ({ useOverlayColor }) => ({
    cursor: "pointer",
    color: useOverlayColor ? theme.palette.OverlayColorTextBase : theme.palette.ColorTextBase,
    "&:hover": {
      color: useOverlayColor ? theme.palette.OverlayColorTextBase : theme.palette.ColorTextLink
    }
  }),
  separator: ({
    useOverlayColor
  }) => ({
    color: useOverlayColor ? theme.palette.OverlayColorTextBase : theme.palette.ColorTextBase
  }),
  ol: {
    "& li:last-child p": {
      pointerEvents: "none"
    }
  }
}));
function NxBreadcrumbs(_a) {
  var _b = _a, {
    breadcrumbs,
    maxItems = 4,
    separator,
    useOverlayColor = false
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "maxItems",
    "separator",
    "useOverlayColor"
  ]);
  const classes = useStyles27({ useOverlayColor });
  const sep = separator || /* @__PURE__ */ React37.createElement(CaretRight, {
    className: classes.separator,
    fontSize: "small"
  });
  return /* @__PURE__ */ React37.createElement(MuiBreadcrumbs, __spreadValues({
    classes: { ol: classes.ol },
    maxItems,
    separator: sep
  }, rest), breadcrumbs.map((breadcrumb) => /* @__PURE__ */ React37.createElement("div", {
    key: breadcrumb.label,
    className: classes.breadcrumbWrapper
  }, breadcrumb.icon, /* @__PURE__ */ React37.createElement(NxTypography, {
    className: classes.link,
    onClick: breadcrumb.onClick,
    variant: "body3"
  }, breadcrumb.label))));
}

// src/cards/NxHeaderCard.tsx
import React40 from "react";
import { Box as Box18, makeStyles as makeStyles30, useTheme as useTheme14 } from "@material-ui/core";
import clsx11 from "clsx";
import { InfoOutlined as InfoOutlined2 } from "@playvs-inc/nexus-icons";

// src/cards/NxHeaderCardAlert.tsx
import React39 from "react";
import { Box as Box17, useTheme as useTheme13 } from "@material-ui/core";
import { Close as Close2 } from "@playvs-inc/nexus-icons";

// src/firebob-message/NxFirebobMessage.tsx
import React38 from "react";
import { Box as Box16, makeStyles as makeStyles29, useTheme as useTheme12 } from "@material-ui/core";
import { NxMiscAssets } from "@playvs-inc/nexus-misc-assets";
var useStyles28 = makeStyles29((theme) => ({
  firebob: {
    transform: "scaleX(-1)",
    height: 32,
    width: 32
  },
  message: {
    borderRadius: theme.mixins.cornerRadius["border-radius-4"],
    background: theme.palette.ColorBackgroundTooltip,
    padding: theme.spacing(0.5, 1)
  },
  arrow: {
    "&:after": {
      content: '""',
      position: "absolute",
      right: "100%",
      top: "50%",
      height: 0,
      width: 0,
      marginTop: -theme.spacing(1),
      border: "solid transparent",
      borderRightColor: theme.palette.ColorBackgroundTooltip,
      borderWidth: theme.spacing(0.5)
    }
  }
}));
function NxFirebobMessage({
  message,
  Firebob: Firebob2 = NxMiscAssets.Firebob17,
  emoteKey,
  onMouseEnter,
  onMouseLeave
}) {
  const classes = useStyles28();
  const theme = useTheme12();
  return /* @__PURE__ */ React38.createElement(Box16, {
    alignItems: "center",
    display: "flex",
    gridGap: theme.spacing(0.5),
    onMouseEnter,
    onMouseLeave,
    width: "fit-content"
  }, emoteKey ? /* @__PURE__ */ React38.createElement(Box16, {
    alignItems: "center",
    display: "flex",
    mr: 0.5
  }, /* @__PURE__ */ React38.createElement(NxEmote, {
    emoteKey,
    height: 24,
    width: 24
  })) : /* @__PURE__ */ React38.createElement(Firebob2, {
    className: classes.firebob
  }), /* @__PURE__ */ React38.createElement(Box16, {
    position: "relative"
  }, /* @__PURE__ */ React38.createElement(Box16, {
    className: classes.arrow
  }), /* @__PURE__ */ React38.createElement(Box16, {
    className: classes.message
  }, /* @__PURE__ */ React38.createElement(NxTypography, {
    colorToken: "OverlayColorTextBase",
    variant: "body1"
  }, message))));
}

// src/cards/NxHeaderCardAlert.tsx
function NxHeaderCardAlert({
  title,
  subtitle,
  content,
  actions,
  onClose,
  showCloseButton = true,
  firebobMessage,
  firebobSubtitle
}) {
  const theme = useTheme13();
  const renderContent = () => typeof content === "string" ? /* @__PURE__ */ React39.createElement(NxTypography, {
    variant: "body3"
  }, content) : content;
  return /* @__PURE__ */ React39.createElement(Box17, {
    bgcolor: "ColorBackgroundBase",
    boxShadow: theme.mixins.boxShadow.elevation4,
    display: "flex",
    flexDirection: "column",
    p: 3
  }, /* @__PURE__ */ React39.createElement(Box17, {
    display: "flex",
    flexDirection: "column",
    gridGap: theme.spacing(1)
  }, /* @__PURE__ */ React39.createElement(Box17, {
    display: "flex",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React39.createElement(NxTypography, {
    variant: "h2"
  }, title), showCloseButton && /* @__PURE__ */ React39.createElement(NxIconButton, {
    icon: /* @__PURE__ */ React39.createElement(Close2, null),
    label: "",
    onClick: onClose,
    variant: "text"
  })), subtitle && /* @__PURE__ */ React39.createElement(NxTypography, {
    variant: "body1"
  }, subtitle)), content && renderContent(), /* @__PURE__ */ React39.createElement(Box17, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gridGap: theme.spacing(1),
    justifyContent: "flex-end",
    my: 2
  }, firebobMessage ? /* @__PURE__ */ React39.createElement(NxFirebobMessage, {
    message: firebobMessage
  }) : null, firebobSubtitle && /* @__PURE__ */ React39.createElement(NxTypography, {
    variant: "body1"
  }, firebobSubtitle)), actions && /* @__PURE__ */ React39.createElement(Box17, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gridGap: theme.spacing(2),
    justifyContent: "flex-end"
  }, actions));
}

// src/cards/NxHeaderCard.tsx
var useStyles29 = makeStyles30((theme) => ({
  container: {
    borderRadius: theme.mixins.cornerRadius["border-radius-10"],
    position: "relative"
  },
  header: ({
    hasSideAction
  }) => ({
    height: "85px",
    padding: hasSideAction ? theme.spacing(2.5, 0, 2.5, 3) : theme.spacing(2.5, 3),
    borderTopRightRadius: theme.mixins.cornerRadius["border-radius-10"],
    borderTopLeftRadius: theme.mixins.cornerRadius["border-radius-10"],
    background: theme.palette.ColorBackgroundAlt,
    color: theme.palette.ColorTextBase
  }),
  helpButton: {
    borderTopRightRadius: theme.mixins.cornerRadius["border-radius-10"],
    "&:hover, &:active": {
      backgroundColor: theme.palette.ColorBackgroundAccentAlt,
      cursor: "pointer"
    }
  }
}));
function NxHeaderCard(_a) {
  var _b = _a, {
    title,
    subtitle,
    actions,
    footer,
    children,
    className,
    headerClassName,
    contentClassName,
    showAlert,
    alertData,
    sideContentAction
  } = _b, boxProps = __objRest(_b, [
    "title",
    "subtitle",
    "actions",
    "footer",
    "children",
    "className",
    "headerClassName",
    "contentClassName",
    "showAlert",
    "alertData",
    "sideContentAction"
  ]);
  var _a2, _b2;
  const theme = useTheme14();
  const styles = useStyles29({ hasSideAction: Boolean(sideContentAction) });
  return /* @__PURE__ */ React40.createElement(Box18, __spreadValues({
    bgcolor: "ColorBackgroundBase",
    boxShadow: theme.mixins.boxShadow.elevation1,
    className: clsx11(className, styles.container)
  }, boxProps), /* @__PURE__ */ React40.createElement(Box18, {
    className: clsx11(styles.header, headerClassName),
    display: "flex",
    flexDirection: "column",
    gridGap: theme.spacing(1),
    justifyContent: "center"
  }, /* @__PURE__ */ React40.createElement(Box18, {
    alignItems: "center",
    display: "flex",
    gridGap: theme.spacing(2),
    justifyContent: "space-between"
  }, /* @__PURE__ */ React40.createElement(Box18, {
    display: "flex",
    flexDirection: "column",
    gridGap: theme.spacing(1)
  }, typeof title === "string" ? /* @__PURE__ */ React40.createElement(NxTypography, {
    color: "inherit",
    variant: "h4"
  }, title) : title, subtitle && /* @__PURE__ */ React40.createElement(NxTypography, {
    color: "inherit",
    variant: "overline"
  }, subtitle)), /* @__PURE__ */ React40.createElement(Box18, {
    alignItems: "center",
    display: "flex"
  }, actions, sideContentAction && /* @__PURE__ */ React40.createElement(Box18, {
    alignContent: "center",
    bgcolor: theme.palette.ColorBackgroundAccent,
    className: styles.helpButton,
    display: "flex",
    flexDirection: "column",
    height: "86px",
    justifyContent: "center",
    ml: 0.5,
    onClick: sideContentAction,
    textAlign: "center",
    width: "40px"
  }, /* @__PURE__ */ React40.createElement(Box18, {
    display: "flex",
    justifyContent: "center",
    width: "100%"
  }, /* @__PURE__ */ React40.createElement(InfoOutlined2, {
    color: theme.palette.common.white
  })))))), showAlert && /* @__PURE__ */ React40.createElement(Box18, {
    position: "absolute",
    width: "100%",
    zIndex: 1300
  }, /* @__PURE__ */ React40.createElement(NxHeaderCardAlert, __spreadValues({
    subtitle: (_a2 = alertData == null ? void 0 : alertData.subtitle) != null ? _a2 : "",
    title: (_b2 = alertData == null ? void 0 : alertData.title) != null ? _b2 : ""
  }, alertData))), /* @__PURE__ */ React40.createElement(Box18, {
    className: clsx11(contentClassName),
    height: "100%",
    px: 3,
    py: 2
  }, children, footer));
}

// src/cards/event-card/NxEventCard.tsx
import React41 from "react";
import { Box as Box19, Divider, useTheme as useTheme15 } from "@material-ui/core";
import clsx12 from "clsx";
import { colors as colors5 } from "@playvs-inc/nexus-core";
import {
  EsportsOutlined,
  ScheduleOutlined,
  ScrimmageOutlined
} from "@playvs-inc/nexus-icons";

// src/cards/event-card/NxEventCard.styles.tsx
import { makeStyles as makeStyles31 } from "@material-ui/core";
var useStyles30 = makeStyles31((theme) => ({
  container: {
    borderColor: theme.palette.BorderLight,
    transition: "border-color 0.2s",
    "&:hover": {
      borderColor: theme.palette.ColorBackgroundAccent,
      "& img": {
        opacity: 1
      }
    }
  },
  image: {
    opacity: 0.5,
    position: "absolute",
    left: "-50%",
    transition: "opacity 0.2s"
  },
  section: {
    display: "flex",
    alignItems: "center",
    gridGap: theme.spacing(1)
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1)
  },
  divider: {
    background: theme.palette.BorderLight
  }
}));

// src/cards/event-card/NxEventCard.tsx
function NxEventCard(_a) {
  var _b = _a, {
    className,
    esportSlug,
    platforms,
    name,
    teamFormat,
    currentPlayerCount,
    maxPlayerCount,
    startDate
  } = _b, boxProps = __objRest(_b, [
    "className",
    "esportSlug",
    "platforms",
    "name",
    "teamFormat",
    "currentPlayerCount",
    "maxPlayerCount",
    "startDate"
  ]);
  const theme = useTheme15();
  const classes = useStyles30();
  const bannerSrc = getEsportBanner(esportSlug, "league");
  const formattedStartsAt = Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }).format(new Date(startDate));
  return /* @__PURE__ */ React41.createElement(Box19, __spreadValues({
    bgcolor: "ColorBackgroundBase",
    border: "2px solid",
    borderRadius: theme.mixins.cornerRadius["border-radius-10"],
    boxShadow: theme.mixins.boxShadow.elevation1,
    className: clsx12(className, classes.container),
    "data-cy": esportSlug,
    overflow: "hidden",
    position: "relative",
    width: "322px"
  }, boxProps), /* @__PURE__ */ React41.createElement(Box19, {
    bgcolor: colors5.Rl[8],
    height: "182px",
    position: "relative"
  }, /* @__PURE__ */ React41.createElement("img", {
    alt: name,
    className: classes.image,
    height: "182px",
    src: bannerSrc,
    width: "auto"
  })), /* @__PURE__ */ React41.createElement(Box19, {
    padding: 1
  }, /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.row
  }, /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.section
  }, /* @__PURE__ */ React41.createElement(NxEsportIcon, {
    esportSlug,
    mode: "dark"
  }), /* @__PURE__ */ React41.createElement(NxTypography, {
    variant: "body2"
  }, name))), /* @__PURE__ */ React41.createElement(Divider, {
    className: classes.divider
  }), /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.row
  }, /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.section
  }, /* @__PURE__ */ React41.createElement(EsportsOutlined, null), /* @__PURE__ */ React41.createElement(NxTypography, {
    variant: "body3"
  }, platforms)), /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.section
  }, /* @__PURE__ */ React41.createElement(NxTypography, {
    variant: "body3"
  }, teamFormat), /* @__PURE__ */ React41.createElement(ScrimmageOutlined, null))), /* @__PURE__ */ React41.createElement(Divider, {
    className: classes.divider
  }), /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.row
  }, /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.section
  }, /* @__PURE__ */ React41.createElement(ScheduleOutlined, null), /* @__PURE__ */ React41.createElement(NxTypography, {
    variant: "body3"
  }, "Starts at ", formattedStartsAt)), /* @__PURE__ */ React41.createElement(Box19, {
    className: classes.section
  }))));
}

// src/carousel/NxCarouselPaginationButtons/NxCardPaginationButtons.tsx
import React42, { useState as useState6 } from "react";
import { Box as Box20, IconButton, makeStyles as makeStyles32, useTheme as useTheme16 } from "@material-ui/core";
import clsx13 from "clsx";
import { CaretLeft, CaretRight as CaretRight2 } from "@playvs-inc/nexus-icons";
import "@playvs-inc/nexus-theme";
var useStyles31 = makeStyles32((theme) => ({
  paginationButtonBase: {
    position: "relative",
    border: "1px solid",
    borderRadius: "50%",
    backgroundColor: theme.palette.ColorBackgroundBase,
    borderColor: theme.palette.ColorBackgroundAlt2,
    color: theme.palette.ColorTextBase,
    "&.active": {
      backgroundColor: theme.palette.ColorBackgroundAccent,
      borderColor: "rgba(0,0,0,0)",
      "& path": {
        fill: theme.palette.ColorIconInvert
      },
      "&:disabled": {
        border: "1px solid",
        borderRadius: "50%",
        borderColor: theme.palette.BorderLight,
        backgroundColor: "rgba(0,0,0,0)",
        "& path": {
          fill: theme.palette.BorderLight
        }
      }
    },
    "&:hover:not(:disabled):not(.active)": {
      borderColor: theme.palette.ColorBackgroundAlt2,
      backgroundColor: theme.palette.ColorBackgroundAlt2,
      "& path": {
        fill: theme.palette.ColorIconBase
      }
    },
    "&:disabled": {
      border: "1px solid",
      borderRadius: "50%",
      borderColor: theme.palette.BorderLight,
      backgroundColor: "rgba(0,0,0,0)",
      "& path": {
        fill: theme.palette.BorderLight
      }
    }
  }
}));
function NxCardPaginationButtons({
  onLeft,
  onRight,
  enableLeft,
  enableRight,
  children
}) {
  const [buttonDown, setButtonDown] = useState6(null);
  const theme = useTheme16();
  const classes = useStyles31();
  return /* @__PURE__ */ React42.createElement(Box20, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gridGap: theme.spacing(1)
  }, /* @__PURE__ */ React42.createElement(IconButton, {
    className: clsx13(classes.paginationButtonBase, buttonDown === "left" && "active"),
    "data-cy": "page-left",
    disabled: !enableLeft,
    onClick: onLeft,
    onMouseDown: () => setButtonDown("left"),
    onMouseUp: () => setButtonDown(null),
    size: "small"
  }, /* @__PURE__ */ React42.createElement(CaretLeft, null)), children, /* @__PURE__ */ React42.createElement(IconButton, {
    className: clsx13(classes.paginationButtonBase, buttonDown === "right" && "active"),
    "data-cy": "page-right",
    disabled: !enableRight,
    onClick: onRight,
    onMouseDown: () => setButtonDown("right"),
    onMouseUp: () => setButtonDown(null),
    size: "small"
  }, /* @__PURE__ */ React42.createElement(CaretRight2, null)));
}

// src/checkbox/NxCheckbox.tsx
import React43 from "react";
import { Box as Box21, Checkbox, makeStyles as makeStyles33, useTheme as useTheme17 } from "@material-ui/core";
import clsx14 from "clsx";
import { colors as colors6 } from "@playvs-inc/nexus-core";
import { Checkbox as CheckboxIcon, Smallcheck } from "@playvs-inc/nexus-icons";
import { MUIThemeModeEnum as MUIThemeModeEnum5 } from "@playvs-inc/nexus-theme";
var useStyles32 = makeStyles33((theme) => ({
  checkboxLight: {
    color: colors6.OpBlack[8],
    "&$checked": {
      color: theme.palette.common.black
    }
  },
  checkboxDark: {
    color: theme.palette.common.white,
    "&$checked": {
      color: theme.palette.common.black
    }
  },
  darkCheck: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.mixins.cornerRadius["border-radius-2"],
    margin: theme.spacing(0.375)
  }
}));
function NxCheckbox(_a) {
  var _b = _a, {
    containerClassName = "",
    className = ""
  } = _b, props = __objRest(_b, [
    "containerClassName",
    "className"
  ]);
  const theme = useTheme17();
  const isLightMode = theme.palette.type === MUIThemeModeEnum5.Light;
  const classes = useStyles32();
  return /* @__PURE__ */ React43.createElement(Box21, {
    className: containerClassName
  }, /* @__PURE__ */ React43.createElement(Checkbox, __spreadValues({
    checkedIcon: isLightMode ? /* @__PURE__ */ React43.createElement(CheckboxIcon, {
      height: 24,
      width: 24
    }) : /* @__PURE__ */ React43.createElement(Smallcheck, {
      className: classes.darkCheck,
      color: theme.palette.common.black,
      height: 18,
      width: 18
    }),
    className: clsx14(isLightMode ? classes.checkboxLight : classes.checkboxDark, className)
  }, props)));
}

// src/clusters/NxMatchDetailsCluster/NxMatchDetailsCluster.tsx
import React44 from "react";
import { Box as Box22, useTheme as useTheme18 } from "@material-ui/core";
import { useEsport as useEsport5 } from "@playvs-inc/nexus-theme";

// src/clusters/NxMatchDetailsCluster/MatchDetailsCluster.helpers.tsx
var formatTimestamp = (timestamp, options = {}) => {
  if (!timestamp) {
    return "";
  }
  const toFormatTimeStamp = new Date(timestamp).getTime();
  if (!toFormatTimeStamp) {
    return "";
  }
  return new Intl.DateTimeFormat("en-US", __spreadValues({
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "2-digit"
  }, options)).format(new Date(toFormatTimeStamp)).replace(/,/g, "");
};

// src/clusters/NxMatchDetailsCluster/NxMatchDetailsCluster.tsx
function NxMatchDetailsCluster({
  esport: esportSlug,
  teamAName,
  teamBName,
  timestamp,
  showAvatar,
  bestOf,
  esportName
}) {
  const theme = useTheme18();
  const showVs = teamAName && teamBName;
  const derivedBestOf = bestOf;
  const esport = useEsport5(esportSlug != null ? esportSlug : "");
  const title = esportName || (esport == null ? void 0 : esport.name);
  return /* @__PURE__ */ React44.createElement(Box22, {
    alignItems: "center",
    display: "flex",
    gridGap: theme.spacing(2)
  }, showAvatar && /* @__PURE__ */ React44.createElement(NxEsportAvatar, {
    esport: esportSlug,
    iconHeight: 40,
    iconWidth: 40
  }), /* @__PURE__ */ React44.createElement(Box22, {
    display: "grid",
    flexDirection: "column",
    gridGap: theme.spacing(0.5)
  }, /* @__PURE__ */ React44.createElement(NxTypography, {
    colorToken: "ColorTextAlt2",
    variant: "overline"
  }, title, " | Best Of ", derivedBestOf), /* @__PURE__ */ React44.createElement(Box22, null, /* @__PURE__ */ React44.createElement(NxTypography, {
    component: "span",
    variant: "body2"
  }, teamAName), showVs && /* @__PURE__ */ React44.createElement(NxTypography, {
    component: "span",
    variant: "body1"
  }, " ", "vs", " "), /* @__PURE__ */ React44.createElement(NxTypography, {
    component: "span",
    variant: "body2"
  }, teamBName)), /* @__PURE__ */ React44.createElement(NxTypography, {
    colorToken: "ColorTextAlt2",
    variant: "body3"
  }, timestamp && formatTimestamp(timestamp) || "")));
}

// src/contact-cluster/NxContactCluster.tsx
import React45 from "react";
import { Box as Box23, makeStyles as makeStyles34 } from "@material-ui/core";
var useStyles33 = makeStyles34((theme) => ({
  userCluster: {
    display: "flex",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: theme.palette.ColorTextBase
  },
  avatarContainer: ({ avatarClickable }) => ({
    cursor: avatarClickable ? "pointer" : "auto"
  }),
  titlesContainer: {
    paddingLeft: theme.spacing(2),
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
  },
  subHeader: {
    color: theme.palette.ColorTextAlt2
  },
  avatarClass: {
    height: 54,
    width: 54
  },
  ellipsisOverflow: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
}));
function NxContactCluster({
  name,
  email,
  phone,
  subHeader,
  avatarHashId,
  avatarUrl,
  showPhoneAndEmail = true,
  onClickAvatar,
  onlineStatus,
  showTooltipForOnlineStatus
}) {
  const classes = useStyles33({ avatarClickable: !!onClickAvatar });
  return /* @__PURE__ */ React45.createElement(Box23, {
    className: classes.userCluster
  }, /* @__PURE__ */ React45.createElement(NxAvatar, {
    avatarHashId,
    avatarUrl,
    hasBorder: true,
    height: 54,
    onClickAvatar,
    onlineStatus,
    showTooltipForOnlineStatus,
    width: 54
  }), /* @__PURE__ */ React45.createElement(Box23, {
    className: classes.titlesContainer
  }, /* @__PURE__ */ React45.createElement(NxTypography, {
    className: `${classes.subHeader} ${classes.ellipsisOverflow}`,
    variant: "overline"
  }, subHeader), /* @__PURE__ */ React45.createElement(NxTypography, {
    className: classes.ellipsisOverflow,
    "data-cy": "name",
    variant: "h4"
  }, name), showPhoneAndEmail && /* @__PURE__ */ React45.createElement(React45.Fragment, null, /* @__PURE__ */ React45.createElement(Box23, {
    pb: 0.5,
    pt: 0.5
  }, /* @__PURE__ */ React45.createElement(NxTypography, {
    className: classes.ellipsisOverflow,
    "data-cy": "email",
    variant: "body4"
  }, email != null ? email : "")), /* @__PURE__ */ React45.createElement(NxTypography, {
    className: classes.ellipsisOverflow,
    "data-cy": "phone",
    variant: "body4"
  }, phone != null ? phone : ""))));
}

// src/dialog/NxModal.tsx
import React47, { useRef as useRef4, useState as useState7 } from "react";
import clsx15 from "clsx";
import { Box as Box25, makeStyles as makeStyles36 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";

// src/dialog/NxModalBase.tsx
import React46, { useMemo as useMemo3 } from "react";
import {
  Box as Box24,
  Dialog,
  IconButton as IconButton2,
  makeStyles as makeStyles35,
  useTheme as useTheme19
} from "@material-ui/core";
import "@playvs-inc/nexus-theme";
import { Close as Close3 } from "@playvs-inc/nexus-icons";
var MODAL_SIZE_SMALL = 480;
var MODAL_SIZE_LARGE = 580;
var useStyles34 = makeStyles35((theme) => ({
  dialogClass: ({ height, width }) => ({
    borderRadius: theme.mixins.cornerRadius["border-radius-10"],
    maxHeight: height != null ? height : "auto",
    maxWidth: width != null ? width : "auto",
    width,
    height,
    padding: theme.spacing(3),
    boxShadow: theme.mixins.boxShadow.elevation4
  }),
  iconButtonClass: {
    zIndex: 100,
    position: "absolute",
    top: 0,
    right: 0,
    margin: theme.spacing(2, 2, 2, 2),
    "&:hover": {
      backgroundColor: theme.palette.ColorBackgroundAlt2
    }
  }
}));
function NxModalBase(_a) {
  var _b = _a, {
    children,
    onClose,
    showTopRightClose = true,
    height,
    width,
    size = "small",
    actions,
    currentStep,
    totalNumberOfSteps,
    showStep,
    footer
  } = _b, props = __objRest(_b, [
    "children",
    "onClose",
    "showTopRightClose",
    "height",
    "width",
    "size",
    "actions",
    "currentStep",
    "totalNumberOfSteps",
    "showStep",
    "footer"
  ]);
  const theme = useTheme19();
  const computedWidth = useMemo3(() => {
    if (width) {
      return width;
    }
    if (size) {
      if (size === "small") {
        return MODAL_SIZE_SMALL;
      }
      if (size === "large") {
        return MODAL_SIZE_LARGE;
      }
    }
    return void 0;
  }, [width, size]);
  const classes = useStyles34({
    height,
    width: computedWidth
  });
  return /* @__PURE__ */ React46.createElement(Dialog, __spreadProps(__spreadValues({
    onClose
  }, props), {
    PaperProps: {
      className: classes.dialogClass
    }
  }), showTopRightClose && /* @__PURE__ */ React46.createElement(IconButton2, {
    className: classes.iconButtonClass,
    onClick: onClose
  }, /* @__PURE__ */ React46.createElement(Close3, null)), children, footer, showStep || actions ? /* @__PURE__ */ React46.createElement(Box24, {
    alignItems: "center",
    display: "flex",
    pt: 2
  }, showStep && /* @__PURE__ */ React46.createElement(Box24, {
    display: "flex",
    flex: 1,
    justifyContent: "flex-start"
  }, /* @__PURE__ */ React46.createElement(NxTypography, {
    variant: "body4"
  }, "Step ", currentStep, " of ", totalNumberOfSteps)), actions && /* @__PURE__ */ React46.createElement(Box24, {
    alignItems: "center",
    display: "flex",
    flex: showStep ? void 0 : 1,
    gridGap: theme.spacing(2),
    justifyContent: "flex-end"
  }, actions)) : null);
}

// src/dialog/NxModal.tsx
var useStyles35 = makeStyles36((theme) => ({
  contentContainer: {
    margin: theme.spacing(2, 0, 2, 0),
    overflow: "auto"
  }
}));
function NxModal(_a) {
  var _b = _a, {
    children,
    title,
    subtitle,
    titleClassName,
    contentClassName,
    subtitleNode,
    titleNode,
    titleDataCy,
    subtitleDataCy
  } = _b, props = __objRest(_b, [
    "children",
    "title",
    "subtitle",
    "titleClassName",
    "contentClassName",
    "subtitleNode",
    "titleNode",
    "titleDataCy",
    "subtitleDataCy"
  ]);
  const [isScrolled, setIsScrolled] = useState7(false);
  const contentRef = useRef4();
  const classes = useStyles35({
    isScrolled
  });
  const onScroll = () => {
    if (contentRef.current) {
      setIsScrolled(contentRef.current.scrollTop > 0);
    }
  };
  return /* @__PURE__ */ React47.createElement(NxModalBase, __spreadValues({}, props), /* @__PURE__ */ React47.createElement(Box25, {
    className: titleClassName
  }, title || titleNode ? /* @__PURE__ */ React47.createElement(Box25, {
    pt: 0.5
  }, titleNode || /* @__PURE__ */ React47.createElement(NxTypography, {
    "data-cy": titleDataCy,
    variant: "h2"
  }, title)) : null, subtitle || subtitleNode ? /* @__PURE__ */ React47.createElement(Box25, {
    pt: 0.5
  }, subtitleNode || /* @__PURE__ */ React47.createElement(NxTypography, {
    colorToken: "ColorTextAlt2",
    "data-cy": subtitleDataCy,
    variant: "body1"
  }, subtitle)) : null), /* @__PURE__ */ React47.createElement(Box25, {
    ref: contentRef,
    className: clsx15(classes.contentContainer, contentClassName),
    onScroll
  }, children));
}

// src/dialog/NxSpotModal.tsx
import React48, { useRef as useRef5, useState as useState8 } from "react";
import { Box as Box26, makeStyles as makeStyles37 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles36 = makeStyles37((theme) => ({
  contentContainer: {
    marginBottom: theme.spacing(2),
    overflow: "auto"
  },
  dialogTitle: {
    lineHeight: 0
  },
  title: {
    marginTop: theme.spacing(2)
  }
}));
function NxSpotModal(_a) {
  var _b = _a, {
    spot,
    children,
    title,
    subtitle,
    subtitleNode
  } = _b, props = __objRest(_b, [
    "spot",
    "children",
    "title",
    "subtitle",
    "subtitleNode"
  ]);
  const [isScrolled, setIsScrolled] = useState8(false);
  const contentRef = useRef5();
  const classes = useStyles36({
    isScrolled
  });
  const onScroll = () => {
    if (contentRef.current) {
      setIsScrolled(contentRef.current.scrollTop > 0);
    }
  };
  return /* @__PURE__ */ React48.createElement(NxModalBase, __spreadValues({}, props), /* @__PURE__ */ React48.createElement(Box26, {
    className: classes.dialogTitle,
    my: 2,
    textAlign: "center"
  }, spot, /* @__PURE__ */ React48.createElement(NxTypography, {
    className: classes.title,
    variant: "h2"
  }, title), subtitle || subtitleNode ? /* @__PURE__ */ React48.createElement(Box26, {
    mt: 1
  }, subtitleNode || /* @__PURE__ */ React48.createElement(NxTypography, {
    colorToken: "ColorTextAlt2",
    variant: "body1"
  }, subtitle)) : null), /* @__PURE__ */ React48.createElement(Box26, {
    ref: contentRef,
    className: classes.contentContainer,
    onScroll
  }, children));
}

// src/dialog/NxLightbox.tsx
import React49 from "react";
import { Dialog as Dialog2, IconButton as IconButton3, makeStyles as makeStyles38 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
import { Close as Close4 } from "@playvs-inc/nexus-icons";
import clsx16 from "clsx";
var useStyles37 = makeStyles38((theme) => ({
  dialog: {
    padding: 0,
    margin: 0
  },
  paper: ({
    height,
    width
  }) => ({
    borderRadius: 10,
    maxHeight: height != null ? height : "auto",
    maxWidth: width != null ? width : "auto",
    padding: 0
  }),
  iconButtonClass: {
    flex: 0,
    padding: theme.spacing(1),
    position: "absolute",
    top: 0,
    right: 0
  }
}));
function NxLightbox(_a) {
  var _b = _a, {
    children,
    onClose,
    showTopRightClose,
    height,
    width,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "onClose",
    "showTopRightClose",
    "height",
    "width",
    "className"
  ]);
  const classes = useStyles37({
    height,
    width
  });
  return /* @__PURE__ */ React49.createElement(Dialog2, __spreadProps(__spreadValues({
    onClose
  }, props), {
    className: clsx16(className, classes.dialog),
    PaperProps: {
      className: classes.paper
    }
  }), showTopRightClose && /* @__PURE__ */ React49.createElement(IconButton3, {
    className: classes.iconButtonClass,
    onClick: onClose
  }, /* @__PURE__ */ React49.createElement(Close4, null)), children);
}

// src/dialog/NxEmbedVideoModal.tsx
import React50 from "react";
import { Dialog as Dialog3, IconButton as IconButton4, makeStyles as makeStyles39 } from "@material-ui/core";
import { Close as Close5 } from "@playvs-inc/nexus-icons";
var useStyles38 = makeStyles39((theme) => ({
  title: {
    marginBottom: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(3, 3, 4, 3)
  },
  iconButton: {
    backgroundColor: theme.palette.OverlayColorOpBlack3,
    position: "absolute",
    top: 16,
    right: 16,
    "&:hover": {
      backgroundColor: theme.palette.OverlayColorOpBlack3
    }
  },
  icon: {
    color: theme.palette.OverlayColorIconBase
  }
}));
function NxEmbedVideoModal(_a) {
  var _b = _a, {
    allow,
    children,
    onClose,
    showTopRightClose,
    title,
    videoSrc,
    videoHeight = 270,
    videoWidth = 480,
    videoTitle = "NxEmbedVideoModalPlayer"
  } = _b, props = __objRest(_b, [
    "allow",
    "children",
    "onClose",
    "showTopRightClose",
    "title",
    "videoSrc",
    "videoHeight",
    "videoWidth",
    "videoTitle"
  ]);
  const classes = useStyles38();
  return /* @__PURE__ */ React50.createElement(Dialog3, __spreadValues({}, props), showTopRightClose && /* @__PURE__ */ React50.createElement(IconButton4, {
    className: classes.iconButton,
    onClick: onClose
  }, /* @__PURE__ */ React50.createElement(Close5, {
    className: classes.icon
  })), /* @__PURE__ */ React50.createElement("iframe", {
    allow,
    allowFullScreen: true,
    frameBorder: "0",
    height: videoHeight,
    src: videoSrc,
    title: videoTitle,
    width: videoWidth
  }), /* @__PURE__ */ React50.createElement("div", {
    className: classes.content
  }, /* @__PURE__ */ React50.createElement(NxTypography, {
    className: classes.title,
    variant: "h4"
  }, title), children));
}

// src/dialog/NxActionSpotModal.tsx
import React51 from "react";
import { Box as Box27, makeStyles as makeStyles40, useTheme as useTheme20 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles39 = makeStyles40((theme) => ({
  contentContainer: {
    marginBottom: theme.spacing(2),
    overflow: "auto"
  },
  parentContent: {
    display: "flex",
    justifyContent: "center"
  },
  spot: {
    lineHeight: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  header: {
    marginTop: theme.spacing(1)
  }
}));
function NxActionSpotModal(_a) {
  var _b = _a, {
    spot,
    headerNode,
    content
  } = _b, props = __objRest(_b, [
    "spot",
    "headerNode",
    "content"
  ]);
  const theme = useTheme20();
  const classes = useStyles39();
  return /* @__PURE__ */ React51.createElement(NxModal, __spreadProps(__spreadValues({}, props), {
    contentClassName: classes.parentContent
  }), /* @__PURE__ */ React51.createElement(Box27, {
    flex: 1,
    maxWidth: "330px"
  }, /* @__PURE__ */ React51.createElement(Box27, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column"
  }, /* @__PURE__ */ React51.createElement(Box27, {
    className: classes.header
  }, headerNode), /* @__PURE__ */ React51.createElement(Box27, {
    className: classes.spot,
    my: theme.spacing(2),
    textAlign: "center"
  }, spot), content)));
}

// src/emotes/NxEmote.tsx
import React54, { useRef as useRef7, useState as useState9 } from "react";

// src/emotes/NxEmotes.helpers.tsx
import React53 from "react";
import reactStringReplace from "react-string-replace";
import { extractLinks } from "@draft-js-plugins/linkify";

// src/emotes/links/plugin/components/Link.tsx
import { makeStyles as makeStyles41 } from "@material-ui/core";
import React52 from "react";
var useStyles40 = makeStyles41({
  link: {
    display: "inline-block",
    textTransform: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});
function Link2({ href }) {
  const classes = useStyles40();
  return /* @__PURE__ */ React52.createElement(NxTextLink, {
    className: classes.link,
    href,
    label: href,
    rel: "noopener",
    target: "_blank",
    variant: "body1"
  });
}

// src/emotes/NxEmotes.helpers.tsx
var MAX_LARGE_EMOTES = 3;
var FB = /* @__PURE__ */ ((FB3) => {
  FB3["Celebrate"] = "fbcelebrate";
  FB3["Cool"] = "fbcool";
  FB3["Cry"] = "fbcry";
  FB3["Whoops"] = "fbwhoops";
  FB3["Think"] = "fbthink";
  FB3["Facepalm"] = "fbfacepalm";
  FB3["Gg"] = "fbgg";
  FB3["Happy"] = "fbhappy";
  FB3["Love"] = "fblove";
  FB3["Shock"] = "fbshock";
  FB3["Wave"] = "fbwave";
  FB3["Lol"] = "fblol";
  FB3["Lurk"] = "fblurk";
  FB3["Rage"] = "fbrage";
  FB3["Rip"] = "fbrip";
  FB3["Sarcastic"] = "fbsarcastic";
  FB3["Thumbsdown"] = "fbthumbsdown";
  FB3["Thumbsup"] = "fbthumbsup";
  FB3["Trophy"] = "fbtrophy";
  FB3["Highfive"] = "fbhighfive";
  FB3["Coach"] = "fbcoach";
  FB3["Fan"] = "fbfan";
  FB3["Hearthstone"] = "fbhearthstone";
  FB3["Hype"] = "fbhype";
  FB3["Kart"] = "fbkart";
  FB3["Madden"] = "fbmadden";
  FB3["Nba"] = "fbnba";
  FB3["Pachimari"] = "fbpachimari";
  FB3["Pika"] = "fbpika";
  FB3["Rocket"] = "fbrocket";
  FB3["Splatoon"] = "fbsplatoon";
  FB3["Teemo"] = "fbteemo";
  FB3["Rivals1"] = "fbrivals1";
  FB3["Rivals2"] = "fbrivals2";
  FB3["Mod"] = "fbmod";
  return FB3;
})(FB || {});
var emotesMap = {
  ["fbcelebrate" /* Celebrate */]: {
    name: "fbcelebrate" /* Celebrate */,
    prettyName: "Firebob Celebrate!",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/celebrate%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/celebrate.gif"
  },
  ["fbcool" /* Cool */]: {
    name: "fbcool" /* Cool */,
    prettyName: "Firebob Cool",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/cool%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/cool.gif"
  },
  ["fbcry" /* Cry */]: {
    name: "fbcry" /* Cry */,
    prettyName: "Firebob Cry",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/cry%40112.png"
  },
  ["fbwhoops" /* Whoops */]: {
    name: "fbwhoops" /* Whoops */,
    prettyName: "Firebob Whoops",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/derp%40112.png"
  },
  ["fbthink" /* Think */]: {
    name: "fbthink" /* Think */,
    prettyName: "Firebob Think",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/think%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/think.gif"
  },
  ["fbfacepalm" /* Facepalm */]: {
    name: "fbfacepalm" /* Facepalm */,
    prettyName: "Firebob Face Palm",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/facepalm%40112.png"
  },
  ["fbgg" /* Gg */]: {
    name: "fbgg" /* Gg */,
    prettyName: "Firebob GG",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/gg%40112.png"
  },
  ["fbhappy" /* Happy */]: {
    name: "fbhappy" /* Happy */,
    prettyName: "Firebob Happy",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/happy%40112.png"
  },
  ["fblove" /* Love */]: {
    name: "fblove" /* Love */,
    prettyName: "Firebob Love",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/heart%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/lol.gif"
  },
  ["fbshock" /* Shock */]: {
    name: "fbshock" /* Shock */,
    prettyName: "Firebob Shocked",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/shocked%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/shock.gif"
  },
  ["fbwave" /* Wave */]: {
    name: "fbwave" /* Wave */,
    prettyName: "Firebob Wave",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/hey%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/wave.gif"
  },
  ["fblol" /* Lol */]: {
    name: "fblol" /* Lol */,
    prettyName: "Firebob LOL!",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/lol%40112.png"
  },
  ["fblurk" /* Lurk */]: {
    name: "fblurk" /* Lurk */,
    prettyName: "Firebob Lurk",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/lurk%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/lurk.gif"
  },
  ["fbrage" /* Rage */]: {
    name: "fbrage" /* Rage */,
    prettyName: "Firebob Rage",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/rage%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/rage.gif"
  },
  ["fbrip" /* Rip */]: {
    name: "fbrip" /* Rip */,
    prettyName: "Firebob RIP",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/rip%40112.png"
  },
  ["fbsarcastic" /* Sarcastic */]: {
    name: "fbsarcastic" /* Sarcastic */,
    prettyName: "Firebob Sarcastic",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/sarcastic%40112.png"
  },
  ["fbthumbsdown" /* Thumbsdown */]: {
    name: "fbthumbsdown" /* Thumbsdown */,
    prettyName: "Firebob Thumbs Down",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/thumbsdown%40112.png"
  },
  ["fbthumbsup" /* Thumbsup */]: {
    name: "fbthumbsup" /* Thumbsup */,
    prettyName: "Firebob Thumbs Up",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/thumbsup%40112.png",
    altSrc: "https://s3.amazonaws.com/assets.playvs.com/emotes/thumbup.gif"
  },
  ["fbtrophy" /* Trophy */]: {
    name: "fbtrophy" /* Trophy */,
    prettyName: "Firebob Trophy",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Trophy%40112.png"
  },
  ["fbhighfive" /* Highfive */]: {
    name: "fbhighfive" /* Highfive */,
    prettyName: "Firebob High Five",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/High-Five%40112.png"
  },
  ["fbcoach" /* Coach */]: {
    name: "fbcoach" /* Coach */,
    prettyName: "Firebob Coach",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Coach%40112.png"
  },
  ["fbfan" /* Fan */]: {
    name: "fbfan" /* Fan */,
    prettyName: "Firebob Fan",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Fan%40112.png"
  },
  ["fbhearthstone" /* Hearthstone */]: {
    name: "fbhearthstone" /* Hearthstone */,
    prettyName: "Firebob Hearthstone",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Hearthstone%40112.png"
  },
  ["fbhype" /* Hype */]: {
    name: "fbhype" /* Hype */,
    prettyName: "Firebob Hype",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Hype2%40112.png"
  },
  ["fbkart" /* Kart */]: {
    name: "fbkart" /* Kart */,
    prettyName: "Firebob Kart",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Kart%40112.png"
  },
  ["fbmadden" /* Madden */]: {
    name: "fbmadden" /* Madden */,
    prettyName: "Firebob Madden",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Madden%40112.png"
  },
  ["fbnba" /* Nba */]: {
    name: "fbnba" /* Nba */,
    prettyName: "Firebob Nba",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/NBA%40112.png"
  },
  ["fbpachimari" /* Pachimari */]: {
    name: "fbpachimari" /* Pachimari */,
    prettyName: "Firebob Pachimari",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Pachimari%40112.png"
  },
  ["fbpika" /* Pika */]: {
    name: "fbpika" /* Pika */,
    prettyName: "Firebob Pika",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Pika%40112.png"
  },
  ["fbrocket" /* Rocket */]: {
    name: "fbrocket" /* Rocket */,
    prettyName: "Firebob Rocket",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Rocket-league-%40112.png"
  },
  ["fbsplatoon" /* Splatoon */]: {
    name: "fbsplatoon" /* Splatoon */,
    prettyName: "Firebob Splatoon",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Splatoon%40112.png"
  },
  ["fbteemo" /* Teemo */]: {
    name: "fbteemo" /* Teemo */,
    prettyName: "Firebob Teemo",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Teemo1%40112.png"
  },
  ["fbrivals1" /* Rivals1 */]: {
    name: "fbrivals1" /* Rivals1 */,
    prettyName: "Firebob Rivals",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Rivals1%40112.png"
  },
  ["fbrivals2" /* Rivals2 */]: {
    name: "fbrivals2" /* Rivals2 */,
    prettyName: "Firebob Rivals",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Rivals2%40112.png"
  },
  ["fbmod" /* Mod */]: {
    name: "fbmod" /* Mod */,
    prettyName: "Firebob Mod",
    src: "https://s3.amazonaws.com/assets.playvs.com/emotes/Mod%40112.png"
  }
};
var EmoteSize = /* @__PURE__ */ ((EmoteSize2) => {
  EmoteSize2[EmoteSize2["Large"] = 48] = "Large";
  EmoteSize2[EmoteSize2["Medium"] = 40] = "Medium";
  EmoteSize2[EmoteSize2["Small"] = 22] = "Small";
  return EmoteSize2;
})(EmoteSize || {});
var shouldRenderLargeEmotes = (message) => Boolean(message.match(/^(:\w+?:){1,3}\s*$/));
var getEmoteSize = (message) => {
  const renderLargeEmotes = shouldRenderLargeEmotes(message);
  return renderLargeEmotes ? 48 /* Large */ : 22 /* Small */;
};
var replaceEmotes = (message, emoteSize) => {
  const derivedEmoteSize = emoteSize || getEmoteSize(message);
  return reactStringReplace(message, /:(\w+?):/, (match) => {
    const emote = emotesMap[match];
    if (emote) {
      return /* @__PURE__ */ React53.createElement(NxEmote, {
        emoteKey: match,
        isLarge: derivedEmoteSize === 48 /* Large */
      });
    }
    return `:${match}:`;
  });
};
var replaceLinks = (message, extractedLinks) => {
  let transformedMessage = message;
  extractedLinks.forEach((link) => {
    transformedMessage = reactStringReplace(transformedMessage, link.raw, (match, i) => /* @__PURE__ */ React53.createElement(Link2, {
      key: match + i,
      href: link.raw
    }));
  });
  return transformedMessage;
};
var replaceNewlines = (message) => reactStringReplace(message, /(\n)/, (match) => {
  if (match.length % 2) {
    const slashes = match.length - 1 ? "\\".repeat(match.length - 1) : "";
    return /* @__PURE__ */ React53.createElement(React53.Fragment, null, slashes, /* @__PURE__ */ React53.createElement("br", null));
  }
  return `${match}n`;
});
var parseMessage = (message, options) => {
  var _a;
  const extractedLinks = (_a = extractLinks(message)) != null ? _a : [];
  let transformedMessage;
  transformedMessage = (options == null ? void 0 : options.hideEmotes) ? message : replaceEmotes(message, options == null ? void 0 : options.emoteSize);
  transformedMessage = replaceNewlines(transformedMessage);
  if (extractedLinks.length && !(options == null ? void 0 : options.hideLinks)) {
    transformedMessage = replaceLinks(transformedMessage, extractedLinks);
  }
  return transformedMessage;
};

// src/emotes/NxEmote.styles.ts
import { makeStyles as makeStyles42 } from "@material-ui/core";
var useStyles41 = makeStyles42(() => ({
  emote: ({
    src,
    isLarge,
    height: heightFromProps,
    width: widthFromProps
  }) => {
    let height = isLarge ? 48 /* Large */ : 22 /* Small */;
    height = heightFromProps || height;
    let width = isLarge ? 48 /* Large */ : 22 /* Small */;
    width = widthFromProps || width;
    return src ? {
      display: "inline-block",
      height,
      width,
      background: `url(${src}) 0 0 / contain`,
      fontSize: 0,
      verticalAlign: "middle"
    } : {};
  }
}));

// src/emotes/NxEmote.tsx
function NxEmote({
  emoteKey,
  isLarge,
  height,
  width,
  shouldAnimate
}) {
  const ref = useRef7(null);
  const [isHovered, setIsHovered] = useState9(false);
  const emote = emotesMap[emoteKey];
  const shoulAnimate = isLarge && isHovered || shouldAnimate;
  const emoteSrc = shoulAnimate && (emote == null ? void 0 : emote.altSrc) || (emote == null ? void 0 : emote.src);
  const styles = useStyles41({
    src: emoteSrc,
    isLarge,
    height,
    width
  });
  if (!emote) {
    return null;
  }
  return /* @__PURE__ */ React54.createElement("span", {
    ref,
    className: styles.emote,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false)
  }, ":", emote.name, ":");
}

// src/emotes/plugin/emotePlugin.tsx
import React55 from "react";
import { EditorState as EditorState2 } from "draft-js";

// src/emotes/plugin/utils/findWithRegex.ts
function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr;
  let start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}

// src/emotes/plugin/emoteStrategy.tsx
var EMOTE_REGEX = new RegExp(`:(${Object.keys(emotesMap).join("|")}):`, "g");
function emoteStrategy(contentBlock, callback, _contentState) {
  findWithRegex(EMOTE_REGEX, contentBlock, callback);
}

// src/emotes/plugin/modifiers/attachImmutableEntitiesToEmotes.ts
import { EditorState, Modifier, SelectionState } from "draft-js";
var unicodeRegex = new RegExp(EMOTE_REGEX, "g");
function attachImmutableEntitiesToEmotes(editorState) {
  const contentState = editorState.getCurrentContent();
  const blocks = contentState.getBlockMap();
  let newContentState = contentState;
  blocks.forEach((block) => {
    if (block) {
      const plainText = block.getText();
      const addEntityToEmote = (start, end) => {
        const existingEntityKey = block.getEntityAt(start);
        if (existingEntityKey) {
          const entity = newContentState.getEntity(existingEntityKey);
          if (entity && entity.getType() === "emote") {
            return;
          }
        }
        const selection = SelectionState.createEmpty(block.getKey()).set("anchorOffset", start).set("focusOffset", end);
        const emoteText = plainText.substring(start, end);
        const emoteKey = emoteText.substr(1, emoteText.length - 2);
        const emote = emotesMap[emoteKey];
        if (emote) {
          const contentStateWithEntity = newContentState.createEntity("emote", "IMMUTABLE", { emote });
          const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
          newContentState = Modifier.replaceText(newContentState, selection, emoteText, void 0, entityKey);
        }
      };
      findWithRegex(unicodeRegex, block, addEntityToEmote);
    }
  });
  if (!newContentState.equals(contentState)) {
    return EditorState.push(editorState, newContentState, "change-block-data");
  }
  return editorState;
}

// src/emotes/plugin/emotePlugin.tsx
var createEmotePlugin = () => {
  const callbacks = {
    keyBindingFn: void 0,
    handleKeyCommand: void 0,
    handleReturn: void 0,
    onChange: void 0
  };
  const searches = /* @__PURE__ */ new Map();
  let escapedSearch;
  const store = {
    getEditorState: void 0,
    setEditorState: void 0,
    getAllSearches: () => searches,
    isEscaped: (offsetKey) => escapedSearch === offsetKey,
    escapeSearch: (offsetKey) => {
      escapedSearch = offsetKey;
    },
    resetEscapedSearch: () => {
      escapedSearch = void 0;
    },
    register: (offsetKey) => {
      searches.set(offsetKey, offsetKey);
    },
    unregister: (offsetKey) => {
      searches.delete(offsetKey);
    }
  };
  function DecoratedEmote(props) {
    return /* @__PURE__ */ React55.createElement(NxEmote, __spreadValues({}, props));
  }
  return {
    decorators: [
      {
        strategy: emoteStrategy,
        component: DecoratedEmote
      }
    ],
    initialize: ({ getEditorState, setEditorState }) => {
      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
    },
    keyBindingFn: (keyboardEvent) => callbacks.keyBindingFn && callbacks.keyBindingFn(keyboardEvent),
    handleReturn: (keyboardEvent) => callbacks.handleReturn && callbacks.handleReturn(keyboardEvent),
    onChange: (editorState) => {
      let newEditorState = attachImmutableEntitiesToEmotes(editorState);
      if (!newEditorState.getCurrentContent().equals(editorState.getCurrentContent())) {
        const selection = editorState.getSelection();
        newEditorState = EditorState2.forceSelection(newEditorState, selection);
      }
      if (callbacks.onChange) {
        return callbacks.onChange(newEditorState);
      }
      return newEditorState;
    }
  };
};

// src/emotes/plugin/modifiers/addEmote.ts
import { Modifier as Modifier2, EditorState as EditorState3 } from "draft-js";

// src/emotes/plugin/utils/emoteToToken.ts
function emoteToToken(emote) {
  if (emote) {
    return `:${emote.name}:`;
  }
  return void 0;
}

// src/emotes/plugin/utils/getWordAt.ts
function getWordAt(string, position) {
  const str = string;
  const pos = position >>> 0;
  const left = str.slice(0, pos + 1).search(/\S+$/);
  const right = str.slice(pos).search(/\s/);
  if (right < 0) {
    return {
      word: str.slice(left),
      begin: left,
      end: str.length
    };
  }
  return {
    word: str.slice(left, right + pos),
    begin: left,
    end: right + pos
  };
}

// src/emotes/plugin/utils/getSearchText.ts
function getSearchText(editorState, selection) {
  const anchorKey = selection.getAnchorKey();
  const anchorOffset = selection.getAnchorOffset() - 1;
  const currentContent = editorState.getCurrentContent();
  const currentBlock = currentContent.getBlockForKey(anchorKey);
  const blockText = currentBlock.getText();
  return getWordAt(blockText, anchorOffset);
}

// src/emotes/plugin/utils/nameToEmote.ts
function nameToEmote(name) {
  const emote = emotesMap[name];
  return emote;
}

// src/emotes/plugin/modifiers/addEmote.ts
var Mode = {
  INSERT: "INSERT",
  REPLACE: "REPLACE"
};
function addEmoji(editorState, emoteShortName, mode = Mode.INSERT) {
  var _a;
  const emote = nameToEmote(emoteShortName);
  const emoteToken = (_a = emoteToToken(emote)) != null ? _a : "";
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity("emote", "IMMUTABLE", { emote });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const currentSelectionState = editorState.getSelection();
  let emoteAddedContent;
  let emoteEndPos = 0;
  let blockSize = 0;
  switch (mode) {
    case Mode.INSERT: {
      const afterRemovalContentState = Modifier2.removeRange(contentState, currentSelectionState, "backward");
      const targetSelection = afterRemovalContentState.getSelectionAfter();
      emoteAddedContent = Modifier2.insertText(afterRemovalContentState, targetSelection, emoteToken, void 0, entityKey);
      emoteEndPos = targetSelection.getAnchorOffset();
      const blockKey = targetSelection.getAnchorKey();
      blockSize = contentState.getBlockForKey(blockKey).getLength();
      break;
    }
    case Mode.REPLACE: {
      const { begin, end } = getSearchText(editorState, currentSelectionState);
      const emoteTextSelection = currentSelectionState.merge({
        anchorOffset: begin,
        focusOffset: end
      });
      emoteAddedContent = Modifier2.replaceText(contentState, emoteTextSelection, emoteToken, void 0, entityKey);
      emoteEndPos = end;
      const blockKey = emoteTextSelection.getAnchorKey();
      blockSize = contentState.getBlockForKey(blockKey).getLength();
      break;
    }
    default:
      throw new Error('Unidentified value of "mode"');
  }
  if (emoteEndPos === blockSize) {
    emoteAddedContent = Modifier2.insertText(emoteAddedContent, emoteAddedContent.getSelectionAfter(), " ");
  }
  const newEditorState = EditorState3.push(editorState, emoteAddedContent, "insert-fragment");
  return EditorState3.forceSelection(newEditorState, emoteAddedContent.getSelectionAfter());
}

// src/emotes/plugin/components/Emote.tsx
import React56 from "react";
import { convertToRaw } from "draft-js";
function DraftjsEmote({
  decoratedText,
  entityKey,
  contentState
}) {
  let emote;
  if (entityKey) {
    const entity = contentState.getEntity(entityKey);
    const data = entity.getData();
    emote = data.emote;
  } else {
    emote = decoratedText.substr(1, decoratedText.length - 2);
  }
  const { entityMap } = convertToRaw(contentState);
  const numOfEmotes = Object.keys(entityMap).length;
  let hasPlainText = false;
  if (numOfEmotes <= MAX_LARGE_EMOTES) {
    const text = contentState.getPlainText("");
    const textWithoutEmotes = text.replace(EMOTE_REGEX, "");
    hasPlainText = Boolean(textWithoutEmotes.length);
  }
  const isLarge = !hasPlainText && numOfEmotes <= MAX_LARGE_EMOTES;
  return /* @__PURE__ */ React56.createElement(NxEmote, {
    emoteKey: emote,
    isLarge
  });
}

// src/empty-state/NxEmptyState.tsx
import React57 from "react";
import { Box as Box28, useMediaQuery as useMediaQuery5, useTheme as useTheme21 } from "@material-ui/core";
import clsx17 from "clsx";

// src/empty-state/EmptyState.styles.tsx
import { makeStyles as makeStyles43 } from "@material-ui/core";
var useStyles42 = makeStyles43((theme) => ({
  root: ({ isStandalone = false }) => ({
    backgroundColor: isStandalone ? "transparent" : theme.palette.ColorBackgroundBase,
    borderRadius: theme.shape.borderRadius * 2.5,
    boxShadow: isStandalone ? void 0 : theme.mixins.boxShadow.elevation1,
    padding: theme.spacing(9, 0),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(8, 3)
    }
  }),
  title: {
    marginTop: theme.spacing(2),
    textAlign: "center"
  },
  subtitle: ({ hasCta }) => ({
    marginTop: theme.spacing(1),
    textAlign: "center",
    marginBottom: hasCta ? theme.spacing(3) : 0
  })
}));

// src/empty-state/NxEmptyState.tsx
function NxEmptyState({
  className,
  cta,
  subtitle,
  title,
  spot,
  isStandalone
}) {
  const hasCta = !!cta;
  const classes = useStyles42({ hasCta, isStandalone });
  const theme = useTheme21();
  const isXs = useMediaQuery5(theme.breakpoints.down("xs"));
  return /* @__PURE__ */ React57.createElement(Box28, {
    alignItems: "center",
    className: clsx17(classes.root, className),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, spot, /* @__PURE__ */ React57.createElement(NxTypography, {
    className: classes.title,
    colorToken: "ColorTextBase",
    variant: isXs ? "h4" : "h1"
  }, title), subtitle && /* @__PURE__ */ React57.createElement(NxTypography, {
    className: classes.subtitle,
    colorToken: "ColorTextAlt2",
    variant: isXs ? "body1" : "subtitle1"
  }, subtitle), cta);
}

// src/enrolled-league-card/NxEnrolledLeagueCard.tsx
import React58 from "react";
import { Box as Box29 } from "@material-ui/core";
import { CarretRight } from "@playvs-inc/nexus-icons";

// src/enrolled-league-card/EnrolledLeagueCard.styles.ts
import { makeStyles as makeStyles44 } from "@material-ui/core";
var useStyles43 = makeStyles44((theme) => ({
  root: {
    width: 302
  },
  verticalLine: ({
    borderColor
  }) => ({
    borderLeft: `8px solid ${borderColor}`,
    borderTopLeftRadius: theme.shape.borderRadius * 2.5,
    borderBottomLeftRadius: theme.shape.borderRadius * 2.5
  }),
  card: {
    borderTopRightRadius: theme.shape.borderRadius * 2.5,
    borderBottomRightRadius: theme.shape.borderRadius * 2.5,
    boxShadow: theme.mixins.boxShadow.elevation1,
    cursor: "pointer",
    minHeight: 100,
    padding: theme.spacing(2),
    width: "100%",
    backgroundColor: theme.palette.ColorBackgroundBase
  },
  body: {
    marginLeft: theme.spacing(2),
    width: "100%"
  },
  title: {
    marginBottom: theme.spacing(0.5)
  },
  icon: {
    marginLeft: "auto"
  }
}));

// src/enrolled-league-card/EnrolledLeagueCardHelpers.ts
import { useTheme as useTheme22 } from "@material-ui/core";
var useGetEnrolledLeagueCardHelpers = (esport) => {
  const theme = useTheme22();
  switch (esport) {
    case EsportSlug.Hearthstone:
      return {
        borderColor: theme.palette.ColorEsportAccentHS5
      };
    case EsportSlug.LeagueOfLegends:
      return {
        borderColor: theme.palette.ColorEsportAccentLoL6
      };
    case EsportSlug.Madden:
    case EsportSlug.Madden21PS4:
    case EsportSlug.Madden21SolosXboxOne:
    case EsportSlug.Madden21XboxOne:
      return {
        borderColor: theme.palette.ColorEsportAccentMadden4
      };
    case EsportSlug.MarioKart:
      return {
        borderColor: theme.palette.ColorEsportAccentMk4
      };
    case EsportSlug.NBA2K:
      return {
        borderColor: theme.palette.ColorEsportAccentNBA7
      };
    case EsportSlug.Overwatch:
      return {
        borderColor: theme.palette.ColorEsportAccentOW4
      };
    case EsportSlug.RocketLeague:
    case EsportSlug.RocketLeagueGMA:
      return {
        borderColor: theme.palette.ColorEsportAccentRL6
      };
    case EsportSlug.SmashBrosUltimate:
      return {
        borderColor: theme.palette.ColorEsportAccentSU4
      };
    case EsportSlug.Splatoon:
      return {
        borderColor: theme.palette.ColorEsportAccentSplatoon4
      };
    case EsportSlug.FC:
      return {
        borderColor: theme.palette.ColorEsportAccentFC4
      };
    case EsportSlug.ARAM:
      return {
        borderColor: theme.palette.ColorEsportAccentARAM4
      };
    case EsportSlug.CollegeFootball25:
      return {
        borderColor: theme.palette.ColorEsportAccentCFB254
      };
    case EsportSlug.Fortnite:
      return {
        borderColor: theme.palette.ColorEsportAccentFn4
      };
    case EsportSlug.StreetFighter:
      return {
        borderColor: theme.palette.ColorEsportAccentSF64
      };
    default:
      return {
        borderColor: theme.palette.ColorBackgroundAccent
      };
  }
};

// src/enrolled-league-card/NxEnrolledLeagueCard.tsx
function NxEnrolledLeagueCard(_a) {
  var _b = _a, {
    className,
    esport,
    onClick,
    subtitle,
    title
  } = _b, props = __objRest(_b, [
    "className",
    "esport",
    "onClick",
    "subtitle",
    "title"
  ]);
  const { borderColor } = useGetEnrolledLeagueCardHelpers(esport);
  const classes = useStyles43({ borderColor });
  return /* @__PURE__ */ React58.createElement(Box29, {
    className: `${classes.root} ${className}`,
    display: "flex"
  }, /* @__PURE__ */ React58.createElement("div", {
    className: classes.verticalLine
  }), /* @__PURE__ */ React58.createElement(Box29, __spreadValues({
    alignItems: "center",
    className: classes.card,
    display: "flex",
    onClick
  }, props), /* @__PURE__ */ React58.createElement(NxEsportAvatar, {
    esport,
    iconHeight: 38,
    iconWidth: 38
  }), /* @__PURE__ */ React58.createElement("div", {
    className: classes.body
  }, /* @__PURE__ */ React58.createElement(NxTypography, {
    className: classes.title,
    variant: "body2"
  }, title), /* @__PURE__ */ React58.createElement(Box29, {
    alignItems: "center",
    display: "flex"
  }, subtitle && /* @__PURE__ */ React58.createElement(NxTypography, {
    variant: "body1"
  }, subtitle), /* @__PURE__ */ React58.createElement(CarretRight, {
    className: classes.icon
  })))));
}

// src/error-state/NxErrorState.tsx
import React61 from "react";
import { Box as Box30, useMediaQuery as useMediaQuery6, useTheme as useTheme23 } from "@material-ui/core";
import { MUIThemeModeEnum as MUIThemeModeEnum6 } from "@playvs-inc/nexus-theme";

// src/error-state/ErrorState.styles.tsx
import { makeStyles as makeStyles45 } from "@material-ui/core";
var useStyles44 = makeStyles45((theme) => ({
  root: ({ isStandalone = false }) => ({
    backgroundColor: isStandalone ? "transparent" : theme.palette.ColorBackgroundBase,
    borderRadius: theme.shape.borderRadius * 2.5,
    boxShadow: isStandalone ? void 0 : theme.mixins.boxShadow.elevation1,
    padding: theme.spacing(9, 3)
  }),
  container: {
    width: 416,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(8, 3),
      width: "auto"
    },
    textAlign: "center"
  },
  title: {
    marginTop: theme.spacing(3),
    textAlign: "center"
  },
  subtitle: {
    padding: theme.spacing(3),
    textAlign: "center",
    marginBottom: 0
  },
  cta: {
    padding: theme.spacing(0, 8),
    textAlign: "center",
    marginBottom: 0,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 3)
    }
  }
}));

// src/error-state/ErrorStateLightLarge.tsx
import * as React59 from "react";
function SvgErrorStateLightLarge(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React59.createElement("svg", __spreadValues({
    fill: "none",
    height: 200,
    viewBox: "0 0 200 200",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React59.createElement("path", {
    d: "M65.209 33.824c.096 2.695 1.305 5.463 3.618 6.982.208.136.29.284.272.538-.042 1.961.162 4.14 1.39 5.735.634.705 1.746-.049 1.348-.924-.676-1.394-.98-2.895-.964-4.438 4.7.961 7.67-3.862 3.588-5.311-2.02-.456-3.901.973-4.754 2.711-1.246-.415-2.82-3.301-2.643-5.194 1.987-.289 4.241-1.254 4.424-3.534.2-2.47-2.722-2.844-4.194-1.394-.962.764-1.43 1.812-1.895 2.926-4.366-1.177-2.945-4.971-4.432-4.89-1.296.086-.692 1.846-.461 2.65.738 2.24 2.555 3.447 4.702 4.142Zm6.116 6.093c.353-.704.772-1.216 1.372-1.51.534-.178 1.492-.59 1.824.104.149 1.375-2.122 1.67-3.196 1.406Zm-4.001-7.933c.363-.868.823-1.538 1.626-1.93.377-.209.916-.182.71.383-.314 1.013-1.255 1.475-2.336 1.547Zm73.372-5.002c-.088 2.695-1.288 5.467-3.596 6.993-.206.138-.288.286-.269.54.048 1.96-.149 4.141-1.372 5.74-.632.707-1.745-.043-1.351-.92.672-1.396.97-2.899.949-4.441-4.696.976-7.682-3.837-3.605-5.3 2.018-.462 3.904.96 4.764 2.696 1.244-.42 2.808-3.31 2.625-5.203-1.987-.282-4.245-1.24-4.436-3.52-.207-2.468 2.713-2.852 4.19-1.407.964.76 1.436 1.807 1.905 2.92 4.362-1.192 2.928-4.98 4.416-4.906 1.295.083.697 1.845.469 2.649-.73 2.243-2.544 3.456-4.688 4.158h-.001Zm-6.096 6.113c-.356-.703-.776-1.213-1.377-1.505-.535-.176-1.494-.585-1.824.11-.144 1.375 2.128 1.664 3.201 1.395Zm3.975-7.946c-.366-.867-.829-1.535-1.632-1.925-.379-.207-.917-.178-.709.386.317 1.012 1.259 1.47 2.341 1.54Z",
    fill: "#FFB694"
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "M93.708 19.011c7.558.204 12.509 10.38 4 13.578-4.74 1.839-2.712 7.866-5.958 7.594-3.787-.75.872-9.586 3.625-10.251 1.246-.883 3.712-1.394 3.3-3.348-1.073-4.697-8.152-5.86-9.035-.372-.485 2.281-3.433 1.76-3.095-.534.301-3.608 3.452-6.79 7.163-6.667Zm.129 26.477c-.038 1.392.011 2.92-1.566 3.022-.746.03-1.5-.426-1.569-1.206a16.858 16.858 0 0 1 .072-3.417c.086-.726.795-1.134 1.506-1.11 1.42-.084 1.606 1.792 1.556 2.711Zm24.619-5.478c.281-1.307.485-2.603.654-3.931.079-.616.155-1.232.23-1.849.034-.292.071-.583.108-.874.021-.162.04-.324.063-.486a133.734 133.734 0 0 1 1.205-7.282c.24-1.227-.345-2.645-1.673-2.947-1.178-.268-2.701.357-2.947 1.674a112.14 112.14 0 0 0-1.18 7.78c-.285 2.468-.524 4.915-.309 7.395.084.98.681 1.788 1.698 1.924.913.122 1.944-.447 2.15-1.403h.001Zm-2.695 8.501c1.238 0 2.424-1.089 2.367-2.367-.058-1.282-1.04-2.367-2.367-2.367-1.237 0-2.423 1.089-2.367 2.367.058 1.282 1.04 2.367 2.367 2.367Z",
    fill: "#272A2B"
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "m136.127 113.366 23.488-49.91-52.754 20.54v-21.08c-7.084 0-13.98 1.441-20.505 3.964-6.338 2.703-12.303 6.666-17.15 11.531-4.846 4.865-8.76 10.81-11.184 17.117-2.61 6.486-3.728 13.153-3.356 20 1.305 25.765 22.929 46.846 49.585 47.927a53.459 53.459 0 0 0 20.692-3.063c6.524-2.342 12.675-5.946 17.708-10.631 5.033-4.684 9.134-10.27 11.931-16.576 2.796-6.306 4.287-12.973 4.287-19.819h-22.742Z",
    fill: "#C9CDCF"
  }), /* @__PURE__ */ React59.createElement("ellipse", {
    cx: 96.964,
    cy: 179.059,
    fill: "#D4D7D8",
    rx: 69.614,
    ry: 4.643
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "M166.579 142.189h10.357m-5.179 5.18v-10.357",
    stroke: "#FFB694",
    strokeLinecap: "round",
    strokeWidth: 2.26
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "m67.717 104.773 9.926 9.926m-9.926 0 9.926-9.925m20.074-.001 9.926 9.926m-9.926 0 9.926-9.925",
    stroke: "#272A2B",
    strokeLinecap: "round",
    strokeWidth: 5.421
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "M40.57 154.529h7.5m-3.75 3.75v-7.5",
    stroke: "#FFB694",
    strokeLinecap: "round",
    strokeWidth: 1.636
  }), /* @__PURE__ */ React59.createElement("circle", {
    cx: 27.35,
    cy: 137.008,
    r: 3.257,
    stroke: "#FFB694",
    strokeWidth: 2.057
  }), /* @__PURE__ */ React59.createElement("circle", {
    cx: 152.579,
    cy: 158.101,
    fill: "#FFB694",
    r: 2.714,
    stroke: "#FFB694",
    strokeWidth: 1.714
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "M141.513 60.645 97.391 78.418V59.916h-3c-6.903 0-13.588 1.454-19.865 3.965l-.05.02-.047.02c-6.14 2.71-11.92 6.68-16.633 11.574-4.704 4.885-8.507 10.853-10.871 17.21-2.532 6.518-3.623 13.24-3.26 20.14 1.27 25.892 22.254 47.091 48.197 48.188a50.358 50.358 0 0 0 20.109-3.082c6.321-2.348 12.308-5.968 17.231-10.709 4.874-4.694 8.863-10.307 11.586-16.662 2.709-6.319 4.164-13.027 4.164-19.933v-3h-19.137l19.549-42.977 3.106-6.828-6.957 2.803Z",
    stroke: "#272A2B",
    strokeWidth: 6
  }), /* @__PURE__ */ React59.createElement("path", {
    d: "M80.677 135.305h21.5",
    stroke: "#272A2B",
    strokeLinecap: "round",
    strokeWidth: 5
  }));
}
var ErrorStateLightLarge_default = SvgErrorStateLightLarge;

// src/error-state/ErrorStateDarkLarge.tsx
import * as React60 from "react";
function SvgErrorStateDarkLarge(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React60.createElement("svg", __spreadValues({
    fill: "none",
    height: 200,
    viewBox: "0 0 200 200",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React60.createElement("path", {
    d: "M65.209 33.826c.096 2.695 1.305 5.462 3.618 6.981.208.137.29.285.272.538-.042 1.962.162 4.142 1.39 5.736.634.705 1.746-.049 1.348-.924-.676-1.394-.98-2.895-.964-4.438 4.7.961 7.67-3.862 3.588-5.312-2.02-.455-3.901.974-4.754 2.712-1.246-.415-2.82-3.301-2.643-5.194 1.987-.289 4.241-1.254 4.424-3.534.2-2.47-2.722-2.844-4.194-1.394-.962.763-1.43 1.812-1.895 2.926-4.366-1.177-2.945-4.971-4.432-4.891-1.296.087-.692 1.847-.461 2.65.738 2.24 2.555 3.448 4.702 4.143Zm6.116 6.093c.353-.704.772-1.216 1.372-1.51.534-.178 1.492-.59 1.824.104.149 1.375-2.122 1.67-3.196 1.406Zm-4.001-7.933c.363-.868.823-1.538 1.626-1.93.377-.21.916-.182.71.383-.314 1.013-1.255 1.475-2.336 1.547Zm73.372-5.002c-.088 2.695-1.288 5.467-3.596 6.993-.206.138-.288.286-.269.54.048 1.96-.149 4.141-1.372 5.74-.632.707-1.745-.043-1.351-.92.672-1.396.97-2.899.949-4.441-4.696.976-7.682-3.837-3.605-5.3 2.018-.462 3.904.96 4.764 2.696 1.244-.42 2.808-3.31 2.625-5.203-1.987-.282-4.245-1.24-4.436-3.52-.207-2.468 2.713-2.852 4.19-1.407.964.76 1.436 1.807 1.905 2.92 4.362-1.192 2.928-4.98 4.416-4.906 1.295.083.697 1.845.469 2.649-.73 2.243-2.544 3.456-4.688 4.158h-.001Zm-6.096 6.113c-.356-.703-.776-1.213-1.377-1.505-.535-.176-1.494-.585-1.824.11-.144 1.375 2.128 1.663 3.201 1.395Zm3.975-7.946c-.366-.867-.829-1.535-1.632-1.925-.379-.207-.917-.178-.709.386.317 1.012 1.259 1.47 2.341 1.54Z",
    fill: "#FF9D70"
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "M93.708 19.013c7.558.204 12.509 10.38 4 13.578-4.74 1.839-2.712 7.865-5.958 7.594-3.787-.75.872-9.586 3.625-10.251 1.246-.883 3.712-1.394 3.3-3.348-1.073-4.697-8.152-5.86-9.035-.372-.485 2.281-3.433 1.76-3.095-.534.301-3.608 3.452-6.79 7.163-6.667Zm.129 26.477c-.038 1.392.011 2.92-1.566 3.022-.746.03-1.5-.427-1.569-1.206a16.858 16.858 0 0 1 .072-3.417c.086-.726.795-1.134 1.506-1.11 1.42-.084 1.606 1.792 1.556 2.711Zm24.619-5.477c.281-1.308.485-2.605.654-3.932.079-.616.155-1.232.23-1.849.034-.292.071-.583.108-.874.021-.162.04-.324.063-.486a133.737 133.737 0 0 1 1.205-7.282c.24-1.227-.345-2.645-1.673-2.947-1.178-.268-2.701.357-2.947 1.674-.484 2.58-.878 5.172-1.18 7.78-.285 2.468-.524 4.915-.309 7.395.084.98.681 1.788 1.698 1.924.913.122 1.944-.447 2.15-1.403h.001Zm-2.695 8.5c1.238 0 2.424-1.089 2.367-2.367-.058-1.282-1.04-2.367-2.367-2.367-1.237 0-2.423 1.089-2.367 2.367.058 1.282 1.04 2.367 2.367 2.367Z",
    fill: "#878F92"
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "m136.127 113.368 23.488-49.91-52.754 20.54v-21.08c-7.084 0-13.98 1.441-20.505 3.964-6.338 2.703-12.303 6.666-17.15 11.531-4.846 4.865-8.76 10.81-11.184 17.117-2.61 6.486-3.728 13.153-3.356 20 1.305 25.765 22.929 46.846 49.585 47.927a53.459 53.459 0 0 0 20.692-3.063c6.524-2.343 12.675-5.946 17.708-10.631 5.033-4.684 9.134-10.27 11.931-16.576 2.796-6.306 4.287-12.973 4.287-19.819h-22.742Z",
    fill: "#272A2B"
  }), /* @__PURE__ */ React60.createElement("ellipse", {
    cx: 96.964,
    cy: 179.061,
    fill: "#3D4143",
    rx: 69.614,
    ry: 4.643
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "M166.579 142.191h10.357m-5.179 5.18v-10.357",
    stroke: "#FF9D70",
    strokeLinecap: "round",
    strokeWidth: 2.26
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "m67.717 104.775 9.926 9.926m-9.926 0 9.926-9.925m20.074-.001 9.926 9.926m-9.926 0 9.926-9.925",
    stroke: "#878F92",
    strokeLinecap: "round",
    strokeWidth: 5.421
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "M40.57 154.531h7.5m-3.75 3.75v-7.5",
    stroke: "#FF9D70",
    strokeLinecap: "round",
    strokeWidth: 1.636
  }), /* @__PURE__ */ React60.createElement("circle", {
    cx: 27.35,
    cy: 137.01,
    r: 3.257,
    stroke: "#FF9D70",
    strokeWidth: 2.057
  }), /* @__PURE__ */ React60.createElement("circle", {
    cx: 152.579,
    cy: 158.103,
    fill: "#FF9D70",
    r: 2.714,
    stroke: "#FF9D70",
    strokeWidth: 1.714
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "M141.513 60.647 97.391 78.42V59.918h-3c-6.903 0-13.588 1.454-19.865 3.965l-.05.02-.047.02c-6.14 2.71-11.92 6.68-16.633 11.574-4.704 4.885-8.507 10.853-10.871 17.21-2.532 6.518-3.623 13.24-3.26 20.14 1.27 25.892 22.254 47.091 48.197 48.188a50.358 50.358 0 0 0 20.109-3.082c6.321-2.348 12.308-5.968 17.231-10.709 4.874-4.694 8.863-10.307 11.586-16.662 2.709-6.319 4.164-13.027 4.164-19.933v-3h-19.137l19.549-42.978 3.106-6.827-6.957 2.803Z",
    stroke: "#878F92",
    strokeWidth: 6
  }), /* @__PURE__ */ React60.createElement("path", {
    d: "M80.677 135.307h21.5",
    stroke: "#878F92",
    strokeLinecap: "round",
    strokeWidth: 5
  }));
}
var ErrorStateDarkLarge_default = SvgErrorStateDarkLarge;

// src/error-state/NxErrorState.tsx
function NxErrorState({
  componentDescription,
  additionalInfo,
  isStandalone
}) {
  const classes = useStyles44({ isStandalone });
  const theme = useTheme23();
  const isXs = useMediaQuery6(theme.breakpoints.down("xs"));
  return /* @__PURE__ */ React61.createElement(Box30, {
    alignItems: "center",
    className: classes.root,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /* @__PURE__ */ React61.createElement(Box30, {
    className: classes.container
  }, theme.palette.type === MUIThemeModeEnum6.Light ? /* @__PURE__ */ React61.createElement(ErrorStateLightLarge_default, {
    height: 200,
    width: 200
  }) : /* @__PURE__ */ React61.createElement(ErrorStateDarkLarge_default, {
    height: 200,
    width: 200
  }), /* @__PURE__ */ React61.createElement(NxTypography, {
    className: classes.title,
    colorToken: "ColorTextBase",
    variant: isXs ? "h4" : "h1"
  }, "Something went wrong"), /* @__PURE__ */ React61.createElement(NxTypography, {
    className: classes.subtitle,
    colorToken: "ColorTextBase",
    variant: "body1"
  }, componentDescription ? `The ${componentDescription} failed to load properly. We are working on a fix. ${additionalInfo}` : "We are working on a fix to resolve this. Hang tight, we will be back shortly."), /* @__PURE__ */ React61.createElement(NxTypography, {
    className: classes.cta,
    colorToken: "ColorTextAlt",
    variant: "body4"
  }, "Please contact us through our", " ", /* @__PURE__ */ React61.createElement(NxTextLink, {
    href: "https://help.playvs.com",
    label: "Help Center",
    labelVariant: "body4"
  }), " ", "if this issue persists.")));
}

// src/esport-selectable/NxEsportSelectable.tsx
import React63, { useState as useState10 } from "react";
import { Box as Box32 } from "@material-ui/core";

// src/esport-selectable/EsportSelectableCard.tsx
import React62 from "react";
import { Box as Box31, useTheme as useTheme24 } from "@material-ui/core";
import clsx18 from "clsx";
import { useEsport as useEsport6 } from "@playvs-inc/nexus-theme";

// src/esport-selectable/EsportSelectable.styles.ts
import { makeStyles as makeStyles46 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles45 = makeStyles46((theme) => ({
  base: ({ selected }) => ({
    cursor: "pointer",
    width: "164px",
    height: "164px",
    borderRadius: "10px",
    justifyContent: "center",
    border: selected ? `3px solid ${theme.palette.BorderDark}` : "none",
    "&:hover": {
      border: selected ? `3px solid ${theme.palette.BorderDark}` : `3px solid ${theme.palette.BorderMedium}`,
      "& div": {
        transform: "scale(0.878)"
      }
    },
    "@media (max-width:390px)": {
      width: "146px",
      height: "146px"
    }
  }),
  cardTitle: {
    color: theme.palette.common.white,
    alignSelf: "end"
  },
  icon: {
    position: "absolute",
    top: 8,
    left: 81,
    height: 75,
    width: 75,
    "@media (max-width:390px)": {
      left: 58,
      height: 60,
      width: 60
    }
  },
  titleBox: ({ esportColor, selected }) => ({
    transform: selected ? "scale(0.878)" : "scale(1)",
    width: "164px",
    height: "164px",
    borderRadius: "10px",
    background: esportColor,
    position: "relative",
    alignSelf: "center",
    "@media (max-width:390px)": {
      width: "146px",
      height: "146px"
    }
  })
}));

// src/esport-selectable/EsportSelectableCard.tsx
function EsportSelectableCard({
  esport: esportSlug,
  tabIndex,
  selected,
  className,
  esportName
}) {
  var _a, _b;
  const theme = useTheme24();
  const esportProps = useGetEsportsProps2(esportSlug);
  const esport = useEsport6(esportSlug);
  const esportColor = ((_a = esport == null ? void 0 : esport.palette) == null ? void 0 : _a.baseColor) || theme.palette.ColorBackgroundInvert;
  const esportIconColor = ((_b = esport == null ? void 0 : esport.palette) == null ? void 0 : _b[1]) || theme.palette.ColorTextInvert;
  const classes = useStyles45({
    esportColor,
    selected
  });
  const name = esportName != null ? esportName : esportProps.title;
  return /* @__PURE__ */ React62.createElement(Box31, {
    className: clsx18(classes.base, className),
    display: "flex",
    tabIndex: tabIndex != null ? tabIndex : 0
  }, /* @__PURE__ */ React62.createElement(Box31, {
    alignItems: "center",
    alignSelf: "flex-end",
    className: classes.titleBox,
    display: "flex",
    padding: 2,
    zIndex: "1"
  }, /* @__PURE__ */ React62.createElement(NxEsportIcon, {
    className: classes.icon,
    color: esportIconColor,
    esportSlug: esportSlug != null ? esportSlug : "",
    mode: "dark"
  }), /* @__PURE__ */ React62.createElement(NxTypography, {
    className: classes.cardTitle,
    "data-cy": esport,
    variant: "h4"
  }, name)));
}

// src/esport-selectable/NxEsportSelectable.tsx
var NxEsportSelectable = React63.memo(({
  esports,
  onChange,
  value,
  defaultValue,
  tabIndex,
  className,
  esportNames
}) => {
  const [selectedIndex, setSelectedIndex] = useState10(defaultValue != null ? defaultValue : -1);
  const computedSelectedValue = value != null ? value : selectedIndex;
  const handleSelect = (evt, index) => {
    setSelectedIndex(index);
    onChange == null ? void 0 : onChange(evt, index);
  };
  const handleOnKeyUp = (evt, choiceIndex) => {
    var _a, _b, _c, _d, _e, _f;
    if (evt.key === " " || evt.key === "Enter") {
      evt.preventDefault();
      if (choiceIndex !== computedSelectedValue) {
        handleSelect(evt, choiceIndex);
      }
    } else if (evt.key === "ArrowLeft" && selectedIndex >= 0) {
      evt.preventDefault();
      const targetChoice = (esports.length + selectedIndex - 1) % esports.length;
      handleSelect(evt, targetChoice);
      const siblings = (_a = evt.currentTarget.parentElement) == null ? void 0 : _a.children;
      (_c = (_b = siblings == null ? void 0 : siblings[targetChoice]).focus) == null ? void 0 : _c.call(_b);
    } else if (evt.key === "ArrowRight" && selectedIndex >= 0) {
      evt.preventDefault();
      const targetChoice = (esports.length + selectedIndex + 1) % esports.length;
      handleSelect(evt, targetChoice);
      const siblings = (_d = evt.currentTarget.parentElement) == null ? void 0 : _d.children;
      (_f = (_e = siblings == null ? void 0 : siblings[targetChoice]).focus) == null ? void 0 : _f.call(_e);
    }
  };
  return /* @__PURE__ */ React63.createElement(Box32, {
    className,
    "data-testid": "NxEsportSelectable__OuterContainer",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gridGap: "1em"
  }, esports.map((esport, choiceIndex) => /* @__PURE__ */ React63.createElement(Box32, {
    key: esport,
    onClick: (evt) => handleSelect(evt, choiceIndex),
    onKeyUp: (evt) => {
      handleOnKeyUp(evt, choiceIndex);
    }
  }, /* @__PURE__ */ React63.createElement(EsportSelectableCard, {
    esport,
    esportName: esportNames == null ? void 0 : esportNames[esport],
    selected: computedSelectedValue === choiceIndex,
    tabIndex
  }))));
});

// src/esport-selectable/NxEsportMultiSelectable.tsx
import React64 from "react";
import { Box as Box33 } from "@material-ui/core";
var NxEsportMultiSelectable = React64.memo(({ esports, onChange, values, className, esportNames }) => {
  const handleSelect = (evt, index) => {
    if (values.includes(index)) {
      const removed = values.filter((item) => item !== index);
      onChange(removed);
    } else {
      onChange([...values, index]);
    }
  };
  return /* @__PURE__ */ React64.createElement(Box33, {
    className,
    "data-testid": "NxEsportMultiSelectable__OuterContainer",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gridGap: "1em"
  }, esports.map((esport, choiceIndex) => /* @__PURE__ */ React64.createElement(Box33, {
    key: esport,
    onClick: (evt) => handleSelect(evt, choiceIndex)
  }, /* @__PURE__ */ React64.createElement(EsportSelectableCard, {
    esport,
    esportName: esportNames == null ? void 0 : esportNames[esport],
    selected: values.includes(choiceIndex),
    tabIndex: choiceIndex
  }))));
});

// src/forms/text-input/NxTextInput.tsx
import React65, {
  forwardRef,
  useCallback,
  useEffect as useEffect3,
  useLayoutEffect as useLayoutEffect2,
  useMemo as useMemo4,
  useState as useState11
} from "react";
import { Box as Box34 } from "@material-ui/core";

// src/forms/text-input/TextInput.styles.ts
import { makeStyles as makeStyles47 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";

// src/forms/base/InputVariant.helpers.ts
function getVariantBorderColor(theme, variant) {
  return {
    success: theme.palette.ColorTextSuccess,
    error: theme.palette.ColorTextError,
    warning: theme.palette.ColorTextWarn,
    default: theme.palette.BorderMedium
  }[variant];
}
function getVariantHelperTextColor(theme, variant) {
  return {
    success: theme.palette.ColorTextSuccess,
    error: theme.palette.ColorTextError,
    warning: theme.palette.ColorTextWarn,
    default: theme.palette.ColorTextAlt
  }[variant];
}

// src/forms/text-input/TextInput.styles.ts
var TextInput_styles_default = makeStyles47((theme) => ({
  wrapper: ({
    fontSize,
    fullWidth
  }) => ({
    height: "max-content",
    width: fullWidth ? "100%" : "max-content",
    fontSize: fontSize != null ? fontSize : "1rem",
    fontFamily: theme.typography.fontFamily,
    position: "relative",
    boxSizing: "border-box",
    marginBottom: fontSize ? `calc(${fontSize} * 0.75)` : "0.75em"
  }),
  input: ({
    variant,
    disabled,
    fullWidth,
    hasAdornment
  }) => ({
    "&::-webkit-calendar-picker-indicator": {
      margin: theme.spacing(-1.9, -2, 0, 0)
    },
    "&::-webkit-clear-button": {
      display: "none"
    },
    backgroundColor: disabled ? theme.palette.ColorBackgroundInactive : theme.palette.ColorBackgroundBase,
    boxSizing: "border-box",
    paddingLeft: "1em",
    paddingRight: hasAdornment ? "2em" : "1em",
    height: "3em",
    width: fullWidth ? "100%" : void 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: "1em",
    borderStyle: "solid",
    borderWidth: "1px",
    color: disabled ? theme.palette.ColorTextDisabled : theme.palette.ColorTextBase,
    borderColor: disabled ? theme.palette.BorderMedium : getVariantBorderColor(theme, variant),
    borderRadius: theme.shape.borderRadius,
    paddingTop: theme.spacing(2),
    paddingBottom: 0,
    outlineColor: variant === "default" ? theme.palette.ColorBackgroundInvert : getVariantBorderColor(theme, variant),
    outlineWidth: "1px",
    "&:active": {
      borderWidth: "1px",
      borderColor: disabled ? theme.palette.BorderMedium : getVariantBorderColor(theme, variant)
    },
    "&:hover": {
      borderWidth: "1px",
      borderColor: variant === "default" ? theme.palette.ColorBackgroundInvert : getVariantBorderColor(theme, variant)
    },
    "&:focus-visible": {
      outlineStyle: "initial"
    },
    "&::placeholder": {
      color: theme.palette.ColorTextAlt2
    },
    "&:-ms-input-placeholder": {
      color: theme.palette.ColorTextAlt2
    },
    "&::-ms-input-placeholder": {
      color: theme.palette.ColorTextAlt2
    },
    transition: "all 0.3s ease-in-out",
    "&:placeholder-shown": {
      paddingTop: "0.6em"
    }
  }),
  floatingLabel: ({
    fontSize
  }) => ({
    position: "absolute",
    left: `calc(2.75em - ${fontSize})`,
    top: theme.spacing(1),
    zIndex: 2,
    fontWeight: theme.typography.body3.fontWeight,
    fontFamily: theme.typography.fontFamily,
    fontSize: "0.75em",
    lineHeight: theme.typography.body3.lineHeight,
    color: theme.palette.ColorTextAlt2
  }),
  helperText: ({
    fontSize,
    variant
  }) => ({
    position: "absolute",
    top: "100%",
    color: getVariantHelperTextColor(theme, variant),
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.body3.fontWeight,
    fontSize: fontSize ? `calc(${fontSize} * 0.75)` : "0.75em",
    lineHeight: theme.typography.body3.lineHeight
  }),
  passwordIcon: {
    position: "absolute",
    right: 5,
    top: theme.spacing(2)
  }
}));

// src/forms/text-input/NxTextInput.tsx
var NxTextInput = forwardRef((props, ref) => {
  const _a = props, {
    defaultValue,
    disabled,
    id,
    fontSize = "1rem",
    fullWidth = false,
    helperText,
    label,
    name,
    variant = "default",
    value,
    onChange,
    endAdornment
  } = _a, remainingProps = __objRest(_a, [
    "defaultValue",
    "disabled",
    "id",
    "fontSize",
    "fullWidth",
    "helperText",
    "label",
    "name",
    "variant",
    "value",
    "onChange",
    "endAdornment"
  ]);
  const [hasInput, setHasInput] = useState11(!!value || !!defaultValue);
  const labelId = useMemo4(() => `NxTextInput.${Date.now()}.${Math.random()}`, []);
  const inputId = useMemo4(() => id != null ? id : `NxTextInput.${Date.now()}.${Math.random()}`, [id]);
  useLayoutEffect2(() => {
    const inputElement = window.document.getElementById(inputId);
    if (!!(inputElement == null ? void 0 : inputElement.value) && !hasInput) {
      setHasInput(true);
    }
  }, []);
  useEffect3(() => {
    if (!!value && !hasInput) {
      setHasInput(true);
    } else if (!value && typeof value !== "undefined" && hasInput) {
      setHasInput(false);
    }
  }, [value, hasInput]);
  const checkValueWasEntered = useCallback((evt) => {
    let valueDetected = !!value;
    if (typeof value === "undefined") {
      valueDetected = !!evt.currentTarget.value;
    }
    if (hasInput !== valueDetected) {
      setHasInput(valueDetected);
    }
  }, [setHasInput, hasInput, value]);
  const classes = TextInput_styles_default({
    fontSize,
    variant,
    disabled,
    fullWidth,
    hasAdornment: !!endAdornment
  });
  return /* @__PURE__ */ React65.createElement(Box34, {
    className: classes.wrapper
  }, /* @__PURE__ */ React65.createElement("input", __spreadProps(__spreadValues({
    ref,
    className: classes.input,
    defaultValue,
    disabled,
    id: inputId,
    name,
    onChange: (e) => {
      checkValueWasEntered(e);
      onChange == null ? void 0 : onChange(e);
    },
    placeholder: label,
    value
  }, remainingProps), {
    "aria-labelledby": hasInput ? labelId : void 0
  })), (!!hasInput || remainingProps.type === "time") && /* @__PURE__ */ React65.createElement("label", {
    className: classes.floatingLabel,
    htmlFor: name,
    id: labelId
  }, label), !!helperText && /* @__PURE__ */ React65.createElement("div", {
    "aria-label": "input caption",
    className: classes.helperText
  }, helperText), /* @__PURE__ */ React65.createElement(Box34, {
    className: classes.passwordIcon
  }, !!endAdornment && endAdornment));
});

// src/forms/text-area/NxTextArea.tsx
import React66, {
  forwardRef as forwardRef2,
  useCallback as useCallback2,
  useEffect as useEffect4,
  useLayoutEffect as useLayoutEffect3,
  useMemo as useMemo5,
  useState as useState12
} from "react";
import { Box as Box35 } from "@material-ui/core";
import clsx19 from "clsx";

// src/forms/text-area/NxTextArea.styles.ts
import { makeStyles as makeStyles48 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var NxTextArea_styles_default = makeStyles48((theme) => ({
  wrapper: ({
    fontSize,
    fullWidth
  }) => ({
    height: "max-content",
    width: fullWidth ? "100%" : "max-content",
    fontFamily: theme.typography.fontFamily,
    fontSize: fontSize != null ? fontSize : "1rem",
    position: "relative",
    boxSizing: "border-box",
    marginBottom: fontSize ? `calc(${fontSize} * 0.75)` : "0.75em"
  }),
  input: ({
    variant,
    disabled,
    fullWidth,
    fontSize
  }) => ({
    resize: "none",
    backgroundColor: disabled ? theme.palette.ColorBackgroundInactive : theme.palette.ColorBackgroundBase,
    boxSizing: "border-box",
    paddingLeft: "1em",
    paddingRight: "1em",
    width: fullWidth ? "100%" : void 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: "1em",
    borderStyle: "solid",
    borderWidth: "1px",
    color: disabled ? theme.palette.ColorTextDisabled : theme.palette.ColorTextBase,
    borderColor: disabled ? theme.palette.BorderMedium : getVariantBorderColor(theme, variant),
    borderRadius: theme.shape.borderRadius,
    paddingTop: `calc(${fontSize} + ${theme.spacing(1.5)}px)`,
    paddingBottom: 0,
    outlineColor: variant === "default" ? theme.palette.ColorBackgroundInvert : getVariantBorderColor(theme, variant),
    outlineWidth: "1px",
    "&:active": {
      borderWidth: "1px",
      borderColor: disabled ? theme.palette.BorderMedium : getVariantBorderColor(theme, variant)
    },
    "&:hover": {
      borderWidth: "1px",
      borderColor: variant === "default" ? theme.palette.ColorBackgroundInvert : getVariantBorderColor(theme, variant)
    },
    "&:focus-visible": {
      outlineStyle: "initial"
    },
    "&::placeholder": {
      color: theme.palette.ColorTextAlt2
    },
    "&:-ms-input-placeholder": {
      color: theme.palette.ColorTextAlt2
    },
    "&::-ms-input-placeholder": {
      color: theme.palette.ColorTextAlt2
    },
    "&::-webkit-scrollbar": {
      right: theme.spacing(0.5),
      background: "transparent",
      width: theme.spacing(1),
      border: `${theme.spacing(0.5)}px transparent`
    },
    "&::-webkit-scrollbar-thumb": {
      width: theme.spacing(1.5),
      background: theme.palette.ColorBackgroundAlt2,
      borderRadius: 0,
      borderRight: `${theme.spacing(0.5)}px solid rgba(255,255,255,0)`,
      outlineColor: "transparent",
      outline: "0 4px 0 0",
      backgroundClip: "padding-box"
    },
    transition: "all 0.3s ease-in-out"
  }),
  floatingLabel: ({
    fontSize
  }) => ({
    position: "absolute",
    left: `calc(2em - ${fontSize})`,
    top: "0.5em",
    zIndex: 2,
    color: theme.palette.ColorTextAlt2
  }),
  helperText: ({ variant }) => ({
    position: "absolute",
    top: "100%",
    "& p": {
      color: `${getVariantHelperTextColor(theme, variant)} !important`
    }
  }),
  charCount: {
    position: "absolute",
    right: "1em",
    top: "0.5em",
    zIndex: 2,
    color: theme.palette.ColorTextAlt2
  },
  charCountWarning: {
    "& p": {
      color: `${theme.palette.ColorTextWarn} !important`,
      fontWeight: "600 !important"
    }
  },
  charCountFull: {
    "& p": {
      color: `${theme.palette.ColorTextError} !important`,
      fontWeight: "600 !important"
    }
  },
  labelSchim: {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    position: "absolute",
    top: 1,
    paddingTop: theme.spacing(1) - 1,
    left: 1,
    right: 1,
    height: theme.spacing(4) - 1,
    pointerEvents: "none"
  },
  labelSchimWithInput: ({
    disabled
  }) => ({
    backgroundColor: disabled ? theme.palette.ColorBackgroundInactive : theme.palette.ColorBackgroundBase
  })
}));

// src/forms/text-area/NxTextArea.tsx
var NxTextArea = forwardRef2((props, ref) => {
  var _b, _c;
  const _a = props, {
    defaultValue,
    disabled,
    id,
    fontSize = "1rem",
    fullWidth = false,
    helperText,
    label,
    name,
    variant = "default",
    value,
    onChange,
    rows,
    cols,
    maxLength,
    placeholder
  } = _a, remainingProps = __objRest(_a, [
    "defaultValue",
    "disabled",
    "id",
    "fontSize",
    "fullWidth",
    "helperText",
    "label",
    "name",
    "variant",
    "value",
    "onChange",
    "rows",
    "cols",
    "maxLength",
    "placeholder"
  ]);
  const [currentInputLength, setCurrentInputLength] = useState12(((_c = (_b = value == null ? void 0 : value.toString()) != null ? _b : defaultValue == null ? void 0 : defaultValue.toString()) != null ? _c : "").length);
  const labelId = useMemo5(() => `NxTextArea.${Date.now()}.${Math.random()}`, []);
  const inputId = useMemo5(() => id != null ? id : `NxTextArea.${Date.now()}.${Math.random()}`, [id]);
  useLayoutEffect3(() => {
    const inputElement = window.document.getElementById(inputId);
    if (!!(inputElement == null ? void 0 : inputElement.value) && !currentInputLength) {
      setCurrentInputLength(inputElement == null ? void 0 : inputElement.value.length);
    }
  }, []);
  useEffect4(() => {
    if (!!value && !currentInputLength) {
      setCurrentInputLength(value.toString().length);
    } else if (!value && typeof value !== "undefined" && currentInputLength) {
      setCurrentInputLength(0);
    }
  }, [value, currentInputLength]);
  const checkValueWasEntered = useCallback2((evt) => {
    var _a2, _b2, _c2;
    const enteredValueLength = (_c2 = (_b2 = value == null ? void 0 : value.toString().length) != null ? _b2 : (_a2 = evt.currentTarget.value) == null ? void 0 : _a2.toString().length) != null ? _c2 : 0;
    if (currentInputLength !== enteredValueLength) {
      setCurrentInputLength(enteredValueLength);
    }
  }, [setCurrentInputLength, currentInputLength, value]);
  const classes = NxTextArea_styles_default({ fontSize, variant, disabled, fullWidth });
  return /* @__PURE__ */ React66.createElement(Box35, {
    className: classes.wrapper
  }, /* @__PURE__ */ React66.createElement("textarea", __spreadProps(__spreadValues({
    ref,
    className: classes.input,
    cols,
    defaultValue,
    disabled,
    id: inputId,
    maxLength,
    name,
    onChange: (e) => {
      checkValueWasEntered(e);
      onChange == null ? void 0 : onChange(e);
    },
    placeholder,
    rows,
    value
  }, remainingProps), {
    "aria-labelledby": labelId
  })), /* @__PURE__ */ React66.createElement(Box35, {
    className: clsx19(classes.labelSchim, currentInputLength > 0 && !disabled && classes.labelSchimWithInput)
  }, /* @__PURE__ */ React66.createElement("label", {
    className: classes.floatingLabel,
    htmlFor: name,
    id: labelId
  }, /* @__PURE__ */ React66.createElement(NxTypography, {
    variant: "body5"
  }, label)), maxLength && /* @__PURE__ */ React66.createElement("div", {
    className: clsx19(classes.charCount, maxLength !== currentInputLength && currentInputLength / maxLength > 0.9 && classes.charCountWarning, maxLength === currentInputLength && classes.charCountFull)
  }, /* @__PURE__ */ React66.createElement(NxTypography, {
    variant: "body5"
  }, maxLength - currentInputLength))), !!helperText && /* @__PURE__ */ React66.createElement("div", {
    "aria-label": "input caption",
    className: classes.helperText
  }, /* @__PURE__ */ React66.createElement(NxTypography, {
    variant: "body3"
  }, helperText)));
});

// src/forms/select/NxSelect.tsx
import React68 from "react";
import { Box as Box36, FormControl, Select, InputLabel } from "@material-ui/core";
import clsx21 from "clsx";
import { CaretDown } from "@playvs-inc/nexus-icons";

// src/forms/select/NxSelectOption.tsx
import React67 from "react";
import { MenuItem as MenuItem2 } from "@material-ui/core";
import clsx20 from "clsx";

// src/forms/select/NxSelect.styles.tsx
import { makeStyles as makeStyles49 } from "@material-ui/core";
var useStyles46 = makeStyles49((theme) => ({
  select: {
    paddingLeft: theme.spacing(2)
  },
  caret: {
    right: 0,
    marginRight: theme.spacing(2)
  },
  menu: {
    maxHeight: 300,
    boxShadow: theme.mixins.boxShadow.elevation3,
    borderRadius: theme.mixins.cornerRadius["border-radius-10"]
  },
  disabled: {
    background: theme.palette.ColorBackgroundInactive,
    border: theme.palette.BorderLight,
    color: theme.palette.ColorTextDisabled
  },
  item: {
    padding: theme.spacing(1, 1.5),
    "&:hover": {
      background: theme.palette.ColorBackgroundAlt
    }
  }
}));

// src/forms/select/NxSelectOption.tsx
function NxSelectOption(_a) {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  const styles = useStyles46();
  return /* @__PURE__ */ React67.createElement(MenuItem2, __spreadProps(__spreadValues({}, props), {
    button: props.button || void 0,
    className: clsx20(className, styles.item)
  }), /* @__PURE__ */ React67.createElement(NxTypography, {
    variant: "body3"
  }, children));
}

// src/forms/select/NxSelect.tsx
function NxSelect(_a) {
  var _b = _a, {
    value,
    children,
    name,
    label,
    subtitle,
    defaultValue,
    fullWidth = false,
    onChange,
    options,
    error,
    errorText,
    helperText,
    disabled,
    required,
    className
  } = _b, props = __objRest(_b, [
    "value",
    "children",
    "name",
    "label",
    "subtitle",
    "defaultValue",
    "fullWidth",
    "onChange",
    "options",
    "error",
    "errorText",
    "helperText",
    "disabled",
    "required",
    "className"
  ]);
  const styles = useStyles46();
  return /* @__PURE__ */ React68.createElement(FormControl, {
    disabled,
    error,
    fullWidth,
    required,
    variant: "outlined"
  }, /* @__PURE__ */ React68.createElement(InputLabel, null, label), /* @__PURE__ */ React68.createElement(Select, __spreadValues({
    classes: {
      select: styles.select,
      icon: styles.caret
    },
    className: clsx21(className, disabled && styles.disabled),
    defaultValue,
    disabled,
    IconComponent: CaretDown,
    label,
    MenuProps: {
      classes: {
        paper: styles.menu
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      getContentAnchorEl: null
    },
    name,
    onChange,
    value
  }, props), options == null ? void 0 : options.map((attrs) => /* @__PURE__ */ React68.createElement(NxSelectOption, __spreadValues({}, attrs))), children), /* @__PURE__ */ React68.createElement(Box36, {
    mt: 0.25
  }, subtitle && /* @__PURE__ */ React68.createElement(NxTypography, {
    color: "inherit",
    colorToken: "ColorTextAlt",
    variant: "body3"
  }, subtitle), helperText && !errorText && /* @__PURE__ */ React68.createElement(NxTypography, {
    variant: "body3"
  }, helperText), errorText && /* @__PURE__ */ React68.createElement(NxTypography, {
    colorToken: "ColorTextError",
    variant: "body3"
  }, errorText)));
}

// src/icon-avatar/NxIconAvatar.tsx
import React69 from "react";
import { Avatar as Avatar3, makeStyles as makeStyles50, useTheme as useTheme25 } from "@material-ui/core";
import clsx22 from "clsx";
import { UserOutlined } from "@playvs-inc/nexus-icons";
var useStyles47 = makeStyles50((theme) => ({
  avatarClass: ({
    height,
    width,
    bgColor
  }) => ({
    height,
    width,
    backgroundColor: bgColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  })
}));
function NxIconAvatar({
  height = 54,
  width = 54,
  className,
  Icon = UserOutlined,
  label,
  bgColor,
  contentColorToken,
  labelTypographyVariant = "body2",
  iconWidth = 20,
  iconHeight = 20,
  iconClassName
}) {
  const theme = useTheme25();
  const classes = useStyles47({
    height,
    width,
    bgColor: bgColor || theme.palette.ColorBackgroundBrand
  });
  const renderLabel = typeof label === "string" || typeof label === "number" ? /* @__PURE__ */ React69.createElement(NxTypography, {
    colorToken: contentColorToken,
    variant: labelTypographyVariant
  }, label) : label;
  return /* @__PURE__ */ React69.createElement(Avatar3, {
    alt: "avatar",
    className: clsx22(classes.avatarClass, className)
  }, /* @__PURE__ */ React69.createElement(Icon, {
    className: iconClassName,
    color: contentColorToken,
    height: iconHeight,
    width: iconWidth
  }), renderLabel);
}

// src/league-card/NxLeagueCard.tsx
import React71 from "react";
import clsx23 from "clsx";
import {
  Box as Box37,
  Card as Card2,
  CardContent,
  useMediaQuery as useMediaQuery7,
  useTheme as useTheme27
} from "@material-ui/core";
import { useEsport as useEsport8 } from "@playvs-inc/nexus-theme";

// src/league-card/LeagueCard.helpers.tsx
import React70 from "react";
import { makeStyles as makeStyles51, useTheme as useTheme26 } from "@material-ui/core";
import { useEsport as useEsport7 } from "@playvs-inc/nexus-theme";
var useStyles48 = makeStyles51((theme) => ({
  coverIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 1,
    height: 120,
    width: 120,
    color: theme.palette.common.white,
    opacity: 0.3,
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      width: 40,
      height: 40,
      opacity: 1,
      marginRight: theme.spacing(1)
    }
  }
}));
var useGetCardProps = (esportSlug) => {
  var _a;
  const theme = useTheme26();
  const classes = useStyles48();
  const esport = useEsport7(esportSlug);
  return {
    backgroundColor: ((_a = esport == null ? void 0 : esport.palette) == null ? void 0 : _a[6]) || theme.palette.ColorBackgroundInvert,
    Icon: () => /* @__PURE__ */ React70.createElement(NxEsportIcon, {
      className: classes.coverIcon,
      esportSlug,
      mode: "dark"
    })
  };
};

// src/league-card/NxLeagueCard.styles.ts
import { makeStyles as makeStyles52 } from "@material-ui/core";
var useStyles49 = makeStyles52((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius * 2.5,
    boxShadow: theme.mixins.boxShadow.elevation1,
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  cover: ({ backgroundColor }) => ({
    display: "flex",
    alignItems: "flex-end",
    padding: theme.spacing(2, 3),
    width: 246,
    backgroundColor,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 3),
      width: "100%",
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "flex-end"
    }
  }),
  coverText: {
    color: theme.palette.OverlayColorTextBase,
    width: 198,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  cardContent: {
    width: "100%",
    padding: theme.spacing(3, 3, 2, 4),
    "&:last-child": {
      paddingBottom: theme.spacing(2)
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 3)
    }
  },
  labelSection: {
    marginBottom: theme.spacing(1)
  },
  label: {
    width: "55px",
    marginRight: theme.spacing(1)
  },
  pill: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1)
    }
  },
  button: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      width: "100%"
    }
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row"
  },
  sponsorMiniLogo: {
    display: "flex",
    marginRight: theme.spacing(1),
    "&:img": {
      height: "40px",
      width: "40px"
    }
  },
  contentText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    [theme.breakpoints.down("xs")]: {
      overflow: "visible",
      textWrap: "wrap",
      textOverflow: "unset"
    }
  },
  coverIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 1,
    height: 120,
    width: 120,
    color: theme.palette.common.white,
    opacity: 0.3,
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      width: 40,
      height: 40,
      opacity: 1,
      marginRight: theme.spacing(1)
    }
  }
}));

// src/league-card/NxLeagueCard.tsx
function NxLeagueCard(_a) {
  var _b = _a, {
    buttonProps,
    className,
    competesOnLabel = "Schedule",
    competesOn,
    esport: esportSlug,
    leagueName,
    numberOfTeamsLabel = "Teams",
    numberOfTeams,
    matchesTimeLabel = "Matches",
    matchesTime,
    pillProps,
    sponsorImg,
    mobileSponsorImg
  } = _b, props = __objRest(_b, [
    "buttonProps",
    "className",
    "competesOnLabel",
    "competesOn",
    "esport",
    "leagueName",
    "numberOfTeamsLabel",
    "numberOfTeams",
    "matchesTimeLabel",
    "matchesTime",
    "pillProps",
    "sponsorImg",
    "mobileSponsorImg"
  ]);
  var _a2;
  const theme = useTheme27();
  const isSm = useMediaQuery7(theme.breakpoints.down("sm"));
  const esport = useEsport8(esportSlug);
  const { backgroundColor } = useGetCardProps(esportSlug);
  const classes = useStyles49({
    backgroundColor: ((_a2 = esport == null ? void 0 : esport.palette) == null ? void 0 : _a2.baseColor) || backgroundColor || theme.palette.common.white
  });
  return /* @__PURE__ */ React71.createElement(Card2, __spreadValues({
    className: clsx23(classes.root, className),
    "data-cy": esportSlug
  }, props), /* @__PURE__ */ React71.createElement("div", {
    className: classes.cover
  }, /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.coverText,
    variant: isSm ? "body2" : "h3"
  }, leagueName), isSm && /* @__PURE__ */ React71.createElement(Box37, {
    className: classes.sponsorMiniLogo
  }, mobileSponsorImg) || /* @__PURE__ */ React71.createElement(NxEsportIcon, {
    className: classes.coverIcon,
    esportSlug,
    mode: "dark"
  })), /* @__PURE__ */ React71.createElement(CardContent, {
    className: classes.cardContent
  }, pillProps && /* @__PURE__ */ React71.createElement(Pill, {
    className: classes.pill,
    label: pillProps.label,
    size: "small",
    variant: pillProps.variant
  }), /* @__PURE__ */ React71.createElement(Box37, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React71.createElement(Box37, {
    width: "100%"
  }, /* @__PURE__ */ React71.createElement(Box37, {
    display: "flex",
    flexDirection: "column"
  }, competesOn && /* @__PURE__ */ React71.createElement(Box37, {
    className: classes.labelSection,
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.label,
    colorToken: "ColorTextAlt2",
    variant: "body3"
  }, competesOnLabel, ":"), /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.contentText
  }, competesOn)), matchesTime && /* @__PURE__ */ React71.createElement(Box37, {
    className: classes.labelSection,
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.label,
    colorToken: "ColorTextAlt2",
    variant: "body3"
  }, matchesTimeLabel, ":"), /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.contentText
  }, matchesTime)), numberOfTeams && /* @__PURE__ */ React71.createElement(Box37, {
    className: classes.labelSection,
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.label,
    colorToken: "ColorTextAlt2",
    variant: "body3"
  }, numberOfTeamsLabel, ":"), /* @__PURE__ */ React71.createElement(NxTypography, {
    className: classes.contentText
  }, numberOfTeams))), /* @__PURE__ */ React71.createElement(NxButton, __spreadProps(__spreadValues({}, buttonProps), {
    className: classes.button,
    label: "View League",
    variant: "secondary"
  }))), !isSm && sponsorImg && /* @__PURE__ */ React71.createElement(Box37, {
    alignSelf: "flex-end",
    display: "flex",
    ml: 1
  }, sponsorImg))));
}

// src/live-indicator/NxLiveIndicator.tsx
import React73 from "react";

// src/live-indicator/PulseIcon.tsx
import React72 from "react";

// src/live-indicator/LiveIndicator.styles.ts
import { makeStyles as makeStyles53 } from "@material-ui/core";
import { colors as colors7 } from "@playvs-inc/nexus-core";
var useStyles50 = makeStyles53(() => ({
  liveText: {
    color: colors7.RedError[4]
  },
  liveWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "0.5em"
  },
  pulseIcon: {
    background: colors7.RedError[4],
    borderRadius: "50%",
    height: "0.60em",
    width: "0.60em",
    transform: "scale(1)",
    animation: "$pulse 1.5s infinite"
  },
  lightPulseIcon: {
    background: colors7.RedError[3],
    borderRadius: "50%",
    height: "0.60em",
    width: "0.60em",
    transform: "scale(1.5)",
    animation: "$outerPulse 1.5s infinite",
    position: "absolute"
  },
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)"
    },
    "5%": {
      transform: "scale(0.9)"
    },
    "50%": {
      transform: "scale(1.25)"
    },
    "90%": {
      transform: "scale(1)"
    }
  },
  "@keyframes outerPulse": {
    "0%": {
      transform: "scale(1.5)"
    },
    "45%": {
      transform: "scale(1.75)"
    },
    "100%": {
      transform: "scale(1.5)"
    }
  }
}));

// src/live-indicator/PulseIcon.tsx
function PulseIcon() {
  const styles = useStyles50();
  return /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement("div", {
    className: styles.lightPulseIcon
  }), /* @__PURE__ */ React72.createElement("div", {
    className: styles.pulseIcon
  }));
}

// src/live-indicator/NxLiveIndicator.tsx
function NxLiveIndicator({
  isLive
}) {
  const styles = useStyles50();
  return isLive ? /* @__PURE__ */ React73.createElement("div", {
    className: styles.liveWrapper
  }, /* @__PURE__ */ React73.createElement(PulseIcon, null), /* @__PURE__ */ React73.createElement(NxTypography, {
    className: styles.liveText,
    variant: "overline"
  }, "Live")) : null;
}

// src/radio-button/NxRadioBase.tsx
import React74 from "react";
import { makeStyles as makeStyles54, Radio, useTheme as useTheme28 } from "@material-ui/core";
import clsx24 from "clsx";
import { colors as colors8 } from "@playvs-inc/nexus-core";
import { MUIThemeModeEnum as MUIThemeModeEnum7 } from "@playvs-inc/nexus-theme";
var useStyles51 = makeStyles54((theme) => ({
  radioBase: ({ isLightTheme }) => ({
    "&.MuiRadio-root": {
      "&~ p": {
        color: theme.palette.ColorTextAlt
      },
      height: "16px",
      width: "16px",
      color: isLightTheme ? colors8.OpBlack[8] : colors8.OpWhite[8],
      borderRadius: theme.mixins.cornerRadius["border-radius-10"],
      "&.MuiRadio-colorSecondary.Mui-checked": {
        color: isLightTheme ? theme.palette.ColorIconBase : colors8.OpWhite[3],
        "&~ p": {
          color: theme.palette.ColorTextBase
        }
      },
      "&:hover, &:active": {
        color: isLightTheme ? theme.palette.ColorIconBase : colors8.OpWhite[3],
        "&~ p": {
          color: theme.palette.ColorTextBase
        }
      }
    },
    "&.MuiRadio-colorSecondary.Mui-disabled + p": {
      color: isLightTheme ? theme.palette.ColorIconDisabled : colors8.OpWhite[13],
      "&~ p": {
        color: isLightTheme ? colors8.OpBlack[14] : colors8.OpWhite[13]
      }
    },
    "&.MuiIconButton-colorSecondary:hover": {
      backgroundColor: "transparent"
    }
  })
}));
function NxRadioBase(_a) {
  var _b = _a, {
    className
  } = _b, rest = __objRest(_b, [
    "className"
  ]);
  const theme = useTheme28();
  const isLightTheme = theme.palette.type === MUIThemeModeEnum7.Light;
  const classes = useStyles51({ isLightTheme });
  return /* @__PURE__ */ React74.createElement(Radio, __spreadValues({
    className: clsx24(className, classes.radioBase)
  }, rest));
}

// src/radio-button/NxRadioButtonGroup.tsx
import React75 from "react";
import { Box as Box38, makeStyles as makeStyles55, RadioGroup } from "@material-ui/core";
var useStyles52 = makeStyles55((theme) => ({
  label: {
    paddingLeft: theme.spacing(2)
  },
  clickableArea: {
    cursor: "pointer"
  }
}));
function NxRadioButtonGroup(_a) {
  var _b = _a, {
    labelVariant = "body1",
    radioOptions,
    className,
    baseClassName,
    paddingBottom = 1,
    paddingLeft = 3,
    row
  } = _b, rest = __objRest(_b, [
    "labelVariant",
    "radioOptions",
    "className",
    "baseClassName",
    "paddingBottom",
    "paddingLeft",
    "row"
  ]);
  const classes = useStyles52();
  return /* @__PURE__ */ React75.createElement(RadioGroup, __spreadValues({
    className,
    row
  }, rest), radioOptions.map((option) => {
    var _a2;
    return /* @__PURE__ */ React75.createElement(Box38, {
      key: option.value,
      alignItems: "center",
      className: classes.clickableArea,
      component: "label",
      display: "flex",
      htmlFor: option.name,
      paddingBottom,
      paddingLeft: row ? paddingLeft : void 0
    }, /* @__PURE__ */ React75.createElement(NxRadioBase, __spreadProps(__spreadValues({
      className: baseClassName,
      value: option.value
    }, rest), {
      id: option.name
    })), typeof option.label === "string" ? /* @__PURE__ */ React75.createElement(NxTypography, {
      className: classes.label,
      variant: labelVariant
    }, option.label) : (_a2 = option == null ? void 0 : option.label) != null ? _a2 : null);
  }));
}

// src/rating/NxRating.tsx
import React77 from "react";
import { Box as Box40 } from "@material-ui/core";

// src/rating/NxRating.styles.tsx
import { makeStyles as makeStyles56 } from "@material-ui/core";
var useStyles53 = makeStyles56((theme) => ({
  container: {
    display: "flex",
    gridGap: theme.spacing(1),
    alignItems: "center"
  },
  starContainer: ({ isHovered }) => ({
    height: 60,
    width: 60,
    justifyContent: "center",
    alignItems: isHovered ? "flex-start" : "center",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      alignItems: "flex-start"
    }
  }),
  hoverContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  emoteContainer: {
    backgroundColor: theme.palette.ColorBackgroundBrand,
    height: 60,
    width: 60,
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    display: "flex"
  },
  title: {
    whiteSpace: "nowrap",
    color: theme.palette.ColorTextAlt
  }
}));

// src/rating/NxStarSelect.tsx
import React76, { useRef as useRef8, useState as useState13 } from "react";
import { Box as Box39, useMediaQuery as useMediaQuery8, useTheme as useTheme29 } from "@material-ui/core";
import { Star, StarFilled } from "@playvs-inc/nexus-icons";
function NxStarSelect({
  ratingValue,
  isSelected,
  onClick,
  emoteKey,
  title
}) {
  const theme = useTheme29();
  const ref = useRef8(null);
  const [isHovered, setIsHovered] = useState13(false);
  const isXs = useMediaQuery8(theme.breakpoints.down("xs"));
  const classes = useStyles53({ isHovered });
  const handleClick = () => {
    onClick(ratingValue);
  };
  const emoteTitle = /* @__PURE__ */ React76.createElement(NxTypography, {
    className: classes.title,
    variant: "body4"
  }, title);
  return /* @__PURE__ */ React76.createElement("span", {
    ref,
    className: classes.starContainer,
    onBlur: () => setIsHovered(false),
    onClick: handleClick,
    onFocus: () => setIsHovered(true),
    onKeyDown: (e) => {
      if (e.key === "Enter") {
        handleClick();
      }
    },
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    role: "button",
    tabIndex: ratingValue
  }, isXs ? /* @__PURE__ */ React76.createElement(Box39, {
    className: classes.hoverContainer
  }, /* @__PURE__ */ React76.createElement(Box39, {
    className: classes.emoteContainer,
    style: {
      backgroundColor: isSelected ? theme.palette.ColorBackgroundBrand : "transparent"
    }
  }, /* @__PURE__ */ React76.createElement(NxEmote, {
    emoteKey,
    height: 30,
    width: 30
  })), emoteTitle) : /* @__PURE__ */ React76.createElement(React76.Fragment, null, !isHovered && (isSelected ? /* @__PURE__ */ React76.createElement(StarFilled, {
    color: theme.palette.ColorBackgroundAccent,
    height: 52,
    width: 52
  }) : /* @__PURE__ */ React76.createElement(Star, {
    color: theme.palette.ColorIconAlt2,
    height: 52,
    width: 52
  })), isHovered && /* @__PURE__ */ React76.createElement(Box39, {
    className: classes.hoverContainer
  }, /* @__PURE__ */ React76.createElement(Box39, {
    className: classes.emoteContainer
  }, /* @__PURE__ */ React76.createElement(NxEmote, {
    emoteKey,
    height: 30,
    shouldAnimate: true,
    width: 30
  })), emoteTitle)));
}

// src/rating/NxRating.tsx
var DEFAULT_OPTIONS = [
  { ratingValue: 1, emoteKey: "fbrage" /* Rage */, title: "Not at All" },
  { ratingValue: 2, emoteKey: "fbthink" /* Think */, title: "Not Really" },
  { ratingValue: 3, emoteKey: "fblurk" /* Lurk */, title: "A Little" },
  { ratingValue: 4, emoteKey: "fbcool" /* Cool */, title: "Mostly Fun" },
  { ratingValue: 5, emoteKey: "fbthumbsup" /* Thumbsup */, title: "The Funnest!" }
];
function NxRating({
  options = DEFAULT_OPTIONS,
  value,
  onClick
}) {
  const classes = useStyles53({});
  return /* @__PURE__ */ React77.createElement(Box40, {
    className: classes.container
  }, options.map((starRatingValue) => /* @__PURE__ */ React77.createElement(NxStarSelect, {
    key: starRatingValue.emoteKey,
    emoteKey: starRatingValue.emoteKey,
    isSelected: !!value && starRatingValue.ratingValue <= value,
    onClick,
    ratingValue: starRatingValue.ratingValue,
    title: starRatingValue.title
  })));
}

// src/scoreboard/NxScoreboard.tsx
import React78, { useMemo as useMemo6 } from "react";

// src/scoreboard/NxScoreboard.styles.tsx
import { makeStyles as makeStyles57 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles54 = makeStyles57((theme) => ({
  tableRow: {
    height: 100
  },
  headerCell: {
    color: theme.palette.ColorTextAlt2,
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  headerGameCell: {
    color: theme.palette.ColorTextAlt2,
    textAlign: "center",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  competitorTBD: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    height: "100%",
    color: theme.palette.ColorTextDisabled
  },
  competitorTBDtext: {
    marginLeft: 5
  },
  userClusterCell: {
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  vsCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: theme.palette.ColorTextDisabled
  },
  gameCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },
  gameCellWColor: {
    color: theme.palette.ColorTextSuccess
  },
  gameCellLColor: {
    color: theme.palette.ColorTextError
  }
}));

// src/scoreboard/NxScoreboard.tsx
function NxScoreboard({
  leftCompetitorHeader,
  rightCompetitorHeader,
  numberOfGames,
  data
}) {
  const classes = useStyles54();
  const memoColumns = useMemo6(() => {
    const columns = [
      {
        accessor: "leftCompetitor" /* LeftCompetitor */,
        Header: HeaderCell2,
        header: leftCompetitorHeader,
        Cell: CompetitorCell,
        classes
      },
      {
        accessor: "vs" /* Vs */,
        Cell: VSCell,
        width: 135,
        classes
      },
      {
        accessor: "rightCompetitor" /* RightCompetitor */,
        Header: HeaderCell2,
        header: rightCompetitorHeader,
        Cell: CompetitorCell,
        classes
      }
    ];
    for (let i = 0; i < numberOfGames; i += 1) {
      columns.push({
        accessor: i.toString(),
        Header: HeaderCell2,
        header: `Game ${i + 1}`,
        isGameColumn: true,
        Cell: GameResultsCell,
        width: 75,
        classes
      });
    }
    return columns;
  }, [classes]);
  const memoData = useMemo6(() => data.map(({ leftCompetitor, rightCompetitor, gameWins }) => {
    const gameObj = {};
    for (let i = 0; i < numberOfGames; i += 1) {
      gameObj[i] = gameWins == null ? void 0 : gameWins[i];
    }
    return __spreadValues({
      ["leftCompetitor" /* LeftCompetitor */]: leftCompetitor,
      ["rightCompetitor" /* RightCompetitor */]: rightCompetitor
    }, gameObj);
  }), [classes]);
  return /* @__PURE__ */ React78.createElement(NxScoreBoardTable, {
    classes,
    columns: memoColumns,
    data: memoData
  });
}

// src/scoreboard/NxScoreboardTable.tsx
import React79 from "react";
import { useFlexLayout as useFlexLayout2, useTable as useTable2 } from "react-table";
function NxScoreBoardTable({
  columns,
  data,
  classes
}) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable2({
    columns,
    data
  }, useFlexLayout2);
  return /* @__PURE__ */ React79.createElement("div", __spreadValues({}, getTableProps()), /* @__PURE__ */ React79.createElement("div", null, headerGroups.map((headerGroup) => /* @__PURE__ */ React79.createElement("div", __spreadValues({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column) => /* @__PURE__ */ React79.createElement("div", __spreadValues({
    "data-cy": column.id
  }, column.getHeaderProps()), column.render("Header")))))), /* @__PURE__ */ React79.createElement("div", __spreadValues({}, getTableBodyProps()), rows.map((row, i) => {
    prepareRow(row);
    return /* @__PURE__ */ React79.createElement("div", __spreadValues({
      className: classes.tableRow,
      "data-cy": "scoreRaw"
    }, row.getRowProps()), row.cells.map((cell) => /* @__PURE__ */ React79.createElement("td", __spreadValues({}, cell.getCellProps()), cell.render("Cell"))));
  })));
}

// src/scoreboard/NxScoreboardCells.tsx
import React80 from "react";
import { Box as Box41, useTheme as useTheme30 } from "@material-ui/core";
import { isNil } from "ramda";
import "@playvs-inc/nexus-theme";
import { Clock } from "@playvs-inc/nexus-icons";
function HeaderCell2({
  column
}) {
  const { isGameColumn, classes } = column;
  return /* @__PURE__ */ React80.createElement(NxTypography, {
    className: isGameColumn ? classes.headerGameCell : classes.headerCell,
    variant: "overline"
  }, column.header);
}
function CompetitorCell({
  value,
  column
}) {
  var _a;
  const theme = useTheme30();
  return value ? /* @__PURE__ */ React80.createElement(Box41, {
    className: column.classes.userClusterCell
  }, /* @__PURE__ */ React80.createElement(NxUserCluster, {
    avatarHashId: (_a = value.avatarHashId) != null ? _a : "",
    avatarUrl: value.avatarUrl,
    subtitles: (value == null ? void 0 : value.subtitle) ? [{ title: value == null ? void 0 : value.subtitle }] : [],
    title: value.title
  })) : /* @__PURE__ */ React80.createElement(Box41, {
    className: column.classes.competitorTBD
  }, /* @__PURE__ */ React80.createElement(Clock, {
    color: theme.palette.ColorIconDisabled
  }), /* @__PURE__ */ React80.createElement(NxTypography, {
    className: column.classes.competitorTBDtext,
    variant: "body2"
  }, "TBD"));
}
function VSCell({
  column
}) {
  return /* @__PURE__ */ React80.createElement(NxTypography, {
    className: column.classes.vsCell,
    variant: "overline"
  }, "VS");
}
function GameResultsCell({
  value,
  column
}) {
  const winnerIndicator = value ? "W" : "L";
  const label = !isNil(value) ? winnerIndicator : "-";
  const winnerIndicatorClass = value ? column.classes.gameCellWColor : column.classes.gameCellLColor;
  const labelClass = !isNil(value) ? winnerIndicatorClass : "";
  return /* @__PURE__ */ React80.createElement(NxTypography, {
    className: `${column.classes.gameCell} ${labelClass}`,
    variant: "h4"
  }, label);
}

// src/scoreboard/Scoreboard.d.tsx
var StaticColumns = /* @__PURE__ */ ((StaticColumns2) => {
  StaticColumns2["LeftCompetitor"] = "leftCompetitor";
  StaticColumns2["Vs"] = "vs";
  StaticColumns2["RightCompetitor"] = "rightCompetitor";
  return StaticColumns2;
})(StaticColumns || {});

// src/scoreboard/NxScoreReviewCard.tsx
import React81 from "react";
import { Box as Box42, Card as Card3, makeStyles as makeStyles58, Tooltip as Tooltip2, useTheme as useTheme31 } from "@material-ui/core";
import { Image as Image2 } from "@playvs-inc/nexus-icons";
import "@playvs-inc/nexus-theme";
var useStyles55 = makeStyles58((theme) => ({
  card: {
    height: 100,
    backgroundColor: theme.palette.ColorBackgroundBody,
    boxShadow: "none",
    padding: theme.spacing(2, 3),
    borderRadius: theme.mixins.cornerRadius["border-radius-10"],
    display: "flex",
    justifyContent: "space-between"
  },
  cardContent: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  cardBody: {
    height: "100%",
    display: "flex",
    alignItems: "center"
  },
  rightContent: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "flex-end"
  },
  score: {
    whiteSpace: "nowrap"
  },
  tooltipContent: {
    height: 20,
    width: 20
  }
}));
function NxScoreReviewCard({
  title,
  score,
  winner,
  screenShotsAttached
}) {
  var _a;
  const classes = useStyles55();
  const theme = useTheme31();
  return /* @__PURE__ */ React81.createElement(Card3, {
    className: classes.card
  }, /* @__PURE__ */ React81.createElement(Box42, {
    className: classes.cardContent
  }, /* @__PURE__ */ React81.createElement(NxTypography, {
    variant: "overline"
  }, title), /* @__PURE__ */ React81.createElement(Box42, {
    className: classes.cardBody
  }, /* @__PURE__ */ React81.createElement(NxUserCluster, {
    avatarHashId: (_a = winner.avatarHashId) != null ? _a : "",
    avatarUrl: winner.avatarUrl,
    compact: true,
    showSubAvatar: winner.showSubAvatar,
    subAvatarHashId: winner.subAvatarHashId,
    subAvatarUrl: winner.subAvatarUrl,
    subtitles: (winner == null ? void 0 : winner.subtitle) ? [{ title: winner.subtitle }] : [],
    title: winner.title
  }))), /* @__PURE__ */ React81.createElement(Box42, {
    className: classes.rightContent
  }, /* @__PURE__ */ React81.createElement(Box42, {
    className: classes.score
  }, score && /* @__PURE__ */ React81.createElement(NxTypography, {
    variant: "h2"
  }, score[0], "-", score[1])), /* @__PURE__ */ React81.createElement(Box42, null, screenShotsAttached && /* @__PURE__ */ React81.createElement(Tooltip2, {
    arrow: true,
    PopperProps: {
      modifiers: {
        flip: {
          enabled: false
        },
        offset: {
          enabled: true,
          offset: "0px, -13px"
        }
      }
    },
    title: "Screenshots Attached"
  }, /* @__PURE__ */ React81.createElement(Box42, {
    className: classes.tooltipContent
  }, /* @__PURE__ */ React81.createElement(Image2, {
    color: theme.palette.ColorIconAlt2
  }))))));
}

// src/scoreboard/NxScoreboardRows.tsx
import React82 from "react";
import { Box as Box43, makeStyles as makeStyles59, useMediaQuery as useMediaQuery9, useTheme as useTheme32 } from "@material-ui/core";
import clsx25 from "clsx";
var useStyles56 = makeStyles59((theme) => ({
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr min-content 1fr"
  },
  rightTriangle: {
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "6px 0 6px 12px",
    borderColor: `transparent transparent transparent ${theme.palette.ColorIconSuccess} `
  },
  leftTriangle: {
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "6px 12px 6px 0",
    borderColor: `transparent ${theme.palette.ColorIconSuccess} transparent`
  },
  desktopOnly: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  leftName: {
    textAlign: "right"
  },
  truncate: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  disabled: {
    opacity: "30%"
  }
}));
function NxScoreboardRows({
  data,
  gridGap,
  requireTitle,
  titleMargin = 2,
  dataRowMargin = 1
}) {
  const theme = useTheme32();
  const isMobile = useMediaQuery9(theme.breakpoints.down("sm"));
  const classes = useStyles56();
  const classNameForTitle = requireTitle ? void 0 : classes.desktopOnly;
  return /* @__PURE__ */ React82.createElement(Box43, {
    display: "flex",
    flexDirection: "column",
    gridGap: gridGap || theme.spacing(6)
  }, data.map(({
    title,
    subtitle,
    leftSide,
    rightSide,
    customMiddle,
    showScore = true,
    isScoreFinal = true
  }, ndx) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const leftSideScore = (_a = leftSide.score) != null ? _a : 0;
    const rightSideScore = (_b = rightSide.score) != null ? _b : 0;
    return /* @__PURE__ */ React82.createElement(Box43, {
      key: ndx
    }, /* @__PURE__ */ React82.createElement(Box43, {
      className: clsx25(classes.grid, classNameForTitle),
      mb: titleMargin
    }, /* @__PURE__ */ React82.createElement(Box43, null), /* @__PURE__ */ React82.createElement(Box43, {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gridGap: theme.spacing(1),
      whiteSpace: "nowrap"
    }, title && /* @__PURE__ */ React82.createElement(NxTypography, {
      variant: "overline"
    }, title), subtitle && /* @__PURE__ */ React82.createElement(NxTypography, {
      variant: "body1"
    }, subtitle)), /* @__PURE__ */ React82.createElement(Box43, null)), isMobile && /* @__PURE__ */ React82.createElement(Box43, {
      alignItems: "baseline",
      className: classes.grid,
      gridGap: theme.spacing(1)
    }, /* @__PURE__ */ React82.createElement(NxTypography, {
      className: clsx25(classes.leftName, classes.truncate),
      colorToken: "ColorTextBase",
      "data-cy": "leftSideTitle",
      variant: "button"
    }, leftSide.title), leftSide.title && rightSide.title && /* @__PURE__ */ React82.createElement(NxTypography, {
      variant: "body3"
    }, "vs"), /* @__PURE__ */ React82.createElement(NxTypography, {
      className: classes.truncate,
      colorToken: "ColorTextBase",
      "data-cy": "rightSideTitle",
      variant: "button"
    }, rightSide.title)), /* @__PURE__ */ React82.createElement(Box43, {
      alignItems: "center",
      className: classes.grid,
      display: "flex",
      gridGap: theme.spacing(1),
      mt: dataRowMargin
    }, leftSide.Avatar ? /* @__PURE__ */ React82.createElement(Box43, {
      className: clsx25(isScoreFinal && leftSideScore < rightSideScore ? classes.disabled : "")
    }, leftSide.Avatar) : /* @__PURE__ */ React82.createElement(NxUserCluster, {
      alignment: "right",
      avatarHashId: leftSide.id,
      avatarUrl: leftSide.avatarUrl,
      disabled: showScore && isScoreFinal ? leftSideScore < rightSideScore : void 0,
      subtitles: isMobile ? [] : [
        { title: (_c = leftSide.subtitle) != null ? _c : "" },
        ...(_d = leftSide.subtitles) != null ? _d : []
      ],
      title: isMobile ? "" : (_e = leftSide.title) != null ? _e : ""
    }), /* @__PURE__ */ React82.createElement(Box43, {
      alignItems: "center",
      display: "flex",
      gridGap: theme.spacing(1),
      position: "relative",
      whiteSpace: "nowrap"
    }, customMiddle, showScore && /* @__PURE__ */ React82.createElement(React82.Fragment, null, isScoreFinal && /* @__PURE__ */ React82.createElement(Box43, {
      className: classes.leftTriangle,
      "data-cy": "leftTriangle",
      visibility: leftSideScore <= rightSideScore && "hidden"
    }), /* @__PURE__ */ React82.createElement(NxTypography, {
      "data-cy": "sideScore",
      variant: "h4"
    }, leftSideScore, " - ", rightSideScore), isScoreFinal && /* @__PURE__ */ React82.createElement(Box43, {
      className: classes.rightTriangle,
      "data-cy": "rightTriangle",
      visibility: rightSideScore <= leftSideScore && "hidden"
    }))), rightSide.Avatar ? /* @__PURE__ */ React82.createElement(Box43, {
      className: clsx25(isScoreFinal && rightSideScore < leftSideScore ? classes.disabled : "")
    }, rightSide.Avatar) : /* @__PURE__ */ React82.createElement(NxUserCluster, {
      avatarHashId: rightSide.id,
      avatarUrl: rightSide.avatarUrl,
      disabled: isScoreFinal && showScore ? rightSideScore < leftSideScore : void 0,
      subtitles: isMobile ? [] : [
        { title: (_f = rightSide.subtitle) != null ? _f : "" },
        ...(_g = rightSide.subtitles) != null ? _g : []
      ],
      title: isMobile ? "" : (_h = rightSide.title) != null ? _h : ""
    })));
  }));
}

// src/search-box/NxSearchBox.tsx
import { Box as Box44, TextField, useTheme as useTheme33, InputAdornment } from "@material-ui/core";
import React83, { useState as useState14 } from "react";
import { Search, Close as Close6 } from "@playvs-inc/nexus-icons";
import clsx26 from "clsx";

// src/search-box/SearchBox.styles.ts
import { makeStyles as makeStyles60 } from "@material-ui/core";
var SearchBox_styles_default = makeStyles60((theme) => ({
  inputContainer: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(1),
    "& .MuiOutlinedInput-root": {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
      "&.Mui-focused fieldset": {
        border: "1px solid rgba(0, 0, 0, 0.85)"
      }
    }
  },
  startingAdornment: {
    marginLeft: theme.spacing(0.25),
    marginRight: "unset"
  },
  closeButton: {
    cursor: "pointer"
  }
}));

// src/search-box/NxSearchBox.tsx
function NxSearchBox({
  placeholderText,
  buttonLabel,
  onSubmitSearch,
  inputFieldClassName,
  startAdornmentClassName
}) {
  const classes = SearchBox_styles_default();
  const theme = useTheme33();
  const [searchText, setSearchText] = useState14("");
  const onSubmit = () => {
    onSubmitSearch(searchText);
  };
  const onClearText = () => {
    setSearchText("");
  };
  return /* @__PURE__ */ React83.createElement(Box44, {
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ React83.createElement(TextField, {
    className: clsx26(classes.inputContainer, inputFieldClassName),
    fullWidth: true,
    InputProps: {
      startAdornment: /* @__PURE__ */ React83.createElement(InputAdornment, {
        className: clsx26(classes.startingAdornment, startAdornmentClassName),
        position: "start"
      }, /* @__PURE__ */ React83.createElement(Search, {
        height: 20,
        width: 20
      })),
      endAdornment: searchText.length ? /* @__PURE__ */ React83.createElement(InputAdornment, {
        className: classes.startingAdornment,
        position: "end"
      }, /* @__PURE__ */ React83.createElement(Close6, {
        className: classes.closeButton,
        height: 20,
        onClick: onClearText,
        width: 20
      })) : null
    },
    inputProps: {
      style: {
        padding: theme.spacing(1)
      }
    },
    onChange: (event) => {
      setSearchText(event.target.value);
    },
    onKeyDown: (e) => {
      if (e.key === "Enter") {
        onSubmit();
      }
    },
    placeholder: placeholderText,
    value: searchText,
    variant: "outlined"
  }), /* @__PURE__ */ React83.createElement(NxButton, {
    label: buttonLabel,
    onClick: onSubmit,
    variant: "primary"
  }));
}

// src/selectable/single/NxSelectableSingle.tsx
import React85, { useCallback as useCallback3, useState as useState15, useRef as useRef9 } from "react";
import "@playvs-inc/nexus-theme";
import { Box as Box46 } from "@material-ui/core";

// src/selectable/NxSelectable.tsx
import React84 from "react";
import { Box as Box45, useTheme as useTheme34 } from "@material-ui/core";
import clsx27 from "clsx";
import "@playvs-inc/nexus-theme";
import { Regularcheck } from "@playvs-inc/nexus-icons";

// src/selectable/Selectable.styles.ts
import { makeStyles as makeStyles61 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles57 = makeStyles61((theme) => ({
  default: ({ disabled, padding }) => ({
    color: disabled ? theme.palette.ColorTextDisabled : theme.palette.ColorTextAlt,
    borderRadius: theme.shape.borderRadius * 2,
    border: `2px solid`,
    padding: padding ? theme.spacing(padding) : void 0,
    display: "flex",
    borderColor: disabled ? theme.palette.ColorBackgroundInactive : theme.palette.BorderMedium,
    backgroundColor: theme.palette.ColorBackgroundBase,
    cursor: disabled ? "auto" : "pointer"
  }),
  inactive: ({ disabled }) => ({
    "&:hover": {
      color: disabled ? void 0 : theme.palette.ColorTextBase,
      borderColor: disabled ? void 0 : theme.palette.BorderDark
    },
    "&:focus": {
      outlineColor: disabled ? void 0 : theme.palette.BorderDark
    }
  }),
  active: () => ({
    color: theme.palette.ColorTextBase,
    borderColor: theme.palette.ColorBackgroundAccent,
    "&:focus": {
      outlineColor: theme.palette.ColorBackgroundAccent,
      borderColor: theme.palette.ColorBackgroundAccent
    },
    "&:hover": {
      borderColor: theme.palette.ColorBackgroundAccent
    }
  }),
  selectedCheck: {
    position: "absolute",
    borderRadius: `0 ${2 * theme.shape.borderRadius}px 0 0`,
    right: "-1px",
    top: "-1px",
    width: "2.5em",
    height: "2.5em",
    background: `linear-gradient(
      to top right, 
      #00000000 0%, 
      #00000000 50%, 
      ${theme.palette.ColorBackgroundAccent} 50%, 
      ${theme.palette.ColorBackgroundAccent} 100%
    )`
  }
}));
var useOverlayStyles = makeStyles61((theme) => ({
  default: ({ disabled, padding }) => ({
    color: disabled ? theme.palette.OverlayColorTextDisabled : theme.palette.OverlayColorTextAlt,
    borderRadius: theme.shape.borderRadius * 2,
    border: `2px solid`,
    padding: padding ? theme.spacing(padding) : void 0,
    display: "flex",
    borderColor: disabled ? theme.palette.OverlayColorBackgroundInactive : theme.palette.OverlayBorderMedium,
    backgroundColor: theme.palette.OverlayColorOpBlack3,
    cursor: disabled ? "auto" : "pointer"
  }),
  inactive: ({ disabled }) => ({
    "&:hover": {
      color: disabled ? void 0 : theme.palette.OverlayColorTextBase,
      borderColor: disabled ? void 0 : theme.palette.OverlayBorderDark
    },
    "&:focus": {
      outlineColor: disabled ? void 0 : theme.palette.OverlayBorderDark
    }
  }),
  active: () => ({
    color: theme.palette.OverlayColorTextBase,
    borderColor: theme.palette.ColorBackgroundAccent,
    "&:focus": {
      outlineColor: theme.palette.ColorBackgroundAccent,
      borderColor: theme.palette.ColorBackgroundAccent
    },
    "&:hover": {
      borderColor: theme.palette.ColorBackgroundAccent
    }
  }),
  selectedCheck: {
    position: "absolute",
    borderRadius: `0 ${2 * theme.shape.borderRadius}px 0 0`,
    right: "-1px",
    top: "-1px",
    width: "2.5em",
    height: "2.5em",
    background: `linear-gradient(
      to top right, 
      #00000000 0%, 
      #00000000 50%, 
      ${theme.palette.ColorBackgroundAccent} 50%, 
      ${theme.palette.ColorBackgroundAccent} 100%
    )`
  }
}));

// src/selectable/NxSelectable.tsx
var NxSelectable = React84.memo(({
  selected,
  disabled,
  tabIndex,
  option,
  width,
  height,
  padding,
  shouldUseOverlayColors,
  hideCheckmark
}) => {
  const overlayClasses = useOverlayStyles({
    disabled: disabled != null ? disabled : false,
    padding
  });
  const baseClasses = useStyles57({
    disabled: disabled != null ? disabled : false,
    padding
  });
  const classes = shouldUseOverlayColors ? overlayClasses : baseClasses;
  const theme = useTheme34();
  const additionalStyles = selected ? classes.active : classes.inactive;
  return /* @__PURE__ */ React84.createElement(Box45, {
    alignItems: "center",
    className: clsx27(classes.default, additionalStyles),
    "data-testid": "NxSelectable__ChoiceButton",
    flexDirection: "column",
    height,
    justifyContent: "center",
    position: "relative",
    tabIndex: tabIndex != null ? tabIndex : 0,
    textAlign: "center",
    width
  }, option, !hideCheckmark && selected && /* @__PURE__ */ React84.createElement(Box45, {
    className: classes.selectedCheck,
    "data-testid": "NxSelectable__ChoiceBox__SelectedCorner",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, /* @__PURE__ */ React84.createElement(Regularcheck, {
    color: theme.palette.common.white
  })));
});

// src/selectable/single/NxSelectableSingle.tsx
var NxSelectableSingle = React85.memo(({
  defaultValue,
  children,
  onChange,
  value,
  disabled,
  justifyContent = "stretch",
  flexDirection = "row",
  onBlur,
  width = "124px",
  height = "124px",
  tabIndex,
  onFocus,
  shouldUseOverlayColors,
  padding,
  hideCheckmark,
  outerContainerClassName,
  selectableContainerClassName
}) => {
  const outerContainerRef = useRef9(null);
  const [selectedIndex, setSelectedIndex] = useState15(defaultValue != null ? defaultValue : -1);
  const computedSelectedValue = value != null ? value : selectedIndex;
  const handleSelect = useCallback3((evt, index) => {
    if (disabled) {
      return;
    }
    setSelectedIndex(index);
    onChange == null ? void 0 : onChange(evt, index);
  }, [disabled]);
  const handleOnKeyUp = (evt, choiceIndex) => {
    var _a, _b, _c, _d, _e, _f;
    if (evt.key === " " || evt.key === "Enter") {
      evt.preventDefault();
      if (choiceIndex !== computedSelectedValue) {
        handleSelect(evt, choiceIndex);
      }
    } else if (evt.key === "ArrowLeft" && selectedIndex >= 0) {
      evt.preventDefault();
      const targetChoice = (children.length + selectedIndex - 1) % children.length;
      handleSelect(evt, targetChoice);
      const siblings = (_a = evt.currentTarget.parentElement) == null ? void 0 : _a.children;
      (_c = (_b = siblings == null ? void 0 : siblings[targetChoice]).focus) == null ? void 0 : _c.call(_b);
    } else if (evt.key === "ArrowRight" && selectedIndex >= 0) {
      evt.preventDefault();
      const targetChoice = (children.length + selectedIndex + 1) % children.length;
      handleSelect(evt, targetChoice);
      const siblings = (_d = evt.currentTarget.parentElement) == null ? void 0 : _d.children;
      (_f = (_e = siblings == null ? void 0 : siblings[targetChoice]).focus) == null ? void 0 : _f.call(_e);
    }
  };
  return /* @__PURE__ */ React85.createElement(Box46, __spreadProps(__spreadValues({}, { ref: outerContainerRef }), {
    className: outerContainerClassName,
    "data-testid": "NxSelectableSingle__OuterContainer",
    display: "flex",
    flexDirection,
    gridGap: "1em",
    justifyContent,
    onBlur: (evt) => {
      onBlur == null ? void 0 : onBlur(evt);
    },
    onFocus: (evt) => {
      onFocus == null ? void 0 : onFocus(evt);
    }
  }), children.map((choiceElement, choiceIndex) => /* @__PURE__ */ React85.createElement(Box46, {
    key: choiceElement.key,
    className: selectableContainerClassName,
    onClick: (evt) => handleSelect(evt, choiceIndex),
    onKeyUp: (evt) => {
      handleOnKeyUp(evt, choiceIndex);
    }
  }, /* @__PURE__ */ React85.createElement(NxSelectable, {
    disabled,
    height,
    hideCheckmark,
    option: choiceElement,
    padding,
    selected: computedSelectedValue === choiceIndex,
    shouldUseOverlayColors,
    tabIndex,
    width
  }))));
});

// src/selectable/multi/NxSelectableMulti.tsx
import React86, { useState as useState16 } from "react";
import { Box as Box47 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var NxSelectableMulti = React86.memo(({
  defaultValue = [],
  children,
  onChange,
  values,
  disabled,
  justifyContent,
  onBlur,
  width = "124px",
  height = "124px",
  tabIndex,
  onFocus,
  shouldUseOverlayColors,
  padding,
  hideCheckmark
}) => {
  const [selectedIndices, setSelectedIndices] = useState16(defaultValue);
  const computedSelectedValues = values != null ? values : selectedIndices;
  const handleSelect = (evt, index) => {
    if (disabled) {
      return;
    }
    const ndxOfIndex = selectedIndices.indexOf(index);
    if (ndxOfIndex === -1) {
      setSelectedIndices([...selectedIndices, index]);
    } else {
      setSelectedIndices([...selectedIndices.filter((n) => n !== index)]);
    }
    onChange == null ? void 0 : onChange(evt, index);
  };
  const handleOnKeyUp = (evt, choiceIndex) => {
    if (evt.key === " " || evt.key === "Enter") {
      evt.preventDefault();
      handleSelect(evt, choiceIndex);
    }
  };
  return /* @__PURE__ */ React86.createElement(Box47, {
    "data-testid": "NxSelectableSingle__OuterContainer",
    display: "flex",
    flexDirection: "row",
    gridGap: "1em",
    justifyContent: justifyContent != null ? justifyContent : "stretch",
    onBlur: (evt) => {
      onBlur == null ? void 0 : onBlur(evt);
    },
    onFocus: (evt) => {
      onFocus == null ? void 0 : onFocus(evt);
    }
  }, children.map((choiceElement, choiceIndex) => /* @__PURE__ */ React86.createElement(Box47, {
    key: choiceElement.key,
    onClick: (evt) => handleSelect(evt, choiceIndex),
    onKeyUp: (evt) => {
      handleOnKeyUp(evt, choiceIndex);
    }
  }, /* @__PURE__ */ React86.createElement(NxSelectable, {
    disabled,
    height,
    hideCheckmark,
    option: choiceElement,
    padding,
    selected: computedSelectedValues.indexOf(choiceIndex) > -1,
    shouldUseOverlayColors,
    tabIndex,
    width
  }))));
});

// src/snackbar/NxSnackbar.tsx
import React87, { useState as useState17 } from "react";
import { Box as Box48, Snackbar, useTheme as useTheme35 } from "@material-ui/core";
import { Close as Close7 } from "@playvs-inc/nexus-icons";

// src/snackbar/NxSnackbar.styles.tsx
import { makeStyles as makeStyles62 } from "@material-ui/core";
var useStyles58 = makeStyles62((theme) => ({
  closeButton: {
    cursor: "pointer",
    marginRight: theme.spacing(1)
  },
  snackbar: {
    boxShadow: theme.mixins.boxShadow.elevation4,
    background: theme.palette.ColorBackgroundBase,
    borderRadius: theme.mixins.cornerRadius["border-radius-10"],
    padding: theme.spacing(2)
  }
}));

// src/snackbar/NxSnackbar.tsx
function NxSnackbar(_a) {
  var _b = _a, {
    variant,
    title,
    subtitle,
    action,
    canClose = true
  } = _b, props = __objRest(_b, [
    "variant",
    "title",
    "subtitle",
    "action",
    "canClose"
  ]);
  const classes = useStyles58();
  const theme = useTheme35();
  const [isClosed, setIsClosed] = useState17(false);
  const onClose = () => {
    setIsClosed(!isClosed);
  };
  const closeButton = canClose && /* @__PURE__ */ React87.createElement(Close7, {
    className: classes.closeButton,
    onClick: onClose
  });
  const icon = getIconFromVariant(variant, theme);
  return /* @__PURE__ */ React87.createElement(Snackbar, __spreadValues({
    action: /* @__PURE__ */ React87.createElement(React87.Fragment, null, action, closeButton),
    ContentProps: {
      className: classes.snackbar
    },
    message: /* @__PURE__ */ React87.createElement(Box48, {
      alignItems: "center",
      display: "flex",
      gridGap: theme.spacing(1)
    }, icon, /* @__PURE__ */ React87.createElement(NxTypography, {
      variant: "body2"
    }, title), subtitle && /* @__PURE__ */ React87.createElement(NxTypography, {
      variant: "body1"
    }, subtitle)),
    onClose,
    open: !isClosed
  }, props));
}

// src/tabs/NxTab.tsx
import React88 from "react";
import { makeStyles as makeStyles63, Tab } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
import clsx28 from "clsx";
var useStyles59 = makeStyles63((theme) => ({
  tab: ({ isSmall }) => ({
    color: theme.palette.ColorTextAlt2,
    minHeight: 36,
    minWidth: "max-content",
    textTransform: "capitalize",
    paddingBottom: isSmall ? theme.spacing(2) : theme.spacing(1.25),
    paddingRight: 0,
    paddingLeft: 0,
    marginRight: theme.spacing(2),
    opacity: 0.5,
    "&:hover": {
      opacity: "1 !important"
    },
    "&.Mui-selected": {
      opacity: void 0,
      color: theme.palette.ColorTextBase
    }
  })
}));
function NxTab(_a) {
  var _b = _a, {
    label,
    value,
    size = "small",
    className
  } = _b, props = __objRest(_b, [
    "label",
    "value",
    "size",
    "className"
  ]);
  const isSmall = size === "small";
  const classes = useStyles59({ isSmall });
  const tabLabel = typeof label === "string" ? /* @__PURE__ */ React88.createElement(NxTypography, {
    "data-cy": label,
    variant: size === "small" ? "button" : "h4"
  }, label) : label;
  return /* @__PURE__ */ React88.createElement(Tab, __spreadValues({
    className: clsx28(classes.tab, className),
    label: tabLabel,
    value
  }, props));
}

// src/tabs/NxTabs.tsx
import React89 from "react";
import { makeStyles as makeStyles64, Tabs } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
import clsx29 from "clsx";
var useStyles60 = makeStyles64((theme) => ({
  tabs: {
    minHeight: 36
  },
  indicator: {
    backgroundColor: theme.palette.ColorBackgroundAccent,
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0px 0px`,
    height: 4
  }
}));
function NxTabs(_a) {
  var _b = _a, {
    children,
    onChange,
    size = "small",
    className
  } = _b, props = __objRest(_b, [
    "children",
    "onChange",
    "size",
    "className"
  ]);
  const classes = useStyles60();
  return /* @__PURE__ */ React89.createElement(Tabs, __spreadValues({
    classes: { indicator: classes.indicator },
    className: clsx29(classes.tabs, className),
    onChange,
    variant: "scrollable"
  }, props), React89.Children.map(children, (child) => {
    if (React89.isValidElement(child)) {
      return React89.cloneElement(child, __spreadProps(__spreadValues({}, child.props), {
        size
      }));
    }
    return null;
  }));
}

// src/task-cards/NxTaskCard.tsx
import React90 from "react";
import { Box as Box49, makeStyles as makeStyles65 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
var useStyles61 = makeStyles65((theme) => ({
  subContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
  },
  body: {
    marginBottom: "auto"
  },
  cta: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1)
    }
  },
  container: {
    height: "269px",
    minWidth: "235px",
    maxWidth: "235px",
    padding: theme.spacing(2),
    marginRight: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 3,
    backgroundColor: theme.palette.background.paper,
    scrollSnapAlign: "start",
    boxShadow: theme.mixins.boxShadow.elevation1,
    [theme.breakpoints.down("xs")]: {
      height: "291px",
      minWidth: "252px",
      maxWidth: "252px",
      marginLeft: theme.spacing(2.5)
    }
  }
}));
function Header({
  children
}) {
  return /* @__PURE__ */ React90.createElement(Box49, {
    mb: 2
  }, children);
}
function Body({ children }) {
  return /* @__PURE__ */ React90.createElement(Box49, {
    mb: "auto"
  }, children);
}
function Cta({ children }) {
  return /* @__PURE__ */ React90.createElement(Box49, {
    mt: "auto"
  }, children);
}
var appendClasses = (...args) => args.filter((x) => !!x).join(" ");
function NxTaskCard({
  taskHeader,
  taskBody,
  taskCta
}) {
  const classes = useStyles61();
  return /* @__PURE__ */ React90.createElement(Box49, {
    className: appendClasses(classes.container, "TaskCard")
  }, /* @__PURE__ */ React90.createElement(Box49, {
    className: classes.subContainer
  }, /* @__PURE__ */ React90.createElement(Header, null, taskHeader), /* @__PURE__ */ React90.createElement(Body, null, taskBody), /* @__PURE__ */ React90.createElement(Cta, null, taskCta)));
}

// src/task-cards/NxTasksProgressBar.tsx
import React91 from "react";
import { Box as Box50, LinearProgress, makeStyles as makeStyles66 } from "@material-ui/core";
import "@playvs-inc/nexus-theme";
import { Firebob } from "@playvs-inc/nexus-icons";
var useStyles62 = makeStyles66((theme) => ({
  container: ({
    hasCompletedAllTask
  }) => ({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    justifyContent: "space-between",
    height: "269px",
    width: "249px",
    padding: theme.spacing(2),
    borderRadius: "12px",
    background: hasCompletedAllTask ? theme.palette.ColorBackgroundSuccess : "linear-gradient(180deg, #FF710A 0%, #FF530A 100%)",
    [theme.breakpoints.up("sm")]: {
      boxShadow: theme.mixins.boxShadow.elevation1
    },
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
      height: "476px",
      width: "calc(100vw - 32px)",
      padding: theme.spacing(2),
      borderRadius: "0px"
    }
  }),
  progressText: ({
    hasCompletedAllTask
  }) => ({
    zIndex: 2,
    color: hasCompletedAllTask ? theme.palette.ColorTextBase : theme.palette.common.white,
    lineHeight: "2.5rem",
    marginBottom: theme.spacing(3.5),
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.85rem",
      marginBottom: theme.spacing(2.5)
    }
  }),
  completionText: ({
    hasCompletedAllTask
  }) => ({
    color: hasCompletedAllTask ? theme.palette.ColorTextBase : theme.palette.common.white
  }),
  backgroundContainer: {
    position: "absolute",
    height: "191px",
    width: "193px",
    overflow: "hidden",
    borderTopRightRadius: "12px",
    transition: "width 0.5s, height 0.5s, opacity 0.5s 0.5s",
    top: 0,
    right: 0
  },
  fullBleedBackgroundContainer: ({
    hasCompletedAllTask
  }) => ({
    top: "0",
    left: "-16px",
    width: "calc(100vw)",
    height: "calc(476px)",
    zIndex: -2,
    position: "absolute",
    background: hasCompletedAllTask ? theme.palette.ColorBackgroundSuccess : "linear-gradient(180deg, #FF710A 0%, #FF530A 100%)",
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  }),
  backgroundIcon: ({
    hasCompletedAllTask
  }) => ({
    height: "316px",
    width: "316px",
    top: "-123px",
    position: "absolute",
    opacity: "0.80",
    zIndex: 1,
    color: hasCompletedAllTask ? theme.palette.ColorBackgroundSuccess : "#FF8100",
    transition: "height 0.25s linear"
  }),
  doneButton: {
    width: "100%",
    height: "36px",
    marginTop: theme.spacing(1.75),
    textTransform: "none",
    zIndex: 2
  }
}));
var useStylesBar = makeStyles66((theme) => ({
  root: {
    borderRadius: "10px",
    height: "0.83em",
    marginTop: theme.spacing(0.5),
    zIndex: 2
  },
  barColorPrimary: {
    backgroundColor: theme.palette.ColorBackgroundBase
  }
}));
function NxTasksProgressCard({
  progress,
  onDonePressed
}) {
  const currentProgress = progress.completed / progress.total * 100;
  const tasksCompleted = `${progress.completed} / ${progress.total} tasks complete`;
  const hasCompletedAllTask = currentProgress === 100;
  const progressBarText = hasCompletedAllTask ? `All done! Your school is ready to compete` : `Let's get your school competition ready`;
  const classes = useStyles62({ hasCompletedAllTask });
  const classesBar = useStylesBar();
  const handleCompleteUserTaskQueue = () => {
    onDonePressed();
  };
  return /* @__PURE__ */ React91.createElement(Box50, {
    className: classes.container
  }, /* @__PURE__ */ React91.createElement(Box50, {
    className: classes.fullBleedBackgroundContainer
  }), /* @__PURE__ */ React91.createElement(Box50, {
    className: classes.backgroundContainer
  }, /* @__PURE__ */ React91.createElement(Firebob, {
    className: classes.backgroundIcon
  })), /* @__PURE__ */ React91.createElement(NxTypography, {
    className: classes.progressText,
    variant: "h1"
  }, progressBarText), /* @__PURE__ */ React91.createElement(Box50, null, /* @__PURE__ */ React91.createElement(NxTypography, {
    className: classes.completionText,
    variant: "body2"
  }, tasksCompleted), hasCompletedAllTask ? /* @__PURE__ */ React91.createElement(NxButton, {
    className: classes.doneButton,
    label: "Done",
    onClick: handleCompleteUserTaskQueue,
    variant: "primary"
  }) : /* @__PURE__ */ React91.createElement(LinearProgress, {
    classes: classesBar,
    value: currentProgress,
    variant: "determinate"
  })));
}

// src/team-history-card/NxTeamHistoryCard.tsx
import React93 from "react";
import { Box as Box52, Card as Card4, makeStyles as makeStyles68, useTheme as useTheme37 } from "@material-ui/core";
import clsx30 from "clsx";
import { useEsport as useEsport9 } from "@playvs-inc/nexus-theme";

// src/team-history-card/TeamHistoryCard.helpers.tsx
import React92 from "react";
import { makeStyles as makeStyles67, useTheme as useTheme36 } from "@material-ui/core";
import {
  Hearthstone as Hearthstone2,
  Leagueoflegends as Leagueoflegends2,
  Madden2 as Madden22,
  Mariokart as Mariokart2,
  Nba2K as Nba2K2,
  Overwatch as Overwatch2,
  Valorant as Valorant2,
  Rocketleague as Rocketleague2,
  Smashbros as Smashbros2,
  Splatoon3 as Splatoon32,
  Fc as Fc2,
  CollegeFootball25
} from "@playvs-inc/nexus-icons";
var useStyles63 = makeStyles67((theme) => ({
  coverIcon: {
    height: 34,
    width: 34,
    color: theme.palette.common.white
  }
}));
var useGetCardProps2 = (esport) => {
  const theme = useTheme36();
  const classes = useStyles63();
  const map = {
    [EsportSlug.Hearthstone]: {
      backgroundColor: theme.palette.ColorEsportAccentHS5,
      Icon: /* @__PURE__ */ React92.createElement(Hearthstone2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.LeagueOfLegends]: {
      backgroundColor: theme.palette.ColorEsportAccentLoL6,
      Icon: /* @__PURE__ */ React92.createElement(Leagueoflegends2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.Madden]: {
      backgroundColor: theme.palette.ColorEsportAccentMadden4,
      Icon: /* @__PURE__ */ React92.createElement(Madden22, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.Madden21PS4]: {
      backgroundColor: theme.palette.ColorEsportAccentMadden4,
      Icon: /* @__PURE__ */ React92.createElement(Madden22, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.Madden21SolosXboxOne]: {
      backgroundColor: theme.palette.ColorEsportAccentMadden4,
      Icon: /* @__PURE__ */ React92.createElement(Madden22, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.Madden21XboxOne]: {
      backgroundColor: theme.palette.ColorEsportAccentMadden4,
      Icon: /* @__PURE__ */ React92.createElement(Madden22, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.MarioKart]: {
      backgroundColor: theme.palette.ColorEsportAccentMk4,
      Icon: /* @__PURE__ */ React92.createElement(Mariokart2, {
        className: `${classes.coverIcon}`
      })
    },
    [EsportSlug.NBA2K]: {
      backgroundColor: theme.palette.ColorEsportAccentNBA7,
      Icon: /* @__PURE__ */ React92.createElement(Nba2K2, {
        className: `${classes.coverIcon}`
      })
    },
    [EsportSlug.Overwatch]: {
      backgroundColor: theme.palette.ColorEsportAccentOW5,
      Icon: /* @__PURE__ */ React92.createElement(Overwatch2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.Valorant]: {
      backgroundColor: theme.palette.ColorEsportAccentNBA7,
      Icon: /* @__PURE__ */ React92.createElement(Valorant2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.RocketLeague]: {
      backgroundColor: theme.palette.ColorEsportAccentRL6,
      Icon: /* @__PURE__ */ React92.createElement(Rocketleague2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.RocketLeagueGMA]: {
      backgroundColor: theme.palette.ColorEsportAccentRL6,
      Icon: /* @__PURE__ */ React92.createElement(Rocketleague2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.Splatoon]: {
      backgroundColor: theme.palette.ColorEsportAccentSplatoon4,
      Icon: /* @__PURE__ */ React92.createElement(Splatoon32, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.SmashBrosUltimate]: {
      backgroundColor: theme.palette.ColorEsportAccentSU5,
      Icon: /* @__PURE__ */ React92.createElement(Smashbros2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.FC]: {
      backgroundColor: theme.palette.ColorEsportAccentFC6,
      Icon: /* @__PURE__ */ React92.createElement(Fc2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.ARAM]: {
      backgroundColor: theme.palette.ColorEsportAccentLoL6,
      Icon: /* @__PURE__ */ React92.createElement(Leagueoflegends2, {
        className: classes.coverIcon
      })
    },
    [EsportSlug.CollegeFootball25]: {
      backgroundColor: theme.palette.ColorEsportAccentCFB256,
      Icon: /* @__PURE__ */ React92.createElement(CollegeFootball25, {
        className: classes.coverIcon
      })
    }
  };
  const defaultMap = {
    backgroundColor: theme.palette.ColorBackgroundInvert,
    Icon: /* @__PURE__ */ React92.createElement(NxEsportIcon, {
      esportSlug: esport,
      height: 34,
      width: 34
    })
  };
  return map[esport] || defaultMap;
};

// src/team-history-card/NxTeamHistoryCard.tsx
var useStyles64 = makeStyles68((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius * 2.5,
    boxShadow: theme.mixins.boxShadow.elevation1,
    display: "flex",
    flexDirection: "column",
    width: 260,
    height: 314
  },
  cover: ({
    backgroundColor
  }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 3, 1),
    backgroundColor,
    position: "relative",
    height: 120
  }),
  coverText: {
    color: theme.palette.OverlayColorTextBase
  },
  bottomContainer: {
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    height: 194
  },
  seasonLeagueContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(3)
  },
  recordContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "auto"
  },
  winLossesContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(1)
  },
  seasonLeagueText: {
    color: theme.palette.ColorTextAlt2,
    textTransform: "uppercase",
    marginBottom: theme.spacing(1)
  },
  winsContainer: {
    boxShadow: theme.mixins.divider.right,
    paddingRight: theme.spacing(4)
  },
  lossesContainer: {
    paddingLeft: theme.spacing(2)
  },
  enrollmentPill: {
    height: "22px",
    marginLeft: theme.spacing(1)
  },
  enrollmentButton: {
    height: "36px"
  }
}));
function NxTeamHistoryRecord({
  teamHistoryRecord,
  className,
  showEnrollment,
  callOutComponent,
  daysLeftToEnroll,
  onEnroll
}) {
  var _a, _b;
  const theme = useTheme37();
  const { esportSlug } = teamHistoryRecord;
  const esport = useEsport9(esportSlug);
  const { backgroundColor } = useGetCardProps2(esportSlug);
  const classes = useStyles64({
    backgroundColor: ((_a = esport == null ? void 0 : esport.palette) == null ? void 0 : _a.baseColor) || backgroundColor || theme.palette.common.white
  });
  const hasDaysLeftToEnroll = daysLeftToEnroll && daysLeftToEnroll > 0;
  const isEnrolled = teamHistoryRecord == null ? void 0 : teamHistoryRecord.isEnrolled;
  const enrollmentText = hasDaysLeftToEnroll ? `${daysLeftToEnroll} Days left to enroll` : "Not Enrolled";
  const { leagueName } = teamHistoryRecord;
  const getOrdinal = (n) => {
    let suffix = "th";
    if (n % 10 === 1 && n % 100 !== 11) {
      suffix = "st";
    } else if (n % 10 === 2 && n % 100 !== 12) {
      suffix = "nd";
    } else if (n % 10 === 3 && n % 100 !== 13) {
      suffix = "rd";
    }
    return `${n}${suffix}`;
  };
  const enrollmentColorToken = hasDaysLeftToEnroll ? "ColorTextWarn" : "ColorTextDisabled";
  const enrolledText = isEnrolled ? leagueName : enrollmentText;
  const enrolledPillText = (teamHistoryRecord == null ? void 0 : teamHistoryRecord.rank) ? `${getOrdinal(teamHistoryRecord == null ? void 0 : teamHistoryRecord.rank)} Place` : "Enrolled";
  return /* @__PURE__ */ React93.createElement(Card4, {
    className: clsx30(classes.root, className)
  }, /* @__PURE__ */ React93.createElement("div", {
    className: classes.cover
  }, /* @__PURE__ */ React93.createElement(Box52, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: 30,
    mb: 1
  }, /* @__PURE__ */ React93.createElement(NxEsportIcon, {
    esportSlug,
    height: 34,
    mode: "dark",
    width: 34
  }), showEnrollment && /* @__PURE__ */ React93.createElement(Pill, {
    className: classes.enrollmentPill,
    label: isEnrolled ? enrolledPillText : "Not Enrolled",
    size: "small",
    variant: isEnrolled ? "success" : "warn"
  })), typeof teamHistoryRecord.teamName === "string" ? /* @__PURE__ */ React93.createElement(NxTypography, {
    className: classes.coverText,
    variant: "h4"
  }, teamHistoryRecord.teamName) : teamHistoryRecord.teamName), /* @__PURE__ */ React93.createElement(Box52, {
    className: classes.bottomContainer
  }, /* @__PURE__ */ React93.createElement(Box52, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React93.createElement(Box52, {
    className: classes.seasonLeagueContainer
  }, /* @__PURE__ */ React93.createElement(NxTypography, {
    className: classes.seasonLeagueText,
    variant: "overline"
  }, teamHistoryRecord.seasonName, " League"), /* @__PURE__ */ React93.createElement(NxTypography, {
    colorToken: isEnrolled || !showEnrollment ? "ColorTextBase" : enrollmentColorToken,
    variant: "body4"
  }, showEnrollment ? enrolledText : leagueName)), showEnrollment && !isEnrolled && !!hasDaysLeftToEnroll && /* @__PURE__ */ React93.createElement(NxButton, {
    className: classes.enrollmentButton,
    label: "Enroll",
    onClick: onEnroll,
    variant: "secondary"
  })), /* @__PURE__ */ React93.createElement(Box52, {
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */ React93.createElement(Box52, {
    className: classes.recordContainer
  }, /* @__PURE__ */ React93.createElement(Box52, null, /* @__PURE__ */ React93.createElement(NxTypography, {
    className: classes.seasonLeagueText,
    variant: "overline"
  }, `${(_b = teamHistoryRecord.recordSeasonName) != null ? _b : teamHistoryRecord.seasonName} Record`)), /* @__PURE__ */ React93.createElement(Box52, {
    className: classes.winLossesContainer
  }, /* @__PURE__ */ React93.createElement(Box52, {
    className: classes.winsContainer
  }, /* @__PURE__ */ React93.createElement(NxTypography, {
    variant: "body2"
  }, teamHistoryRecord.wins), /* @__PURE__ */ React93.createElement(NxTypography, {
    colorToken: "ColorTextDisabled",
    variant: "body4"
  }, "Wins")), /* @__PURE__ */ React93.createElement(Box52, {
    className: classes.lossesContainer
  }, /* @__PURE__ */ React93.createElement(NxTypography, {
    variant: "body2"
  }, teamHistoryRecord.losses), /* @__PURE__ */ React93.createElement(NxTypography, {
    colorToken: "ColorTextDisabled",
    variant: "body4"
  }, "Losses")))), callOutComponent != null ? callOutComponent : null)));
}

// src/toggle/NxToggle.tsx
import React94 from "react";
import { Box as Box53, makeStyles as makeStyles69, useTheme as useTheme38 } from "@material-ui/core";
import { Smallcheck as Smallcheck2, Smallclose } from "@playvs-inc/nexus-icons";
import clsx31 from "clsx";
var useStyles65 = makeStyles69((theme) => ({
  toggle: {
    width: 35,
    height: 20,
    borderRadius: theme.spacing(2),
    border: `2px solid ${theme.palette.BorderDark}`,
    background: theme.palette.ColorBackgroundBase,
    padding: theme.spacing(0.25)
  },
  toggleActive: {
    background: theme.palette.ColorIconBase
  },
  thumb: {
    height: 12,
    width: 12,
    borderRadius: theme.mixins.cornerRadius["border-radius-1000"],
    background: theme.palette.ColorIconBase,
    transition: "transform 0.2s, color 0.2s"
  },
  thumbActive: {
    transform: "translate(calc(100% + 2px))",
    background: theme.palette.ColorBackgroundBase
  },
  activeIcon: {
    position: "absolute",
    left: -2
  },
  inactiveIcon: {
    position: "absolute",
    right: -2
  },
  hidden: {
    display: "none"
  },
  label: {
    display: "flex",
    gridGap: theme.spacing(1),
    alignItems: "center"
  }
}));
function NxToggle({
  label,
  name,
  checked = false,
  onChange
}) {
  const [isChecked, setIsChecked] = React94.useState(checked);
  const theme = useTheme38();
  const styles = useStyles65();
  const handleChange = () => {
    setIsChecked(!isChecked);
    onChange == null ? void 0 : onChange(isChecked);
  };
  return /* @__PURE__ */ React94.createElement("label", {
    className: styles.label,
    htmlFor: name
  }, /* @__PURE__ */ React94.createElement("input", {
    checked: isChecked,
    className: styles.hidden,
    id: name,
    name,
    onChange: handleChange,
    type: "checkbox"
  }), /* @__PURE__ */ React94.createElement(Box53, {
    alignItems: "center",
    className: clsx31(styles.toggle, isChecked && styles.toggleActive),
    display: "flex",
    position: "relative"
  }, /* @__PURE__ */ React94.createElement(Box53, {
    className: clsx31(styles.thumb, isChecked && styles.thumbActive),
    zIndex: 10
  }), /* @__PURE__ */ React94.createElement(Smallcheck2, {
    className: styles.activeIcon,
    color: theme.palette.ColorBackgroundBase
  }), /* @__PURE__ */ React94.createElement(Smallclose, {
    className: styles.inactiveIcon,
    color: theme.palette.ColorIconBase
  })), label && /* @__PURE__ */ React94.createElement(NxTypography, {
    colorToken: "ColorTextAlt",
    variant: "body1"
  }, label));
}

// src/widget/NxWidget.tsx
import React95 from "react";
import { Box as Box54 } from "@material-ui/core";

// src/widget/Widget.styles.ts
import { makeStyles as makeStyles70 } from "@material-ui/core";
var useStyles66 = makeStyles70((theme) => ({
  card: {
    backgroundColor: theme.palette.ColorBackgroundBase,
    borderRadius: theme.shape.borderRadius * 2.5,
    boxShadow: theme.mixins.boxShadow.elevation2,
    display: "flex",
    flexDirection: "column",
    minHeight: 188,
    maxHeight: 288
  },
  titleContainer: {
    flex: "0 0 auto",
    padding: theme.spacing(3, 3, 2, 3)
  },
  title: {
    color: theme.palette.ColorTextBase
  },
  subtitle: {
    color: theme.palette.ColorTextAlt2,
    marginTop: theme.spacing(0.5)
  },
  body: {
    flex: "1 1 auto",
    padding: theme.spacing(0, 3),
    overflowY: "auto"
  },
  cta: {
    color: theme.palette.ColorTextBase,
    marginBottom: theme.spacing(1)
  },
  actions: {
    flex: "0 0 auto",
    padding: theme.spacing(2, 3, 3, 3)
  }
}));

// src/widget/NxWidget.tsx
function NxWidget(_a) {
  var _b = _a, {
    actions,
    children,
    subtitle,
    title,
    width = 300
  } = _b, rest = __objRest(_b, [
    "actions",
    "children",
    "subtitle",
    "title",
    "width"
  ]);
  const classes = useStyles66();
  return /* @__PURE__ */ React95.createElement(Box54, __spreadProps(__spreadValues({
    className: classes.card
  }, rest), {
    width
  }), /* @__PURE__ */ React95.createElement("div", {
    className: classes.titleContainer
  }, /* @__PURE__ */ React95.createElement(NxTypography, {
    className: classes.title,
    variant: "h4"
  }, title), subtitle && /* @__PURE__ */ React95.createElement(NxTypography, {
    className: classes.subtitle,
    variant: "body3"
  }, subtitle)), /* @__PURE__ */ React95.createElement("div", {
    className: classes.body
  }, children), /* @__PURE__ */ React95.createElement("div", {
    className: classes.actions
  }, actions));
}
export {
  CompetitorCell,
  DraftjsEmote,
  EmoteSize,
  EnrollmentLoadingSpinner,
  EsportSlug,
  EventAction,
  FB,
  GameResultsCell,
  HeaderCell2 as HeaderCell,
  LoadingSpinner,
  MAX_LARGE_EMOTES,
  Mode,
  NxActionSpotModal,
  NxAlert,
  NxAvatar,
  NxAvatarGroup,
  NxBreadcrumbs,
  NxButton,
  NxCardPaginationButtons,
  NxCheckbox,
  NxComboButton,
  NxContactCluster,
  NxDropdownButton,
  NxEmbedVideoModal,
  NxEmote,
  NxEmptyState,
  NxEnrolledLeagueCard,
  NxErrorState,
  NxEsportAvatar,
  NxEsportBanner,
  NxEsportCard,
  NxEsportIcon,
  NxEsportMultiSelectable,
  NxEsportSelectable,
  NxEventCard,
  NxFirebobMessage,
  NxHeaderCard,
  NxIconAvatar,
  NxIconButton,
  NxLeagueCard,
  NxLightbox,
  NxLiveIndicator,
  NxMatchDetailsCluster,
  NxModal,
  NxPlayVsBanner,
  NxRadioBase,
  NxRadioButtonGroup,
  NxRating,
  NxScoreBoardTable,
  NxScoreReviewCard,
  NxScoreboard,
  NxScoreboardRows,
  NxSearchBox,
  NxSeasonalAwardsTable,
  NxSelect,
  NxSelectOption,
  NxSelectableMulti,
  NxSelectableSingle,
  NxSkeletonLoader,
  NxSnackbar,
  NxSpotModal,
  NxTab,
  NxTabs,
  NxTaskCard,
  NxTasksProgressCard,
  NxTeamHistoryRecord,
  NxTextArea,
  NxTextInput,
  NxTextLink,
  NxTextLinkExternal,
  NxToggle,
  NxTooltip,
  NxTypography,
  NxUserCluster,
  NxUserOnlineStatus,
  NxWeeklyAwardAchievementCard,
  NxWidget,
  OnlineStatus,
  OverlayPill,
  PersonaImageVariant,
  Pill,
  PlayVsImageVariant,
  StaticColumns,
  VSCell,
  addEmoji,
  composeEsportGradient,
  composePersonaGradient,
  createEmotePlugin,
  emoteToToken,
  emotesMap,
  esportLogoMap,
  esportTokenSlugMap,
  fcPersona,
  getEmoteSize,
  getEsportBanner,
  getEsportColorValue,
  getEsportPaletteKey,
  getPersonaImageVariantByPath,
  getSearchText,
  getWordAt,
  hearthstonePersona,
  leaguePersona,
  maddenPersona,
  marioKartPersona,
  nameToEmote,
  nbaPersona,
  otherMap,
  overwatchPersona,
  parseMessage,
  personaImagesMap,
  playVsPersona,
  rocketLeaguePersona,
  shouldRenderLargeEmotes,
  slugToToken,
  smashBrosPersona,
  splatoonPersona,
  useGetEnrolledLeagueCardHelpers,
  useGetEsportsProps2 as useGetEsportsProps,
  valorantPersona,
  variantSlugMap,
  variantToToken
};
//# sourceMappingURL=index.js.map